// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/apis.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import type { ApiErrorResponse, CreateDockerWorkerRegistryEntryRequest, CreateEntityResponse, DockerAuthorizationRequest, DockerAuthorizationResponse, DockerLicenseInformation, DockerRunArtifactCreateRequest, DockerRunArtifactCreatedData, DockerRunCreateRequest, DockerRunData, DockerRunLogCreateEntriesRequest, DockerRunLogData, DockerRunScheduledCreateRequest, DockerRunScheduledData, DockerRunScheduledState, DockerRunScheduledUpdateRequest, DockerRunUpdateRequest, DockerUserStats, DockerWorkerAuthorizationRequest, DockerWorkerConfigCreateRequest, DockerWorkerConfigOmniVXCreateRequest, DockerWorkerConfigV0Data, DockerWorkerConfigV2CreateRequest, DockerWorkerConfigV2Data, DockerWorkerConfigV3CreateRequest, DockerWorkerConfigV3Data, DockerWorkerConfigVXData, DockerWorkerRegistryEntryData, TagData, UpdateDockerWorkerRegistryEntryRequest, } from '../models';
import { ApiErrorResponseFromJSON, ApiErrorResponseToJSON, ApiErrorResponseValidator, CreateDockerWorkerRegistryEntryRequestFromJSON, CreateDockerWorkerRegistryEntryRequestToJSON, CreateDockerWorkerRegistryEntryRequestValidator, CreateEntityResponseFromJSON, CreateEntityResponseToJSON, CreateEntityResponseValidator, DockerAuthorizationRequestFromJSON, DockerAuthorizationRequestToJSON, DockerAuthorizationRequestValidator, DockerAuthorizationResponseFromJSON, DockerAuthorizationResponseToJSON, DockerAuthorizationResponseValidator, DockerLicenseInformationFromJSON, DockerLicenseInformationToJSON, DockerLicenseInformationValidator, DockerRunArtifactCreateRequestFromJSON, DockerRunArtifactCreateRequestToJSON, DockerRunArtifactCreateRequestValidator, DockerRunArtifactCreatedDataFromJSON, DockerRunArtifactCreatedDataToJSON, DockerRunArtifactCreatedDataValidator, DockerRunCreateRequestFromJSON, DockerRunCreateRequestToJSON, DockerRunCreateRequestValidator, DockerRunDataFromJSON, DockerRunDataToJSON, DockerRunDataValidator, DockerRunLogCreateEntriesRequestFromJSON, DockerRunLogCreateEntriesRequestToJSON, DockerRunLogCreateEntriesRequestValidator, DockerRunLogDataFromJSON, DockerRunLogDataToJSON, DockerRunLogDataValidator, DockerRunScheduledCreateRequestFromJSON, DockerRunScheduledCreateRequestToJSON, DockerRunScheduledCreateRequestValidator, DockerRunScheduledDataFromJSON, DockerRunScheduledDataToJSON, DockerRunScheduledDataValidator, DockerRunScheduledStateFromJSON, DockerRunScheduledStateToJSON, DockerRunScheduledStateValidator, DockerRunScheduledUpdateRequestFromJSON, DockerRunScheduledUpdateRequestToJSON, DockerRunScheduledUpdateRequestValidator, DockerRunUpdateRequestFromJSON, DockerRunUpdateRequestToJSON, DockerRunUpdateRequestValidator, DockerUserStatsFromJSON, DockerUserStatsToJSON, DockerUserStatsValidator, DockerWorkerAuthorizationRequestFromJSON, DockerWorkerAuthorizationRequestToJSON, DockerWorkerAuthorizationRequestValidator, DockerWorkerConfigCreateRequestFromJSON, DockerWorkerConfigCreateRequestToJSON, DockerWorkerConfigCreateRequestValidator, DockerWorkerConfigOmniVXCreateRequestFromJSON, DockerWorkerConfigOmniVXCreateRequestToJSON, DockerWorkerConfigOmniVXCreateRequestValidator, DockerWorkerConfigV0DataFromJSON, DockerWorkerConfigV0DataToJSON, DockerWorkerConfigV0DataValidator, DockerWorkerConfigV2CreateRequestFromJSON, DockerWorkerConfigV2CreateRequestToJSON, DockerWorkerConfigV2CreateRequestValidator, DockerWorkerConfigV2DataFromJSON, DockerWorkerConfigV2DataToJSON, DockerWorkerConfigV2DataValidator, DockerWorkerConfigV3CreateRequestFromJSON, DockerWorkerConfigV3CreateRequestToJSON, DockerWorkerConfigV3CreateRequestValidator, DockerWorkerConfigV3DataFromJSON, DockerWorkerConfigV3DataToJSON, DockerWorkerConfigV3DataValidator, DockerWorkerConfigVXDataFromJSON, DockerWorkerConfigVXDataToJSON, DockerWorkerConfigVXDataValidator, DockerWorkerRegistryEntryDataFromJSON, DockerWorkerRegistryEntryDataToJSON, DockerWorkerRegistryEntryDataValidator, TagDataFromJSON, TagDataToJSON, TagDataValidator, UpdateDockerWorkerRegistryEntryRequestFromJSON, UpdateDockerWorkerRegistryEntryRequestToJSON, UpdateDockerWorkerRegistryEntryRequestValidator, } from '../models';
import * as models from '../models';
/* LIGHTLY CUSTOM START -> -> moved from bottom to top:  apiMustache */
/* LIGHTLY CUSTOM END -> moved from bottom to top: apiMustache */
export interface CancelScheduledDockerRunStateByIdRequest {
    datasetId: string;
    scheduledId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const CancelScheduledDockerRunStateByIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CancelScheduledDockerRunStateByIdRequestValidator = yup.object().shape(CancelScheduledDockerRunStateByIdRequestValidatorShape);
export interface ConfirmDockerRunArtifactCreationRequest {
    runId: string;
    artifactId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const ConfirmDockerRunArtifactCreationRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'artifactId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const ConfirmDockerRunArtifactCreationRequestValidator = yup.object().shape(ConfirmDockerRunArtifactCreationRequestValidatorShape);
export interface CreateDockerRunRequest {
    dockerRunCreateRequest: models.DockerRunCreateRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerRunRequestValidatorShape = {
    'dockerRunCreateRequest': models.DockerRunCreateRequestValidator.defined(),
};
export const CreateDockerRunRequestValidator = yup.object().shape(CreateDockerRunRequestValidatorShape);
export interface CreateDockerRunArtifactRequest {
    dockerRunArtifactCreateRequest: models.DockerRunArtifactCreateRequest;
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerRunArtifactRequestValidatorShape = {
    'dockerRunArtifactCreateRequest': models.DockerRunArtifactCreateRequestValidator.defined(),
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CreateDockerRunArtifactRequestValidator = yup.object().shape(CreateDockerRunArtifactRequestValidatorShape);
export interface CreateDockerRunLogByIdRequest {
    dockerRunLogCreateEntriesRequest: models.DockerRunLogCreateEntriesRequest;
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerRunLogByIdRequestValidatorShape = {
    'dockerRunLogCreateEntriesRequest': models.DockerRunLogCreateEntriesRequestValidator.defined(),
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CreateDockerRunLogByIdRequestValidator = yup.object().shape(CreateDockerRunLogByIdRequestValidatorShape);
export interface CreateDockerRunScheduledByDatasetIdRequest {
    dockerRunScheduledCreateRequest: models.DockerRunScheduledCreateRequest;
    datasetId: string;
    disableConfigValidation?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerRunScheduledByDatasetIdRequestValidatorShape = {
    'dockerRunScheduledCreateRequest': models.DockerRunScheduledCreateRequestValidator.defined(),
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'disableConfigValidation': yup.boolean(),
};
export const CreateDockerRunScheduledByDatasetIdRequestValidator = yup.object().shape(CreateDockerRunScheduledByDatasetIdRequestValidatorShape);
export interface CreateDockerWorkerConfigRequest {
    dockerWorkerConfigCreateRequest: models.DockerWorkerConfigCreateRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerWorkerConfigRequestValidatorShape = {
    'dockerWorkerConfigCreateRequest': models.DockerWorkerConfigCreateRequestValidator.defined(),
};
export const CreateDockerWorkerConfigRequestValidator = yup.object().shape(CreateDockerWorkerConfigRequestValidatorShape);
export interface CreateDockerWorkerConfigV2Request {
    dockerWorkerConfigV2CreateRequest: models.DockerWorkerConfigV2CreateRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerWorkerConfigV2RequestValidatorShape = {
    'dockerWorkerConfigV2CreateRequest': models.DockerWorkerConfigV2CreateRequestValidator.defined(),
};
export const CreateDockerWorkerConfigV2RequestValidator = yup.object().shape(CreateDockerWorkerConfigV2RequestValidatorShape);
export interface CreateDockerWorkerConfigV3Request {
    dockerWorkerConfigV3CreateRequest: models.DockerWorkerConfigV3CreateRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerWorkerConfigV3RequestValidatorShape = {
    'dockerWorkerConfigV3CreateRequest': models.DockerWorkerConfigV3CreateRequestValidator.defined(),
};
export const CreateDockerWorkerConfigV3RequestValidator = yup.object().shape(CreateDockerWorkerConfigV3RequestValidatorShape);
export interface CreateDockerWorkerConfigVXRequest {
    dockerWorkerConfigOmniVXCreateRequest: models.DockerWorkerConfigOmniVXCreateRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const CreateDockerWorkerConfigVXRequestValidatorShape = {
    'dockerWorkerConfigOmniVXCreateRequest': models.DockerWorkerConfigOmniVXCreateRequestValidator,
};
export const CreateDockerWorkerConfigVXRequestValidator = yup.object().shape(CreateDockerWorkerConfigVXRequestValidatorShape);
export interface DeleteDockerWorkerRegistryEntryByIdRequest {
    workerId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const DeleteDockerWorkerRegistryEntryByIdRequestValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const DeleteDockerWorkerRegistryEntryByIdRequestValidator = yup.object().shape(DeleteDockerWorkerRegistryEntryByIdRequestValidatorShape);
export interface GetDockerRunArtifactReadUrlByIdRequest {
    runId: string;
    artifactId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunArtifactReadUrlByIdRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'artifactId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunArtifactReadUrlByIdRequestValidator = yup.object().shape(GetDockerRunArtifactReadUrlByIdRequestValidatorShape);
export interface GetDockerRunByIdRequest {
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunByIdRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunByIdRequestValidator = yup.object().shape(GetDockerRunByIdRequestValidatorShape);
export interface GetDockerRunByScheduledIdRequest {
    scheduledId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunByScheduledIdRequestValidatorShape = {
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunByScheduledIdRequestValidator = yup.object().shape(GetDockerRunByScheduledIdRequestValidatorShape);
export interface GetDockerRunLogsByIdRequest {
    runId: string;
    cursor?: number;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunLogsByIdRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'cursor': yup.number().integer().min(0),
};
export const GetDockerRunLogsByIdRequestValidator = yup.object().shape(GetDockerRunLogsByIdRequestValidatorShape);
export interface GetDockerRunReportReadUrlByIdRequest {
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunReportReadUrlByIdRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunReportReadUrlByIdRequestValidator = yup.object().shape(GetDockerRunReportReadUrlByIdRequestValidatorShape);
export interface GetDockerRunReportWriteUrlByIdRequest {
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunReportWriteUrlByIdRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunReportWriteUrlByIdRequestValidator = yup.object().shape(GetDockerRunReportWriteUrlByIdRequestValidatorShape);
export interface GetDockerRunTagsRequest {
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunTagsRequestValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunTagsRequestValidator = yup.object().shape(GetDockerRunTagsRequestValidatorShape);
export interface GetDockerRunsRequest {
    pageSize?: number;
    pageOffset?: number;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
    showArchived?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunsRequestValidatorShape = {
    'pageSize': yup.number().min(1),
    'pageOffset': yup.number().min(0),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
    'showArchived': yup.boolean(),
};
export const GetDockerRunsRequestValidator = yup.object().shape(GetDockerRunsRequestValidatorShape);
export interface GetDockerRunsCountRequest {
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
    showArchived?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunsCountRequestValidatorShape = {
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
    'showArchived': yup.boolean(),
};
export const GetDockerRunsCountRequestValidator = yup.object().shape(GetDockerRunsCountRequestValidatorShape);
export interface GetDockerRunsQueryByDatasetIdRequest {
    datasetId: string;
    pageSize?: number;
    pageOffset?: number;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunsQueryByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'pageSize': yup.number().min(1),
    'pageOffset': yup.number().min(0),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerRunsQueryByDatasetIdRequestValidator = yup.object().shape(GetDockerRunsQueryByDatasetIdRequestValidatorShape);
export interface GetDockerRunsScheduledByDatasetIdRequest {
    datasetId: string;
    state?: models.DockerRunScheduledState;
    states?: models.DockerRunScheduledStateArray;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunsScheduledByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'state': models.DockerRunScheduledStateValidator.optional().default(undefined),
    'states': models.DockerRunScheduledStateArrayValidator.optional().default(undefined),
};
export const GetDockerRunsScheduledByDatasetIdRequestValidator = yup.object().shape(GetDockerRunsScheduledByDatasetIdRequestValidatorShape);
export interface GetDockerRunsScheduledByStateAndLabelsRequest {
    state?: models.DockerRunScheduledState;
    labels?: models.DockerWorkerLabels;
    version?: string;
    includeUnlockableRuns?: boolean;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunsScheduledByStateAndLabelsRequestValidatorShape = {
    'state': models.DockerRunScheduledStateValidator.optional().default(undefined),
    'labels': models.DockerWorkerLabelsValidator.optional().default(undefined),
    'version': yup.string(),
    'includeUnlockableRuns': yup.boolean(),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerRunsScheduledByStateAndLabelsRequestValidator = yup.object().shape(GetDockerRunsScheduledByStateAndLabelsRequestValidatorShape);
export interface GetDockerRunsScheduledByWorkerIdRequest {
    workerId: string;
    state?: models.DockerRunScheduledState;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerRunsScheduledByWorkerIdRequestValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'state': models.DockerRunScheduledStateValidator.optional().default(undefined),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerRunsScheduledByWorkerIdRequestValidator = yup.object().shape(GetDockerRunsScheduledByWorkerIdRequestValidatorShape);
export interface GetDockerWorkerConfigByIdRequest {
    configId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerWorkerConfigByIdRequestValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigByIdRequestValidator = yup.object().shape(GetDockerWorkerConfigByIdRequestValidatorShape);
export interface GetDockerWorkerConfigV2ByIdRequest {
    configId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerWorkerConfigV2ByIdRequestValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigV2ByIdRequestValidator = yup.object().shape(GetDockerWorkerConfigV2ByIdRequestValidatorShape);
export interface GetDockerWorkerConfigV3ByIdRequest {
    configId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerWorkerConfigV3ByIdRequestValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigV3ByIdRequestValidator = yup.object().shape(GetDockerWorkerConfigV3ByIdRequestValidatorShape);
export interface GetDockerWorkerConfigVXByIdRequest {
    configId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerWorkerConfigVXByIdRequestValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigVXByIdRequestValidator = yup.object().shape(GetDockerWorkerConfigVXByIdRequestValidatorShape);
export interface GetDockerWorkerRegistryEntriesRequest {
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerWorkerRegistryEntriesRequestValidatorShape = {
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerWorkerRegistryEntriesRequestValidator = yup.object().shape(GetDockerWorkerRegistryEntriesRequestValidatorShape);
export interface GetDockerWorkerRegistryEntryByIdRequest {
    workerId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDockerWorkerRegistryEntryByIdRequestValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerRegistryEntryByIdRequestValidator = yup.object().shape(GetDockerWorkerRegistryEntryByIdRequestValidatorShape);
export interface PostDockerAuthorizationRequestRequest {
    dockerAuthorizationRequest: models.DockerAuthorizationRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const PostDockerAuthorizationRequestRequestValidatorShape = {
    'dockerAuthorizationRequest': models.DockerAuthorizationRequestValidator.defined(),
};
export const PostDockerAuthorizationRequestRequestValidator = yup.object().shape(PostDockerAuthorizationRequestRequestValidatorShape);
export interface PostDockerUsageStatsRequest {
    dockerUserStats: models.DockerUserStats;
}
/* LIGHTLY CUSTOM START -> apis */
export const PostDockerUsageStatsRequestValidatorShape = {
    'dockerUserStats': models.DockerUserStatsValidator.defined(),
};
export const PostDockerUsageStatsRequestValidator = yup.object().shape(PostDockerUsageStatsRequestValidatorShape);
export interface PostDockerWorkerAuthorizationRequestRequest {
    dockerWorkerAuthorizationRequest: models.DockerWorkerAuthorizationRequest;
}
/* LIGHTLY CUSTOM START -> apis */
export const PostDockerWorkerAuthorizationRequestRequestValidatorShape = {
    'dockerWorkerAuthorizationRequest': models.DockerWorkerAuthorizationRequestValidator.defined(),
};
export const PostDockerWorkerAuthorizationRequestRequestValidator = yup.object().shape(PostDockerWorkerAuthorizationRequestRequestValidatorShape);
export interface RegisterDockerWorkerRequest {
    createDockerWorkerRegistryEntryRequest: models.CreateDockerWorkerRegistryEntryRequest;
    forUserId?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const RegisterDockerWorkerRequestValidatorShape = {
    'createDockerWorkerRegistryEntryRequest': models.CreateDockerWorkerRegistryEntryRequestValidator.defined(),
    'forUserId': yup.string(),
};
export const RegisterDockerWorkerRequestValidator = yup.object().shape(RegisterDockerWorkerRequestValidatorShape);
export interface UpdateDockerRunByIdRequest {
    dockerRunUpdateRequest: models.DockerRunUpdateRequest;
    runId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const UpdateDockerRunByIdRequestValidatorShape = {
    'dockerRunUpdateRequest': models.DockerRunUpdateRequestValidator.defined(),
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDockerRunByIdRequestValidator = yup.object().shape(UpdateDockerRunByIdRequestValidatorShape);
export interface UpdateDockerWorkerConfigByIdRequest {
    dockerWorkerConfigCreateRequest: models.DockerWorkerConfigCreateRequest;
    configId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const UpdateDockerWorkerConfigByIdRequestValidatorShape = {
    'dockerWorkerConfigCreateRequest': models.DockerWorkerConfigCreateRequestValidator.defined(),
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDockerWorkerConfigByIdRequestValidator = yup.object().shape(UpdateDockerWorkerConfigByIdRequestValidatorShape);
export interface UpdateDockerWorkerRegistryEntryByIdRequest {
    updateDockerWorkerRegistryEntryRequest: models.UpdateDockerWorkerRegistryEntryRequest;
    workerId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const UpdateDockerWorkerRegistryEntryByIdRequestValidatorShape = {
    'updateDockerWorkerRegistryEntryRequest': models.UpdateDockerWorkerRegistryEntryRequestValidator.defined(),
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDockerWorkerRegistryEntryByIdRequestValidator = yup.object().shape(UpdateDockerWorkerRegistryEntryByIdRequestValidatorShape);
export interface UpdateScheduledDockerRunStateByIdRequest {
    dockerRunScheduledUpdateRequest: models.DockerRunScheduledUpdateRequest;
    datasetId: string;
    workerId: string;
    scheduledId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const UpdateScheduledDockerRunStateByIdRequestValidatorShape = {
    'dockerRunScheduledUpdateRequest': models.DockerRunScheduledUpdateRequestValidator.defined(),
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateScheduledDockerRunStateByIdRequestValidator = yup.object().shape(UpdateScheduledDockerRunStateByIdRequestValidatorShape);
export interface CancelScheduledDockerRunStateByIdRequestParams {
    datasetId: string;
    scheduledId: string;
}
export function CancelScheduledDockerRunStateByIdRequestParamsSanitizer(json: any): CancelScheduledDockerRunStateByIdRequestParams {
    return {
        'datasetId': json['datasetId'],
        'scheduledId': json['scheduledId'],
    };
}
export const CancelScheduledDockerRunStateByIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CancelScheduledDockerRunStateByIdRequestParamsValidator = yup.object().shape(CancelScheduledDockerRunStateByIdRequestParamsValidatorShape);
export interface ConfirmDockerRunArtifactCreationRequestParams {
    runId: string;
    artifactId: string;
}
export function ConfirmDockerRunArtifactCreationRequestParamsSanitizer(json: any): ConfirmDockerRunArtifactCreationRequestParams {
    return {
        'runId': json['runId'],
        'artifactId': json['artifactId'],
    };
}
export const ConfirmDockerRunArtifactCreationRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'artifactId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const ConfirmDockerRunArtifactCreationRequestParamsValidator = yup.object().shape(ConfirmDockerRunArtifactCreationRequestParamsValidatorShape);
export interface CreateDockerRunRequestParams {
}
export function CreateDockerRunRequestParamsSanitizer(json: any): CreateDockerRunRequestParams {
    return {};
}
export const CreateDockerRunRequestParamsValidatorShape = {};
export const CreateDockerRunRequestParamsValidator = yup.object().shape(CreateDockerRunRequestParamsValidatorShape);
export interface CreateDockerRunArtifactRequestParams {
    runId: string;
}
export function CreateDockerRunArtifactRequestParamsSanitizer(json: any): CreateDockerRunArtifactRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const CreateDockerRunArtifactRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CreateDockerRunArtifactRequestParamsValidator = yup.object().shape(CreateDockerRunArtifactRequestParamsValidatorShape);
export interface CreateDockerRunLogByIdRequestParams {
    runId: string;
}
export function CreateDockerRunLogByIdRequestParamsSanitizer(json: any): CreateDockerRunLogByIdRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const CreateDockerRunLogByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CreateDockerRunLogByIdRequestParamsValidator = yup.object().shape(CreateDockerRunLogByIdRequestParamsValidatorShape);
export interface CreateDockerRunScheduledByDatasetIdRequestParams {
    datasetId: string;
}
export function CreateDockerRunScheduledByDatasetIdRequestParamsSanitizer(json: any): CreateDockerRunScheduledByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const CreateDockerRunScheduledByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CreateDockerRunScheduledByDatasetIdRequestParamsValidator = yup.object().shape(CreateDockerRunScheduledByDatasetIdRequestParamsValidatorShape);
export interface CreateDockerWorkerConfigRequestParams {
}
export function CreateDockerWorkerConfigRequestParamsSanitizer(json: any): CreateDockerWorkerConfigRequestParams {
    return {};
}
export const CreateDockerWorkerConfigRequestParamsValidatorShape = {};
export const CreateDockerWorkerConfigRequestParamsValidator = yup.object().shape(CreateDockerWorkerConfigRequestParamsValidatorShape);
export interface CreateDockerWorkerConfigV2RequestParams {
}
export function CreateDockerWorkerConfigV2RequestParamsSanitizer(json: any): CreateDockerWorkerConfigV2RequestParams {
    return {};
}
export const CreateDockerWorkerConfigV2RequestParamsValidatorShape = {};
export const CreateDockerWorkerConfigV2RequestParamsValidator = yup.object().shape(CreateDockerWorkerConfigV2RequestParamsValidatorShape);
export interface CreateDockerWorkerConfigV3RequestParams {
}
export function CreateDockerWorkerConfigV3RequestParamsSanitizer(json: any): CreateDockerWorkerConfigV3RequestParams {
    return {};
}
export const CreateDockerWorkerConfigV3RequestParamsValidatorShape = {};
export const CreateDockerWorkerConfigV3RequestParamsValidator = yup.object().shape(CreateDockerWorkerConfigV3RequestParamsValidatorShape);
export interface CreateDockerWorkerConfigVXRequestParams {
}
export function CreateDockerWorkerConfigVXRequestParamsSanitizer(json: any): CreateDockerWorkerConfigVXRequestParams {
    return {};
}
export const CreateDockerWorkerConfigVXRequestParamsValidatorShape = {};
export const CreateDockerWorkerConfigVXRequestParamsValidator = yup.object().shape(CreateDockerWorkerConfigVXRequestParamsValidatorShape);
export interface DeleteDockerWorkerRegistryEntryByIdRequestParams {
    workerId: string;
}
export function DeleteDockerWorkerRegistryEntryByIdRequestParamsSanitizer(json: any): DeleteDockerWorkerRegistryEntryByIdRequestParams {
    return {
        'workerId': json['workerId'],
    };
}
export const DeleteDockerWorkerRegistryEntryByIdRequestParamsValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const DeleteDockerWorkerRegistryEntryByIdRequestParamsValidator = yup.object().shape(DeleteDockerWorkerRegistryEntryByIdRequestParamsValidatorShape);
export interface GetDefaultOrRegisterWorkerRequestParams {
}
export function GetDefaultOrRegisterWorkerRequestParamsSanitizer(json: any): GetDefaultOrRegisterWorkerRequestParams {
    return {};
}
export const GetDefaultOrRegisterWorkerRequestParamsValidatorShape = {};
export const GetDefaultOrRegisterWorkerRequestParamsValidator = yup.object().shape(GetDefaultOrRegisterWorkerRequestParamsValidatorShape);
export interface GetDockerLicenseInformationRequestParams {
}
export function GetDockerLicenseInformationRequestParamsSanitizer(json: any): GetDockerLicenseInformationRequestParams {
    return {};
}
export const GetDockerLicenseInformationRequestParamsValidatorShape = {};
export const GetDockerLicenseInformationRequestParamsValidator = yup.object().shape(GetDockerLicenseInformationRequestParamsValidatorShape);
export interface GetDockerRunArtifactReadUrlByIdRequestParams {
    runId: string;
    artifactId: string;
}
export function GetDockerRunArtifactReadUrlByIdRequestParamsSanitizer(json: any): GetDockerRunArtifactReadUrlByIdRequestParams {
    return {
        'runId': json['runId'],
        'artifactId': json['artifactId'],
    };
}
export const GetDockerRunArtifactReadUrlByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'artifactId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunArtifactReadUrlByIdRequestParamsValidator = yup.object().shape(GetDockerRunArtifactReadUrlByIdRequestParamsValidatorShape);
export interface GetDockerRunByIdRequestParams {
    runId: string;
}
export function GetDockerRunByIdRequestParamsSanitizer(json: any): GetDockerRunByIdRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const GetDockerRunByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunByIdRequestParamsValidator = yup.object().shape(GetDockerRunByIdRequestParamsValidatorShape);
export interface GetDockerRunByScheduledIdRequestParams {
    scheduledId: string;
}
export function GetDockerRunByScheduledIdRequestParamsSanitizer(json: any): GetDockerRunByScheduledIdRequestParams {
    return {
        'scheduledId': json['scheduledId'],
    };
}
export const GetDockerRunByScheduledIdRequestParamsValidatorShape = {
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunByScheduledIdRequestParamsValidator = yup.object().shape(GetDockerRunByScheduledIdRequestParamsValidatorShape);
export interface GetDockerRunLogsByIdRequestParams {
    runId: string;
}
export function GetDockerRunLogsByIdRequestParamsSanitizer(json: any): GetDockerRunLogsByIdRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const GetDockerRunLogsByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunLogsByIdRequestParamsValidator = yup.object().shape(GetDockerRunLogsByIdRequestParamsValidatorShape);
export interface GetDockerRunReportReadUrlByIdRequestParams {
    runId: string;
}
export function GetDockerRunReportReadUrlByIdRequestParamsSanitizer(json: any): GetDockerRunReportReadUrlByIdRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const GetDockerRunReportReadUrlByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunReportReadUrlByIdRequestParamsValidator = yup.object().shape(GetDockerRunReportReadUrlByIdRequestParamsValidatorShape);
export interface GetDockerRunReportWriteUrlByIdRequestParams {
    runId: string;
}
export function GetDockerRunReportWriteUrlByIdRequestParamsSanitizer(json: any): GetDockerRunReportWriteUrlByIdRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const GetDockerRunReportWriteUrlByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunReportWriteUrlByIdRequestParamsValidator = yup.object().shape(GetDockerRunReportWriteUrlByIdRequestParamsValidatorShape);
export interface GetDockerRunTagsRequestParams {
    runId: string;
}
export function GetDockerRunTagsRequestParamsSanitizer(json: any): GetDockerRunTagsRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const GetDockerRunTagsRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunTagsRequestParamsValidator = yup.object().shape(GetDockerRunTagsRequestParamsValidatorShape);
export interface GetDockerRunsRequestParams {
}
export function GetDockerRunsRequestParamsSanitizer(json: any): GetDockerRunsRequestParams {
    return {};
}
export const GetDockerRunsRequestParamsValidatorShape = {};
export const GetDockerRunsRequestParamsValidator = yup.object().shape(GetDockerRunsRequestParamsValidatorShape);
export interface GetDockerRunsCountRequestParams {
}
export function GetDockerRunsCountRequestParamsSanitizer(json: any): GetDockerRunsCountRequestParams {
    return {};
}
export const GetDockerRunsCountRequestParamsValidatorShape = {};
export const GetDockerRunsCountRequestParamsValidator = yup.object().shape(GetDockerRunsCountRequestParamsValidatorShape);
export interface GetDockerRunsQueryByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDockerRunsQueryByDatasetIdRequestParamsSanitizer(json: any): GetDockerRunsQueryByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDockerRunsQueryByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunsQueryByDatasetIdRequestParamsValidator = yup.object().shape(GetDockerRunsQueryByDatasetIdRequestParamsValidatorShape);
export interface GetDockerRunsScheduledByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDockerRunsScheduledByDatasetIdRequestParamsSanitizer(json: any): GetDockerRunsScheduledByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDockerRunsScheduledByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunsScheduledByDatasetIdRequestParamsValidator = yup.object().shape(GetDockerRunsScheduledByDatasetIdRequestParamsValidatorShape);
export interface GetDockerRunsScheduledByStateAndLabelsRequestParams {
}
export function GetDockerRunsScheduledByStateAndLabelsRequestParamsSanitizer(json: any): GetDockerRunsScheduledByStateAndLabelsRequestParams {
    return {};
}
export const GetDockerRunsScheduledByStateAndLabelsRequestParamsValidatorShape = {};
export const GetDockerRunsScheduledByStateAndLabelsRequestParamsValidator = yup.object().shape(GetDockerRunsScheduledByStateAndLabelsRequestParamsValidatorShape);
export interface GetDockerRunsScheduledByWorkerIdRequestParams {
    workerId: string;
}
export function GetDockerRunsScheduledByWorkerIdRequestParamsSanitizer(json: any): GetDockerRunsScheduledByWorkerIdRequestParams {
    return {
        'workerId': json['workerId'],
    };
}
export const GetDockerRunsScheduledByWorkerIdRequestParamsValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerRunsScheduledByWorkerIdRequestParamsValidator = yup.object().shape(GetDockerRunsScheduledByWorkerIdRequestParamsValidatorShape);
export interface GetDockerWorkerConfigByIdRequestParams {
    configId: string;
}
export function GetDockerWorkerConfigByIdRequestParamsSanitizer(json: any): GetDockerWorkerConfigByIdRequestParams {
    return {
        'configId': json['configId'],
    };
}
export const GetDockerWorkerConfigByIdRequestParamsValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigByIdRequestParamsValidator = yup.object().shape(GetDockerWorkerConfigByIdRequestParamsValidatorShape);
export interface GetDockerWorkerConfigV2ByIdRequestParams {
    configId: string;
}
export function GetDockerWorkerConfigV2ByIdRequestParamsSanitizer(json: any): GetDockerWorkerConfigV2ByIdRequestParams {
    return {
        'configId': json['configId'],
    };
}
export const GetDockerWorkerConfigV2ByIdRequestParamsValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigV2ByIdRequestParamsValidator = yup.object().shape(GetDockerWorkerConfigV2ByIdRequestParamsValidatorShape);
export interface GetDockerWorkerConfigV3ByIdRequestParams {
    configId: string;
}
export function GetDockerWorkerConfigV3ByIdRequestParamsSanitizer(json: any): GetDockerWorkerConfigV3ByIdRequestParams {
    return {
        'configId': json['configId'],
    };
}
export const GetDockerWorkerConfigV3ByIdRequestParamsValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigV3ByIdRequestParamsValidator = yup.object().shape(GetDockerWorkerConfigV3ByIdRequestParamsValidatorShape);
export interface GetDockerWorkerConfigVXByIdRequestParams {
    configId: string;
}
export function GetDockerWorkerConfigVXByIdRequestParamsSanitizer(json: any): GetDockerWorkerConfigVXByIdRequestParams {
    return {
        'configId': json['configId'],
    };
}
export const GetDockerWorkerConfigVXByIdRequestParamsValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerConfigVXByIdRequestParamsValidator = yup.object().shape(GetDockerWorkerConfigVXByIdRequestParamsValidatorShape);
export interface GetDockerWorkerConfigsRequestParams {
}
export function GetDockerWorkerConfigsRequestParamsSanitizer(json: any): GetDockerWorkerConfigsRequestParams {
    return {};
}
export const GetDockerWorkerConfigsRequestParamsValidatorShape = {};
export const GetDockerWorkerConfigsRequestParamsValidator = yup.object().shape(GetDockerWorkerConfigsRequestParamsValidatorShape);
export interface GetDockerWorkerRegistryEntriesRequestParams {
}
export function GetDockerWorkerRegistryEntriesRequestParamsSanitizer(json: any): GetDockerWorkerRegistryEntriesRequestParams {
    return {};
}
export const GetDockerWorkerRegistryEntriesRequestParamsValidatorShape = {};
export const GetDockerWorkerRegistryEntriesRequestParamsValidator = yup.object().shape(GetDockerWorkerRegistryEntriesRequestParamsValidatorShape);
export interface GetDockerWorkerRegistryEntryByIdRequestParams {
    workerId: string;
}
export function GetDockerWorkerRegistryEntryByIdRequestParamsSanitizer(json: any): GetDockerWorkerRegistryEntryByIdRequestParams {
    return {
        'workerId': json['workerId'],
    };
}
export const GetDockerWorkerRegistryEntryByIdRequestParamsValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDockerWorkerRegistryEntryByIdRequestParamsValidator = yup.object().shape(GetDockerWorkerRegistryEntryByIdRequestParamsValidatorShape);
export interface PostDockerAuthorizationRequestRequestParams {
}
export function PostDockerAuthorizationRequestRequestParamsSanitizer(json: any): PostDockerAuthorizationRequestRequestParams {
    return {};
}
export const PostDockerAuthorizationRequestRequestParamsValidatorShape = {};
export const PostDockerAuthorizationRequestRequestParamsValidator = yup.object().shape(PostDockerAuthorizationRequestRequestParamsValidatorShape);
export interface PostDockerUsageStatsRequestParams {
}
export function PostDockerUsageStatsRequestParamsSanitizer(json: any): PostDockerUsageStatsRequestParams {
    return {};
}
export const PostDockerUsageStatsRequestParamsValidatorShape = {};
export const PostDockerUsageStatsRequestParamsValidator = yup.object().shape(PostDockerUsageStatsRequestParamsValidatorShape);
export interface PostDockerWorkerAuthorizationRequestRequestParams {
}
export function PostDockerWorkerAuthorizationRequestRequestParamsSanitizer(json: any): PostDockerWorkerAuthorizationRequestRequestParams {
    return {};
}
export const PostDockerWorkerAuthorizationRequestRequestParamsValidatorShape = {};
export const PostDockerWorkerAuthorizationRequestRequestParamsValidator = yup.object().shape(PostDockerWorkerAuthorizationRequestRequestParamsValidatorShape);
export interface RegisterDockerWorkerRequestParams {
}
export function RegisterDockerWorkerRequestParamsSanitizer(json: any): RegisterDockerWorkerRequestParams {
    return {};
}
export const RegisterDockerWorkerRequestParamsValidatorShape = {};
export const RegisterDockerWorkerRequestParamsValidator = yup.object().shape(RegisterDockerWorkerRequestParamsValidatorShape);
export interface UpdateDockerRunByIdRequestParams {
    runId: string;
}
export function UpdateDockerRunByIdRequestParamsSanitizer(json: any): UpdateDockerRunByIdRequestParams {
    return {
        'runId': json['runId'],
    };
}
export const UpdateDockerRunByIdRequestParamsValidatorShape = {
    'runId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDockerRunByIdRequestParamsValidator = yup.object().shape(UpdateDockerRunByIdRequestParamsValidatorShape);
export interface UpdateDockerWorkerConfigByIdRequestParams {
    configId: string;
}
export function UpdateDockerWorkerConfigByIdRequestParamsSanitizer(json: any): UpdateDockerWorkerConfigByIdRequestParams {
    return {
        'configId': json['configId'],
    };
}
export const UpdateDockerWorkerConfigByIdRequestParamsValidatorShape = {
    'configId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDockerWorkerConfigByIdRequestParamsValidator = yup.object().shape(UpdateDockerWorkerConfigByIdRequestParamsValidatorShape);
export interface UpdateDockerWorkerRegistryEntryByIdRequestParams {
    workerId: string;
}
export function UpdateDockerWorkerRegistryEntryByIdRequestParamsSanitizer(json: any): UpdateDockerWorkerRegistryEntryByIdRequestParams {
    return {
        'workerId': json['workerId'],
    };
}
export const UpdateDockerWorkerRegistryEntryByIdRequestParamsValidatorShape = {
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDockerWorkerRegistryEntryByIdRequestParamsValidator = yup.object().shape(UpdateDockerWorkerRegistryEntryByIdRequestParamsValidatorShape);
export interface UpdateScheduledDockerRunStateByIdRequestParams {
    datasetId: string;
    workerId: string;
    scheduledId: string;
}
export function UpdateScheduledDockerRunStateByIdRequestParamsSanitizer(json: any): UpdateScheduledDockerRunStateByIdRequestParams {
    return {
        'datasetId': json['datasetId'],
        'workerId': json['workerId'],
        'scheduledId': json['scheduledId'],
    };
}
export const UpdateScheduledDockerRunStateByIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'workerId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'scheduledId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateScheduledDockerRunStateByIdRequestParamsValidator = yup.object().shape(UpdateScheduledDockerRunStateByIdRequestParamsValidatorShape);
export interface CancelScheduledDockerRunStateByIdRequestQuery {
}
export function CancelScheduledDockerRunStateByIdRequestQuerySanitizer(json: any): CancelScheduledDockerRunStateByIdRequestQuery {
    return {};
}
export const CancelScheduledDockerRunStateByIdRequestQueryValidatorShape = {};
export const CancelScheduledDockerRunStateByIdRequestQueryValidator = yup.object().shape(CancelScheduledDockerRunStateByIdRequestQueryValidatorShape);
export interface ConfirmDockerRunArtifactCreationRequestQuery {
}
export function ConfirmDockerRunArtifactCreationRequestQuerySanitizer(json: any): ConfirmDockerRunArtifactCreationRequestQuery {
    return {};
}
export const ConfirmDockerRunArtifactCreationRequestQueryValidatorShape = {};
export const ConfirmDockerRunArtifactCreationRequestQueryValidator = yup.object().shape(ConfirmDockerRunArtifactCreationRequestQueryValidatorShape);
export interface CreateDockerRunRequestQuery {
}
export function CreateDockerRunRequestQuerySanitizer(json: any): CreateDockerRunRequestQuery {
    return {};
}
export const CreateDockerRunRequestQueryValidatorShape = {};
export const CreateDockerRunRequestQueryValidator = yup.object().shape(CreateDockerRunRequestQueryValidatorShape);
export interface CreateDockerRunArtifactRequestQuery {
}
export function CreateDockerRunArtifactRequestQuerySanitizer(json: any): CreateDockerRunArtifactRequestQuery {
    return {};
}
export const CreateDockerRunArtifactRequestQueryValidatorShape = {};
export const CreateDockerRunArtifactRequestQueryValidator = yup.object().shape(CreateDockerRunArtifactRequestQueryValidatorShape);
export interface CreateDockerRunLogByIdRequestQuery {
}
export function CreateDockerRunLogByIdRequestQuerySanitizer(json: any): CreateDockerRunLogByIdRequestQuery {
    return {};
}
export const CreateDockerRunLogByIdRequestQueryValidatorShape = {};
export const CreateDockerRunLogByIdRequestQueryValidator = yup.object().shape(CreateDockerRunLogByIdRequestQueryValidatorShape);
export interface CreateDockerRunScheduledByDatasetIdRequestQuery {
    disableConfigValidation?: boolean;
}
export function CreateDockerRunScheduledByDatasetIdRequestQuerySanitizer(json: any): CreateDockerRunScheduledByDatasetIdRequestQuery {
    return {
        'disableConfigValidation': json['disableConfigValidation'],
    };
}
export const CreateDockerRunScheduledByDatasetIdRequestQueryValidatorShape = {
    'disableConfigValidation': yup.boolean(),
};
export const CreateDockerRunScheduledByDatasetIdRequestQueryValidator = yup.object().shape(CreateDockerRunScheduledByDatasetIdRequestQueryValidatorShape);
export interface CreateDockerWorkerConfigRequestQuery {
}
export function CreateDockerWorkerConfigRequestQuerySanitizer(json: any): CreateDockerWorkerConfigRequestQuery {
    return {};
}
export const CreateDockerWorkerConfigRequestQueryValidatorShape = {};
export const CreateDockerWorkerConfigRequestQueryValidator = yup.object().shape(CreateDockerWorkerConfigRequestQueryValidatorShape);
export interface CreateDockerWorkerConfigV2RequestQuery {
}
export function CreateDockerWorkerConfigV2RequestQuerySanitizer(json: any): CreateDockerWorkerConfigV2RequestQuery {
    return {};
}
export const CreateDockerWorkerConfigV2RequestQueryValidatorShape = {};
export const CreateDockerWorkerConfigV2RequestQueryValidator = yup.object().shape(CreateDockerWorkerConfigV2RequestQueryValidatorShape);
export interface CreateDockerWorkerConfigV3RequestQuery {
}
export function CreateDockerWorkerConfigV3RequestQuerySanitizer(json: any): CreateDockerWorkerConfigV3RequestQuery {
    return {};
}
export const CreateDockerWorkerConfigV3RequestQueryValidatorShape = {};
export const CreateDockerWorkerConfigV3RequestQueryValidator = yup.object().shape(CreateDockerWorkerConfigV3RequestQueryValidatorShape);
export interface CreateDockerWorkerConfigVXRequestQuery {
}
export function CreateDockerWorkerConfigVXRequestQuerySanitizer(json: any): CreateDockerWorkerConfigVXRequestQuery {
    return {};
}
export const CreateDockerWorkerConfigVXRequestQueryValidatorShape = {};
export const CreateDockerWorkerConfigVXRequestQueryValidator = yup.object().shape(CreateDockerWorkerConfigVXRequestQueryValidatorShape);
export interface DeleteDockerWorkerRegistryEntryByIdRequestQuery {
}
export function DeleteDockerWorkerRegistryEntryByIdRequestQuerySanitizer(json: any): DeleteDockerWorkerRegistryEntryByIdRequestQuery {
    return {};
}
export const DeleteDockerWorkerRegistryEntryByIdRequestQueryValidatorShape = {};
export const DeleteDockerWorkerRegistryEntryByIdRequestQueryValidator = yup.object().shape(DeleteDockerWorkerRegistryEntryByIdRequestQueryValidatorShape);
export interface GetDefaultOrRegisterWorkerRequestQuery {
}
export function GetDefaultOrRegisterWorkerRequestQuerySanitizer(json: any): GetDefaultOrRegisterWorkerRequestQuery {
    return {};
}
export const GetDefaultOrRegisterWorkerRequestQueryValidatorShape = {};
export const GetDefaultOrRegisterWorkerRequestQueryValidator = yup.object().shape(GetDefaultOrRegisterWorkerRequestQueryValidatorShape);
export interface GetDockerLicenseInformationRequestQuery {
}
export function GetDockerLicenseInformationRequestQuerySanitizer(json: any): GetDockerLicenseInformationRequestQuery {
    return {};
}
export const GetDockerLicenseInformationRequestQueryValidatorShape = {};
export const GetDockerLicenseInformationRequestQueryValidator = yup.object().shape(GetDockerLicenseInformationRequestQueryValidatorShape);
export interface GetDockerRunArtifactReadUrlByIdRequestQuery {
}
export function GetDockerRunArtifactReadUrlByIdRequestQuerySanitizer(json: any): GetDockerRunArtifactReadUrlByIdRequestQuery {
    return {};
}
export const GetDockerRunArtifactReadUrlByIdRequestQueryValidatorShape = {};
export const GetDockerRunArtifactReadUrlByIdRequestQueryValidator = yup.object().shape(GetDockerRunArtifactReadUrlByIdRequestQueryValidatorShape);
export interface GetDockerRunByIdRequestQuery {
}
export function GetDockerRunByIdRequestQuerySanitizer(json: any): GetDockerRunByIdRequestQuery {
    return {};
}
export const GetDockerRunByIdRequestQueryValidatorShape = {};
export const GetDockerRunByIdRequestQueryValidator = yup.object().shape(GetDockerRunByIdRequestQueryValidatorShape);
export interface GetDockerRunByScheduledIdRequestQuery {
}
export function GetDockerRunByScheduledIdRequestQuerySanitizer(json: any): GetDockerRunByScheduledIdRequestQuery {
    return {};
}
export const GetDockerRunByScheduledIdRequestQueryValidatorShape = {};
export const GetDockerRunByScheduledIdRequestQueryValidator = yup.object().shape(GetDockerRunByScheduledIdRequestQueryValidatorShape);
export interface GetDockerRunLogsByIdRequestQuery {
    cursor?: number;
}
export function GetDockerRunLogsByIdRequestQuerySanitizer(json: any): GetDockerRunLogsByIdRequestQuery {
    return {
        'cursor': json['cursor'],
    };
}
export const GetDockerRunLogsByIdRequestQueryValidatorShape = {
    'cursor': yup.number().integer().min(0),
};
export const GetDockerRunLogsByIdRequestQueryValidator = yup.object().shape(GetDockerRunLogsByIdRequestQueryValidatorShape);
export interface GetDockerRunReportReadUrlByIdRequestQuery {
}
export function GetDockerRunReportReadUrlByIdRequestQuerySanitizer(json: any): GetDockerRunReportReadUrlByIdRequestQuery {
    return {};
}
export const GetDockerRunReportReadUrlByIdRequestQueryValidatorShape = {};
export const GetDockerRunReportReadUrlByIdRequestQueryValidator = yup.object().shape(GetDockerRunReportReadUrlByIdRequestQueryValidatorShape);
export interface GetDockerRunReportWriteUrlByIdRequestQuery {
}
export function GetDockerRunReportWriteUrlByIdRequestQuerySanitizer(json: any): GetDockerRunReportWriteUrlByIdRequestQuery {
    return {};
}
export const GetDockerRunReportWriteUrlByIdRequestQueryValidatorShape = {};
export const GetDockerRunReportWriteUrlByIdRequestQueryValidator = yup.object().shape(GetDockerRunReportWriteUrlByIdRequestQueryValidatorShape);
export interface GetDockerRunTagsRequestQuery {
}
export function GetDockerRunTagsRequestQuerySanitizer(json: any): GetDockerRunTagsRequestQuery {
    return {};
}
export const GetDockerRunTagsRequestQueryValidatorShape = {};
export const GetDockerRunTagsRequestQueryValidator = yup.object().shape(GetDockerRunTagsRequestQueryValidatorShape);
export interface GetDockerRunsRequestQuery {
    pageSize?: number;
    pageOffset?: number;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
    showArchived?: boolean;
}
export function GetDockerRunsRequestQuerySanitizer(json: any): GetDockerRunsRequestQuery {
    return {
        'pageSize': json['pageSize'],
        'pageOffset': json['pageOffset'],
        'getAssetsOfTeam': json['getAssetsOfTeam'],
        'getAssetsOfTeamInclusiveSelf': json['getAssetsOfTeamInclusiveSelf'],
        'showArchived': json['showArchived'],
    };
}
export const GetDockerRunsRequestQueryValidatorShape = {
    'pageSize': yup.number().min(1),
    'pageOffset': yup.number().min(0),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
    'showArchived': yup.boolean(),
};
export const GetDockerRunsRequestQueryValidator = yup.object().shape(GetDockerRunsRequestQueryValidatorShape);
export interface GetDockerRunsCountRequestQuery {
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
    showArchived?: boolean;
}
export function GetDockerRunsCountRequestQuerySanitizer(json: any): GetDockerRunsCountRequestQuery {
    return {
        'getAssetsOfTeam': json['getAssetsOfTeam'],
        'getAssetsOfTeamInclusiveSelf': json['getAssetsOfTeamInclusiveSelf'],
        'showArchived': json['showArchived'],
    };
}
export const GetDockerRunsCountRequestQueryValidatorShape = {
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
    'showArchived': yup.boolean(),
};
export const GetDockerRunsCountRequestQueryValidator = yup.object().shape(GetDockerRunsCountRequestQueryValidatorShape);
export interface GetDockerRunsQueryByDatasetIdRequestQuery {
    pageSize?: number;
    pageOffset?: number;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
export function GetDockerRunsQueryByDatasetIdRequestQuerySanitizer(json: any): GetDockerRunsQueryByDatasetIdRequestQuery {
    return {
        'pageSize': json['pageSize'],
        'pageOffset': json['pageOffset'],
        'getAssetsOfTeam': json['getAssetsOfTeam'],
        'getAssetsOfTeamInclusiveSelf': json['getAssetsOfTeamInclusiveSelf'],
    };
}
export const GetDockerRunsQueryByDatasetIdRequestQueryValidatorShape = {
    'pageSize': yup.number().min(1),
    'pageOffset': yup.number().min(0),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerRunsQueryByDatasetIdRequestQueryValidator = yup.object().shape(GetDockerRunsQueryByDatasetIdRequestQueryValidatorShape);
export interface GetDockerRunsScheduledByDatasetIdRequestQuery {
    state?: models.DockerRunScheduledState;
    states?: models.DockerRunScheduledStateArray;
}
export function GetDockerRunsScheduledByDatasetIdRequestQuerySanitizer(json: any): GetDockerRunsScheduledByDatasetIdRequestQuery {
    return {
        'state': json['state'],
        'states': json['states'],
    };
}
export const GetDockerRunsScheduledByDatasetIdRequestQueryValidatorShape = {
    'state': models.DockerRunScheduledStateValidator.optional().default(undefined),
    'states': models.DockerRunScheduledStateArrayValidator.optional().default(undefined),
};
export const GetDockerRunsScheduledByDatasetIdRequestQueryValidator = yup.object().shape(GetDockerRunsScheduledByDatasetIdRequestQueryValidatorShape);
export interface GetDockerRunsScheduledByStateAndLabelsRequestQuery {
    state?: models.DockerRunScheduledState;
    labels?: models.DockerWorkerLabels;
    version?: string;
    includeUnlockableRuns?: boolean;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
export function GetDockerRunsScheduledByStateAndLabelsRequestQuerySanitizer(json: any): GetDockerRunsScheduledByStateAndLabelsRequestQuery {
    return {
        'state': json['state'],
        'labels': json['labels'],
        'version': json['version'],
        'includeUnlockableRuns': json['includeUnlockableRuns'],
        'getAssetsOfTeam': json['getAssetsOfTeam'],
        'getAssetsOfTeamInclusiveSelf': json['getAssetsOfTeamInclusiveSelf'],
    };
}
export const GetDockerRunsScheduledByStateAndLabelsRequestQueryValidatorShape = {
    'state': models.DockerRunScheduledStateValidator.optional().default(undefined),
    'labels': models.DockerWorkerLabelsValidator.optional().default(undefined),
    'version': yup.string(),
    'includeUnlockableRuns': yup.boolean(),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerRunsScheduledByStateAndLabelsRequestQueryValidator = yup.object().shape(GetDockerRunsScheduledByStateAndLabelsRequestQueryValidatorShape);
export interface GetDockerRunsScheduledByWorkerIdRequestQuery {
    state?: models.DockerRunScheduledState;
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
export function GetDockerRunsScheduledByWorkerIdRequestQuerySanitizer(json: any): GetDockerRunsScheduledByWorkerIdRequestQuery {
    return {
        'state': json['state'],
        'getAssetsOfTeam': json['getAssetsOfTeam'],
        'getAssetsOfTeamInclusiveSelf': json['getAssetsOfTeamInclusiveSelf'],
    };
}
export const GetDockerRunsScheduledByWorkerIdRequestQueryValidatorShape = {
    'state': models.DockerRunScheduledStateValidator.optional().default(undefined),
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerRunsScheduledByWorkerIdRequestQueryValidator = yup.object().shape(GetDockerRunsScheduledByWorkerIdRequestQueryValidatorShape);
export interface GetDockerWorkerConfigByIdRequestQuery {
}
export function GetDockerWorkerConfigByIdRequestQuerySanitizer(json: any): GetDockerWorkerConfigByIdRequestQuery {
    return {};
}
export const GetDockerWorkerConfigByIdRequestQueryValidatorShape = {};
export const GetDockerWorkerConfigByIdRequestQueryValidator = yup.object().shape(GetDockerWorkerConfigByIdRequestQueryValidatorShape);
export interface GetDockerWorkerConfigV2ByIdRequestQuery {
}
export function GetDockerWorkerConfigV2ByIdRequestQuerySanitizer(json: any): GetDockerWorkerConfigV2ByIdRequestQuery {
    return {};
}
export const GetDockerWorkerConfigV2ByIdRequestQueryValidatorShape = {};
export const GetDockerWorkerConfigV2ByIdRequestQueryValidator = yup.object().shape(GetDockerWorkerConfigV2ByIdRequestQueryValidatorShape);
export interface GetDockerWorkerConfigV3ByIdRequestQuery {
}
export function GetDockerWorkerConfigV3ByIdRequestQuerySanitizer(json: any): GetDockerWorkerConfigV3ByIdRequestQuery {
    return {};
}
export const GetDockerWorkerConfigV3ByIdRequestQueryValidatorShape = {};
export const GetDockerWorkerConfigV3ByIdRequestQueryValidator = yup.object().shape(GetDockerWorkerConfigV3ByIdRequestQueryValidatorShape);
export interface GetDockerWorkerConfigVXByIdRequestQuery {
}
export function GetDockerWorkerConfigVXByIdRequestQuerySanitizer(json: any): GetDockerWorkerConfigVXByIdRequestQuery {
    return {};
}
export const GetDockerWorkerConfigVXByIdRequestQueryValidatorShape = {};
export const GetDockerWorkerConfigVXByIdRequestQueryValidator = yup.object().shape(GetDockerWorkerConfigVXByIdRequestQueryValidatorShape);
export interface GetDockerWorkerConfigsRequestQuery {
}
export function GetDockerWorkerConfigsRequestQuerySanitizer(json: any): GetDockerWorkerConfigsRequestQuery {
    return {};
}
export const GetDockerWorkerConfigsRequestQueryValidatorShape = {};
export const GetDockerWorkerConfigsRequestQueryValidator = yup.object().shape(GetDockerWorkerConfigsRequestQueryValidatorShape);
export interface GetDockerWorkerRegistryEntriesRequestQuery {
    getAssetsOfTeam?: boolean;
    getAssetsOfTeamInclusiveSelf?: boolean;
}
export function GetDockerWorkerRegistryEntriesRequestQuerySanitizer(json: any): GetDockerWorkerRegistryEntriesRequestQuery {
    return {
        'getAssetsOfTeam': json['getAssetsOfTeam'],
        'getAssetsOfTeamInclusiveSelf': json['getAssetsOfTeamInclusiveSelf'],
    };
}
export const GetDockerWorkerRegistryEntriesRequestQueryValidatorShape = {
    'getAssetsOfTeam': yup.boolean(),
    'getAssetsOfTeamInclusiveSelf': yup.boolean(),
};
export const GetDockerWorkerRegistryEntriesRequestQueryValidator = yup.object().shape(GetDockerWorkerRegistryEntriesRequestQueryValidatorShape);
export interface GetDockerWorkerRegistryEntryByIdRequestQuery {
}
export function GetDockerWorkerRegistryEntryByIdRequestQuerySanitizer(json: any): GetDockerWorkerRegistryEntryByIdRequestQuery {
    return {};
}
export const GetDockerWorkerRegistryEntryByIdRequestQueryValidatorShape = {};
export const GetDockerWorkerRegistryEntryByIdRequestQueryValidator = yup.object().shape(GetDockerWorkerRegistryEntryByIdRequestQueryValidatorShape);
export interface PostDockerAuthorizationRequestRequestQuery {
}
export function PostDockerAuthorizationRequestRequestQuerySanitizer(json: any): PostDockerAuthorizationRequestRequestQuery {
    return {};
}
export const PostDockerAuthorizationRequestRequestQueryValidatorShape = {};
export const PostDockerAuthorizationRequestRequestQueryValidator = yup.object().shape(PostDockerAuthorizationRequestRequestQueryValidatorShape);
export interface PostDockerUsageStatsRequestQuery {
}
export function PostDockerUsageStatsRequestQuerySanitizer(json: any): PostDockerUsageStatsRequestQuery {
    return {};
}
export const PostDockerUsageStatsRequestQueryValidatorShape = {};
export const PostDockerUsageStatsRequestQueryValidator = yup.object().shape(PostDockerUsageStatsRequestQueryValidatorShape);
export interface PostDockerWorkerAuthorizationRequestRequestQuery {
}
export function PostDockerWorkerAuthorizationRequestRequestQuerySanitizer(json: any): PostDockerWorkerAuthorizationRequestRequestQuery {
    return {};
}
export const PostDockerWorkerAuthorizationRequestRequestQueryValidatorShape = {};
export const PostDockerWorkerAuthorizationRequestRequestQueryValidator = yup.object().shape(PostDockerWorkerAuthorizationRequestRequestQueryValidatorShape);
export interface RegisterDockerWorkerRequestQuery {
    forUserId?: string;
}
export function RegisterDockerWorkerRequestQuerySanitizer(json: any): RegisterDockerWorkerRequestQuery {
    return {
        'forUserId': json['forUserId'],
    };
}
export const RegisterDockerWorkerRequestQueryValidatorShape = {
    'forUserId': yup.string(),
};
export const RegisterDockerWorkerRequestQueryValidator = yup.object().shape(RegisterDockerWorkerRequestQueryValidatorShape);
export interface UpdateDockerRunByIdRequestQuery {
}
export function UpdateDockerRunByIdRequestQuerySanitizer(json: any): UpdateDockerRunByIdRequestQuery {
    return {};
}
export const UpdateDockerRunByIdRequestQueryValidatorShape = {};
export const UpdateDockerRunByIdRequestQueryValidator = yup.object().shape(UpdateDockerRunByIdRequestQueryValidatorShape);
export interface UpdateDockerWorkerConfigByIdRequestQuery {
}
export function UpdateDockerWorkerConfigByIdRequestQuerySanitizer(json: any): UpdateDockerWorkerConfigByIdRequestQuery {
    return {};
}
export const UpdateDockerWorkerConfigByIdRequestQueryValidatorShape = {};
export const UpdateDockerWorkerConfigByIdRequestQueryValidator = yup.object().shape(UpdateDockerWorkerConfigByIdRequestQueryValidatorShape);
export interface UpdateDockerWorkerRegistryEntryByIdRequestQuery {
}
export function UpdateDockerWorkerRegistryEntryByIdRequestQuerySanitizer(json: any): UpdateDockerWorkerRegistryEntryByIdRequestQuery {
    return {};
}
export const UpdateDockerWorkerRegistryEntryByIdRequestQueryValidatorShape = {};
export const UpdateDockerWorkerRegistryEntryByIdRequestQueryValidator = yup.object().shape(UpdateDockerWorkerRegistryEntryByIdRequestQueryValidatorShape);
export interface UpdateScheduledDockerRunStateByIdRequestQuery {
}
export function UpdateScheduledDockerRunStateByIdRequestQuerySanitizer(json: any): UpdateScheduledDockerRunStateByIdRequestQuery {
    return {};
}
export const UpdateScheduledDockerRunStateByIdRequestQueryValidatorShape = {};
export const UpdateScheduledDockerRunStateByIdRequestQueryValidator = yup.object().shape(UpdateScheduledDockerRunStateByIdRequestQueryValidatorShape);
export type CreateDockerRunRequestBody = DockerRunCreateRequest;
export const CreateDockerRunRequestBodySanitizer = DockerRunCreateRequestFromJSON;
export const CreateDockerRunRequestBodyValidator = DockerRunCreateRequestValidator;
export const CreateDockerRunTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerRunRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerRunRequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.dockerVersion && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_DockerRunCreateRequest_datasetId", "string", "", input.datasetId)) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && $is_custom("pattern_DockerRunCreateRequest_scheduledId", "string", "", input.scheduledId)) && (undefined === input.configId || "string" === typeof input.configId && $is_custom("pattern_DockerRunCreateRequest_configId", "string", "", input.configId)) && (undefined === input.message || "string" === typeof input.message) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["dockerVersion", "datasetId", "scheduledId", "configId", "message", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "string",
                    value: input.dockerVersion
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_DockerRunCreateRequest_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_DockerRunCreateRequest_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && ($is_custom("pattern_DockerRunCreateRequest_scheduledId", "string", "", input.scheduledId) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "string (@pattern_DockerRunCreateRequest_scheduledId)",
                    value: input.scheduledId
                })) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "(string | undefined)",
                    value: input.scheduledId
                })) && (undefined === input.configId || "string" === typeof input.configId && ($is_custom("pattern_DockerRunCreateRequest_configId", "string", "", input.configId) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string (@pattern_DockerRunCreateRequest_configId)",
                    value: input.configId
                })) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "(string | undefined)",
                    value: input.configId
                })) && (undefined === input.message || "string" === typeof input.message || $guard(_exceptionable, {
                    path: _path + ".message",
                    expected: "(string | undefined)",
                    value: input.message
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["dockerVersion", "datasetId", "scheduledId", "configId", "message", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerRunTypiaAssertStringify = (input: CreateDockerRunRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerRunRequestBody => {
        const __is = (input: any): input is CreateDockerRunRequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "string" === typeof input.dockerVersion && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_DockerRunCreateRequest_datasetId", "string", "", input.datasetId)) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && $is_custom("pattern_DockerRunCreateRequest_scheduledId", "string", "", input.scheduledId)) && (undefined === input.configId || "string" === typeof input.configId && $is_custom("pattern_DockerRunCreateRequest_configId", "string", "", input.configId)) && (undefined === input.message || "string" === typeof input.message) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "string",
                    value: input.dockerVersion
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_DockerRunCreateRequest_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_DockerRunCreateRequest_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.scheduledId || "string" === typeof input.scheduledId && ($is_custom("pattern_DockerRunCreateRequest_scheduledId", "string", "", input.scheduledId) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "string (@pattern_DockerRunCreateRequest_scheduledId)",
                    value: input.scheduledId
                })) || $guard(_exceptionable, {
                    path: _path + ".scheduledId",
                    expected: "(string | undefined)",
                    value: input.scheduledId
                })) && (undefined === input.configId || "string" === typeof input.configId && ($is_custom("pattern_DockerRunCreateRequest_configId", "string", "", input.configId) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string (@pattern_DockerRunCreateRequest_configId)",
                    value: input.configId
                })) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "(string | undefined)",
                    value: input.configId
                })) && (undefined === input.message || "string" === typeof input.message || $guard(_exceptionable, {
                    path: _path + ".message",
                    expected: "(string | undefined)",
                    value: input.message
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerRunRequestBody): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.scheduledId ? "" : `"scheduledId":${undefined !== input.scheduledId ? $string(input.scheduledId) : undefined},`}${undefined === input.configId ? "" : `"configId":${undefined !== input.configId ? $string(input.configId) : undefined},`}${undefined === input.message ? "" : `"message":${undefined !== input.message ? $string(input.message) : undefined},`}${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"dockerVersion":${$string(input.dockerVersion)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerRunArtifactRequestBody = DockerRunArtifactCreateRequest;
export const CreateDockerRunArtifactRequestBodySanitizer = DockerRunArtifactCreateRequestFromJSON;
export const CreateDockerRunArtifactRequestBodyValidator = DockerRunArtifactCreateRequestValidator;
export const CreateDockerRunArtifactTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerRunArtifactRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerRunArtifactRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.fileName && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["fileName", "type", "storageLocation"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunArtifactRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                    value: input.type
                })) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation || $guard(_exceptionable, {
                    path: _path + ".storageLocation",
                    expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                    value: input.storageLocation
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["fileName", "type", "storageLocation"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerRunArtifactTypiaAssertStringify = (input: CreateDockerRunArtifactRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerRunArtifactRequestBody => {
        const __is = (input: any): input is CreateDockerRunArtifactRequestBody => {
            const $io0 = (input: any): boolean => "string" === typeof input.fileName && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunArtifactRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.fileName || $guard(_exceptionable, {
                    path: _path + ".fileName",
                    expected: "string",
                    value: input.fileName
                })) && ("LOG" === input.type || "MEMLOG" === input.type || "CHECKPOINT" === input.type || "REPORT_PDF" === input.type || "REPORT_JSON" === input.type || "REPORT_V2_JSON" === input.type || "CORRUPTNESS_CHECK_INFORMATION" === input.type || "SEQUENCE_INFORMATION" === input.type || "RELEVANT_FILENAMES" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                    value: input.type
                })) && (undefined === input.storageLocation || "LIGHTLY" === input.storageLocation || "DATASOURCE" === input.storageLocation || $guard(_exceptionable, {
                    path: _path + ".storageLocation",
                    expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                    value: input.storageLocation
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunArtifactCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerRunArtifactRequestBody): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${undefined === input.storageLocation ? "" : `"storageLocation":${undefined !== input.storageLocation ? (() => {
            if ("string" === typeof input.storageLocation)
                return $string(input.storageLocation);
            if ("string" === typeof input.storageLocation)
                return "\"" + input.storageLocation + "\"";
            $throws({
                expected: "(\"DATASOURCE\" | \"LIGHTLY\" | undefined)",
                value: input.storageLocation
            });
        })() : undefined},`}"fileName":${$string(input.fileName)},"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"CHECKPOINT\" | \"CORRUPTNESS_CHECK_INFORMATION\" | \"LOG\" | \"MEMLOG\" | \"RELEVANT_FILENAMES\" | \"REPORT_JSON\" | \"REPORT_PDF\" | \"REPORT_V2_JSON\" | \"SEQUENCE_INFORMATION\")",
                value: input.type
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerRunLogByIdRequestBody = DockerRunLogCreateEntriesRequest;
export const CreateDockerRunLogByIdRequestBodySanitizer = DockerRunLogCreateEntriesRequestFromJSON;
export const CreateDockerRunLogByIdRequestBodyValidator = DockerRunLogCreateEntriesRequestValidator;
export const CreateDockerRunLogByIdTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerRunLogByIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerRunLogByIdRequestBody => {
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "object" === typeof value && null !== value && $io1(value, true && _exceptionable);
                return false;
            });
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.ts && 0 <= input.ts && ("VERBOSE" === input.level || "NOTSET" === input.level || "DEBUG" === input.level || "INFO" === input.level || "WARNING" === input.level || "ERROR" === input.level || "CRITICAL" === input.level) && "string" === typeof input.group && (undefined === input.origin || "string" === typeof input.origin) && "string" === typeof input.msg && (undefined === input.state || "STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.load || "object" === typeof input.load && null !== input.load && false === Array.isArray(input.load) && $io2(input.load, true && _exceptionable)) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["ts", "level", "group", "origin", "msg", "state", "load"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.cpu || "number" === typeof input.cpu && 0 <= input.cpu && 100 >= input.cpu) && (undefined === input.mem || "number" === typeof input.mem && 0 <= input.mem && 100 >= input.mem) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["cpu", "mem"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunLogByIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return ("object" === typeof value && null !== value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DockerRunLogCreateEntryData",
                            value: value
                        })) && $ao1(value, _path + $join(key), true && _exceptionable) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DockerRunLogCreateEntryData",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.ts && (0 <= input.ts || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "number (@minimum 0)",
                    value: input.ts
                })) || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "number",
                    value: input.ts
                })) && ("VERBOSE" === input.level || "NOTSET" === input.level || "DEBUG" === input.level || "INFO" === input.level || "WARNING" === input.level || "ERROR" === input.level || "CRITICAL" === input.level || $guard(_exceptionable, {
                    path: _path + ".level",
                    expected: "(\"CRITICAL\" | \"DEBUG\" | \"ERROR\" | \"INFO\" | \"NOTSET\" | \"VERBOSE\" | \"WARNING\")",
                    value: input.level
                })) && ("string" === typeof input.group || $guard(_exceptionable, {
                    path: _path + ".group",
                    expected: "string",
                    value: input.group
                })) && (undefined === input.origin || "string" === typeof input.origin || $guard(_exceptionable, {
                    path: _path + ".origin",
                    expected: "(string | undefined)",
                    value: input.origin
                })) && ("string" === typeof input.msg || $guard(_exceptionable, {
                    path: _path + ".msg",
                    expected: "string",
                    value: input.msg
                })) && (undefined === input.state || "STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\" | undefined)",
                    value: input.state
                })) && (undefined === input.load || ("object" === typeof input.load && null !== input.load && false === Array.isArray(input.load) || $guard(_exceptionable, {
                    path: _path + ".load",
                    expected: "(DockerRunLogDockerLoad | undefined)",
                    value: input.load
                })) && $ao2(input.load, _path + ".load", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".load",
                    expected: "(DockerRunLogDockerLoad | undefined)",
                    value: input.load
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["ts", "level", "group", "origin", "msg", "state", "load"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cpu || "number" === typeof input.cpu && (0 <= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@minimum 0)",
                    value: input.cpu
                })) && (100 >= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@maximum 100)",
                    value: input.cpu
                })) || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "(number | undefined)",
                    value: input.cpu
                })) && (undefined === input.mem || "number" === typeof input.mem && (0 <= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@minimum 0)",
                    value: input.mem
                })) && (100 >= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@maximum 100)",
                    value: input.mem
                })) || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "(number | undefined)",
                    value: input.mem
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["cpu", "mem"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogCreateEntriesRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogCreateEntriesRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerRunLogByIdTypiaAssertStringify = (input: CreateDockerRunLogByIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerRunLogByIdRequestBody => {
        const __is = (input: any): input is CreateDockerRunLogByIdRequestBody => {
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "object" === typeof value && null !== value && $io1(value);
                return true;
            });
            const $io1 = (input: any): boolean => "number" === typeof input.ts && !Number.isNaN(input.ts) && 0 <= input.ts && ("VERBOSE" === input.level || "NOTSET" === input.level || "DEBUG" === input.level || "INFO" === input.level || "WARNING" === input.level || "ERROR" === input.level || "CRITICAL" === input.level) && "string" === typeof input.group && (undefined === input.origin || "string" === typeof input.origin) && "string" === typeof input.msg && (undefined === input.state || "STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.load || "object" === typeof input.load && null !== input.load && false === Array.isArray(input.load) && $io2(input.load));
            const $io2 = (input: any): boolean => (undefined === input.cpu || "number" === typeof input.cpu && 0 <= input.cpu && 100 >= input.cpu) && (undefined === input.mem || "number" === typeof input.mem && 0 <= input.mem && 100 >= input.mem);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunLogByIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return ("object" === typeof value && null !== value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DockerRunLogCreateEntryData",
                            value: value
                        })) && $ao1(value, _path + $join(key), true && _exceptionable) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DockerRunLogCreateEntryData",
                            value: value
                        });
                    return true;
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.ts && !Number.isNaN(input.ts) && (0 <= input.ts || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "number (@minimum 0)",
                    value: input.ts
                })) || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "number",
                    value: input.ts
                })) && ("VERBOSE" === input.level || "NOTSET" === input.level || "DEBUG" === input.level || "INFO" === input.level || "WARNING" === input.level || "ERROR" === input.level || "CRITICAL" === input.level || $guard(_exceptionable, {
                    path: _path + ".level",
                    expected: "(\"CRITICAL\" | \"DEBUG\" | \"ERROR\" | \"INFO\" | \"NOTSET\" | \"VERBOSE\" | \"WARNING\")",
                    value: input.level
                })) && ("string" === typeof input.group || $guard(_exceptionable, {
                    path: _path + ".group",
                    expected: "string",
                    value: input.group
                })) && (undefined === input.origin || "string" === typeof input.origin || $guard(_exceptionable, {
                    path: _path + ".origin",
                    expected: "(string | undefined)",
                    value: input.origin
                })) && ("string" === typeof input.msg || $guard(_exceptionable, {
                    path: _path + ".msg",
                    expected: "string",
                    value: input.msg
                })) && (undefined === input.state || "STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\" | undefined)",
                    value: input.state
                })) && (undefined === input.load || ("object" === typeof input.load && null !== input.load && false === Array.isArray(input.load) || $guard(_exceptionable, {
                    path: _path + ".load",
                    expected: "(DockerRunLogDockerLoad | undefined)",
                    value: input.load
                })) && $ao2(input.load, _path + ".load", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".load",
                    expected: "(DockerRunLogDockerLoad | undefined)",
                    value: input.load
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cpu || "number" === typeof input.cpu && (0 <= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@minimum 0)",
                    value: input.cpu
                })) && (100 >= input.cpu || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "number (@maximum 100)",
                    value: input.cpu
                })) || $guard(_exceptionable, {
                    path: _path + ".cpu",
                    expected: "(number | undefined)",
                    value: input.cpu
                })) && (undefined === input.mem || "number" === typeof input.mem && (0 <= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@minimum 0)",
                    value: input.mem
                })) && (100 >= input.mem || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "number (@maximum 100)",
                    value: input.mem
                })) || $guard(_exceptionable, {
                    path: _path + ".mem",
                    expected: "(number | undefined)",
                    value: input.mem
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogCreateEntriesRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunLogCreateEntriesRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerRunLogByIdRequestBody): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.ts && 0 <= input.ts && ("VERBOSE" === input.level || "NOTSET" === input.level || "DEBUG" === input.level || "INFO" === input.level || "WARNING" === input.level || "ERROR" === input.level || "CRITICAL" === input.level) && "string" === typeof input.group && (undefined === input.origin || "string" === typeof input.origin) && "string" === typeof input.msg && (undefined === input.state || "STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.load || "object" === typeof input.load && null !== input.load && false === Array.isArray(input.load) && $io2(input.load));
        const $io2 = (input: any): boolean => (undefined === input.cpu || "number" === typeof input.cpu && 0 <= input.cpu && 100 >= input.cpu) && (undefined === input.mem || "number" === typeof input.mem && 0 <= input.mem && 100 >= input.mem);
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$so1(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        const $so1 = (input: any): any => `{${undefined === input.origin ? "" : `"origin":${undefined !== input.origin ? $string(input.origin) : undefined},`}${undefined === input.state ? "" : `"state":${undefined !== input.state ? (() => {
            if ("string" === typeof input.state)
                return $string(input.state);
            if ("string" === typeof input.state)
                return "\"" + input.state + "\"";
            $throws({
                expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\" | undefined)",
                value: input.state
            });
        })() : undefined},`}${undefined === input.load ? "" : `"load":${undefined !== input.load ? $so2(input.load) : undefined},`}"ts":${input.ts},"level":${(() => {
            if ("string" === typeof input.level)
                return $string(input.level);
            if ("string" === typeof input.level)
                return "\"" + input.level + "\"";
            $throws({
                expected: "(\"CRITICAL\" | \"DEBUG\" | \"ERROR\" | \"INFO\" | \"NOTSET\" | \"VERBOSE\" | \"WARNING\")",
                value: input.level
            });
        })()},"group":${$string(input.group)},"msg":${$string(input.msg)}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.cpu ? "" : `"cpu":${undefined !== input.cpu ? input.cpu : undefined},`}${undefined === input.mem ? "" : `"mem":${undefined !== input.mem ? input.mem : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerRunScheduledByDatasetIdRequestBody = DockerRunScheduledCreateRequest;
export const CreateDockerRunScheduledByDatasetIdRequestBodySanitizer = DockerRunScheduledCreateRequestFromJSON;
export const CreateDockerRunScheduledByDatasetIdRequestBodyValidator = DockerRunScheduledCreateRequestValidator;
export const CreateDockerRunScheduledByDatasetIdTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerRunScheduledByDatasetIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerRunScheduledByDatasetIdRequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.configId && $is_custom("pattern_DockerRunScheduledCreateRequest_configId", "string", "", input.configId) && ("LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority) && (undefined === input.runsOn || "object" === typeof input.runsOn && null !== input.runsOn && $io1(input.runsOn, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["configId", "priority", "runsOn", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunScheduledByDatasetIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.configId && ($is_custom("pattern_DockerRunScheduledCreateRequest_configId", "string", "", input.configId) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string (@pattern_DockerRunScheduledCreateRequest_configId)",
                    value: input.configId
                })) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string",
                    value: input.configId
                })) && ("LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority || $guard(_exceptionable, {
                    path: _path + ".priority",
                    expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\")",
                    value: input.priority
                })) && (undefined === input.runsOn || ("object" === typeof input.runsOn && null !== input.runsOn || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && $ao1(input.runsOn, _path + ".runsOn", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["configId", "priority", "runsOn", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerRunScheduledByDatasetIdTypiaAssertStringify = (input: CreateDockerRunScheduledByDatasetIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerRunScheduledByDatasetIdRequestBody => {
        const __is = (input: any): input is CreateDockerRunScheduledByDatasetIdRequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => "string" === typeof input.configId && $is_custom("pattern_DockerRunScheduledCreateRequest_configId", "string", "", input.configId) && ("LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority) && (undefined === input.runsOn || "object" === typeof input.runsOn && null !== input.runsOn && $io1(input.runsOn)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerRunScheduledByDatasetIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.configId && ($is_custom("pattern_DockerRunScheduledCreateRequest_configId", "string", "", input.configId) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string (@pattern_DockerRunScheduledCreateRequest_configId)",
                    value: input.configId
                })) || $guard(_exceptionable, {
                    path: _path + ".configId",
                    expected: "string",
                    value: input.configId
                })) && ("LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority || $guard(_exceptionable, {
                    path: _path + ".priority",
                    expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\")",
                    value: input.priority
                })) && (undefined === input.runsOn || ("object" === typeof input.runsOn && null !== input.runsOn || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && $ao1(input.runsOn, _path + ".runsOn", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerRunScheduledByDatasetIdRequestBody): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "string" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.runsOn ? "" : `"runsOn":${undefined !== input.runsOn ? $so1(input.runsOn) : undefined},`}${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"configId":${$string(input.configId)},"priority":${(() => {
            if ("string" === typeof input.priority)
                return $string(input.priority);
            if ("string" === typeof input.priority)
                return "\"" + input.priority + "\"";
            $throws({
                expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\")",
                value: input.priority
            });
        })()}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$string(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerWorkerConfigRequestBody = DockerWorkerConfigCreateRequest;
export const CreateDockerWorkerConfigRequestBodySanitizer = DockerWorkerConfigCreateRequestFromJSON;
export const CreateDockerWorkerConfigRequestBodyValidator = DockerWorkerConfigCreateRequestValidator;
export const CreateDockerWorkerConfigTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerWorkerConfigRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerWorkerConfigRequestBody => {
            const $join = (typia.createAssertEquals as any).join;
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config, true && _exceptionable) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (null === input.docker || undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker, true && _exceptionable)) && (null === input.lightly || undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io3(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io4(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return false;
            });
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return false;
            });
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index1: number) => "object" === typeof elem && null !== elem && $io5(elem, true && _exceptionable))) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io6(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io7(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index2: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io8(input.target, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io8 = (input: any, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (null === input.docker || undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && (null === input.lightly || undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && $ao3(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao4(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                });
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao5(elem, _path + ".strategies[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao6(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao7(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index2: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index2 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao8(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerWorkerConfigTypiaAssertStringify = (input: CreateDockerWorkerConfigRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerWorkerConfigRequestBody => {
        const __is = (input: any): input is CreateDockerWorkerConfigRequestBody => {
            const $join = (typia.createAssertStringify as any).join;
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io1 = (input: any): boolean => "FULL" === input.workerType && (null === input.docker || undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (null === input.lightly || undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io3(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io4(input.selection));
            const $io2 = (input: any): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return true;
            });
            const $io3 = (input: any): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return true;
            });
            const $io4 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io5(elem)));
            const $io5 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io6(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io7(input.strategy));
            const $io6 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io7 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io8(input.target));
            const $io8 = (input: any): boolean => true;
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (null === input.docker || undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && (null === input.lightly || undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && $ao3(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao4(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return true;
                });
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return true;
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao5(elem, _path + ".strategies[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao6(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao7(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                }));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index2: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index2 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao8(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                }));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => true;
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerWorkerConfigRequestBody): string => {
        const $io1 = (input: any): boolean => "FULL" === input.workerType && (null === input.docker || undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (null === input.lightly || undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io3(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io4(input.selection));
        const $io2 = (input: any): boolean => Object.keys(input).every((key: any) => {
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/(.*)/).test(key))
                return true;
            return true;
        });
        const $io3 = (input: any): boolean => Object.keys(input).every((key: any) => {
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/(.*)/).test(key))
                return true;
            return true;
        });
        const $io4 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io5(elem)));
        const $io5 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io6(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io7(input.strategy));
        const $io6 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io7 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io8(input.target));
        const $io8 = (input: any): boolean => true;
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"config":${$so1(input.config)}}`;
        const $so1 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? null !== input.docker ? $so2(input.docker) : "null" : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? null !== input.lightly ? $so3(input.lightly) : "null" : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so4(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so2 = (input: any): any => `{${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; return `${JSON.stringify(key)}:${undefined !== value ? JSON.stringify(value) : undefined}`; }).filter((str: any) => "" !== str).join(",")}}`;
        const $so3 = (input: any): any => `{${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; return `${JSON.stringify(key)}:${undefined !== value ? JSON.stringify(value) : undefined}`; }).filter((str: any) => "" !== str).join(",")}}`;
        const $so4 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so5(elem)).join(",")}]`}}`;
        const $so5 = (input: any): any => `{"input":${$so6(input.input)},"strategy":${$so7(input.strategy)}}`;
        const $so6 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so7 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerWorkerConfigV2RequestBody = DockerWorkerConfigV2CreateRequest;
export const CreateDockerWorkerConfigV2RequestBodySanitizer = DockerWorkerConfigV2CreateRequestFromJSON;
export const CreateDockerWorkerConfigV2RequestBodyValidator = DockerWorkerConfigV2CreateRequestValidator;
export const CreateDockerWorkerConfigV2TypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerWorkerConfigV2RequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerWorkerConfigV2RequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config, true && _exceptionable) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker, true && _exceptionable)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io14(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io5(input.objectLevel, true && _exceptionable)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io6(input.stoppingCondition, true && _exceptionable)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "method", "normalizeEmbeddings", "outputImageFormat", "objectLevel", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "stoppingCondition", "uploadReport"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["corruptionThreshold"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bypassVerify", "enableDatapoolUpdate", "processAll"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["cropDatasetName", "padding", "taskName"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance) && (undefined === input.nSamples || "number" === typeof input.nSamples) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minDistance", "nSamples"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader, true && _exceptionable)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io9(input.model, true && _exceptionable)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io10(input.trainer, true && _exceptionable)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion, true && _exceptionable)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer, true && _exceptionable)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io13(input.collate, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io8 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io9 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io10 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io11 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["temperature"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io12 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["lr", "weightDecay"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io13 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io14 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index2: number) => "object" === typeof elem && null !== elem && $io15(elem, true && _exceptionable))) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io15 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io16(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io17(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io16 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index3: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io17 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io18 = (input: any, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigV2RequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && $ao7(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao14(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao4(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.method || "coreset" === input.method || "random" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"coreset\" | \"random\" | undefined)",
                    value: input.method
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.objectLevel || ("object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && $ao5(input.objectLevel, _path + ".objectLevel", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao6(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "method", "normalizeEmbeddings", "outputImageFormat", "objectLevel", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "stoppingCondition", "uploadReport"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["corruptionThreshold"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bypassVerify", "enableDatapoolUpdate", "processAll"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName)",
                    value: input.cropDatasetName
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "(string | undefined)",
                    value: input.cropDatasetName
                })) && (undefined === input.padding || "number" === typeof input.padding || $guard(_exceptionable, {
                    path: _path + ".padding",
                    expected: "(number | undefined)",
                    value: input.padding
                })) && (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["cropDatasetName", "padding", "taskName"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (undefined === input.nSamples || "number" === typeof input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minDistance", "nSamples"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao8(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && $ao9(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao10(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao11(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao12(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao13(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["temperature"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["lr", "weightDecay"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index2: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao15(elem, _path + ".strategies[" + _index2 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao16(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao17(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao16 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index3: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index3 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao17 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao18 = (input: any, _path: string, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2CreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2CreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerWorkerConfigV2TypiaAssertStringify = (input: CreateDockerWorkerConfigV2RequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerWorkerConfigV2RequestBody => {
        const __is = (input: any): input is CreateDockerWorkerConfigV2RequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io1 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io14(input.selection));
            const $io2 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io5(input.objectLevel)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io6(input.stoppingCondition)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport);
            const $io3 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
            const $io4 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll);
            const $io5 = (input: any): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding && !Number.isNaN(input.padding)) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName));
            const $io6 = (input: any): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance)) && (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples));
            const $io7 = (input: any): boolean => (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io9(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io10(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io13(input.collate));
            const $io8 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
            const $io9 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
            const $io10 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
            const $io11 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && 0 < input.temperature;
            const $io12 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
            const $io13 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem))) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb);
            const $io14 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io15(elem)));
            const $io15 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io16(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io17(input.strategy));
            const $io16 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io17 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target));
            const $io18 = (input: any): boolean => true;
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigV2RequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && $ao7(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao14(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao4(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.method || "coreset" === input.method || "random" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"coreset\" | \"random\" | undefined)",
                    value: input.method
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.objectLevel || ("object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && $ao5(input.objectLevel, _path + ".objectLevel", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao6(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName)",
                    value: input.cropDatasetName
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "(string | undefined)",
                    value: input.cropDatasetName
                })) && (undefined === input.padding || "number" === typeof input.padding && !Number.isNaN(input.padding) || $guard(_exceptionable, {
                    path: _path + ".padding",
                    expected: "(number | undefined)",
                    value: input.padding
                })) && (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                }));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance) || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                }));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao8(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && $ao9(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao10(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao11(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao12(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao13(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                }));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                }));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                }));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                }));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                });
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                }));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                }));
                const $ao14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index2: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao15(elem, _path + ".strategies[" + _index2 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                }));
                const $ao15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao16(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao17(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                }));
                const $ao16 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index3: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index3 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao17 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                }));
                const $ao18 = (input: any, _path: string, _exceptionable: boolean = true): boolean => true;
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2CreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV2CreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerWorkerConfigV2RequestBody): string => {
        const $io1 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io14(input.selection));
        const $io2 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io5(input.objectLevel)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io6(input.stoppingCondition)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport);
        const $io3 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
        const $io4 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll);
        const $io5 = (input: any): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName));
        const $io6 = (input: any): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance) && (undefined === input.nSamples || "number" === typeof input.nSamples);
        const $io7 = (input: any): boolean => (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io9(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io10(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io13(input.collate));
        const $io8 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
        const $io9 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
        const $io10 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
        const $io11 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature;
        const $io12 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
        const $io13 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb);
        const $io14 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io15(elem)));
        const $io15 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io16(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io17(input.strategy));
        const $io16 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io17 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target));
        const $io18 = (input: any): boolean => true;
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"config":${$so1(input.config)}}`;
        const $so1 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? $so2(input.docker) : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? $so7(input.lightly) : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so14(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so3(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so4(input.datasource) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.method ? "" : `"method":${undefined !== input.method ? (() => {
            if ("string" === typeof input.method)
                return $string(input.method);
            if ("string" === typeof input.method)
                return "\"" + input.method + "\"";
            $throws({
                expected: "(\"coreset\" | \"random\" | undefined)",
                value: input.method
            });
        })() : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.objectLevel ? "" : `"objectLevel":${undefined !== input.objectLevel ? $so5(input.objectLevel) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.stoppingCondition ? "" : `"stoppingCondition":${undefined !== input.stoppingCondition ? $so6(input.stoppingCondition) : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{${$tail(`${undefined === input.corruptionThreshold ? "" : `"corruptionThreshold":${undefined !== input.corruptionThreshold ? input.corruptionThreshold : undefined}`}`)}}`;
        const $so4 = (input: any): any => `{${$tail(`${undefined === input.bypassVerify ? "" : `"bypassVerify":${undefined !== input.bypassVerify ? input.bypassVerify : undefined},`}${undefined === input.enableDatapoolUpdate ? "" : `"enableDatapoolUpdate":${undefined !== input.enableDatapoolUpdate ? input.enableDatapoolUpdate : undefined},`}${undefined === input.processAll ? "" : `"processAll":${undefined !== input.processAll ? input.processAll : undefined}`}`)}}`;
        const $so5 = (input: any): any => `{${$tail(`${undefined === input.cropDatasetName ? "" : `"cropDatasetName":${undefined !== input.cropDatasetName ? $string(input.cropDatasetName) : undefined},`}${undefined === input.padding ? "" : `"padding":${undefined !== input.padding ? input.padding : undefined},`}${undefined === input.taskName ? "" : `"taskName":${undefined !== input.taskName ? $string(input.taskName) : undefined}`}`)}}`;
        const $so6 = (input: any): any => `{${$tail(`${undefined === input.minDistance ? "" : `"minDistance":${undefined !== input.minDistance ? input.minDistance : undefined},`}${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined}`}`)}}`;
        const $so7 = (input: any): any => `{${$tail(`${undefined === input.loader ? "" : `"loader":${undefined !== input.loader ? $so8(input.loader) : undefined},`}${undefined === input.model ? "" : `"model":${undefined !== input.model ? $so9(input.model) : undefined},`}${undefined === input.trainer ? "" : `"trainer":${undefined !== input.trainer ? $so10(input.trainer) : undefined},`}${undefined === input.criterion ? "" : `"criterion":${undefined !== input.criterion ? $so11(input.criterion) : undefined},`}${undefined === input.optimizer ? "" : `"optimizer":${undefined !== input.optimizer ? $so12(input.optimizer) : undefined},`}${undefined === input.collate ? "" : `"collate":${undefined !== input.collate ? $so13(input.collate) : undefined}`}`)}}`;
        const $so8 = (input: any): any => `{${$tail(`${undefined === input.batchSize ? "" : `"batchSize":${undefined !== input.batchSize ? input.batchSize : undefined},`}${undefined === input.shuffle ? "" : `"shuffle":${undefined !== input.shuffle ? input.shuffle : undefined},`}${undefined === input.numWorkers ? "" : `"numWorkers":${undefined !== input.numWorkers ? input.numWorkers : undefined},`}${undefined === input.dropLast ? "" : `"dropLast":${undefined !== input.dropLast ? input.dropLast : undefined}`}`)}}`;
        const $so9 = (input: any): any => `{${$tail(`${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.outDim ? "" : `"outDim":${undefined !== input.outDim ? input.outDim : undefined},`}${undefined === input.numFtrs ? "" : `"numFtrs":${undefined !== input.numFtrs ? input.numFtrs : undefined},`}${undefined === input.width ? "" : `"width":${undefined !== input.width ? input.width : undefined}`}`)}}`;
        const $so10 = (input: any): any => `{${$tail(`${undefined === input.gpus ? "" : `"gpus":${undefined !== input.gpus ? input.gpus : undefined},`}${undefined === input.maxEpochs ? "" : `"maxEpochs":${undefined !== input.maxEpochs ? input.maxEpochs : undefined},`}${undefined === input.precision ? "" : `"precision":${undefined !== input.precision ? input.precision : undefined}`}`)}}`;
        const $so11 = (input: any): any => `{${$tail(`${undefined === input.temperature ? "" : `"temperature":${undefined !== input.temperature ? input.temperature : undefined}`}`)}}`;
        const $so12 = (input: any): any => `{${$tail(`${undefined === input.lr ? "" : `"lr":${undefined !== input.lr ? input.lr : undefined},`}${undefined === input.weightDecay ? "" : `"weightDecay":${undefined !== input.weightDecay ? input.weightDecay : undefined}`}`)}}`;
        const $so13 = (input: any): any => `{${$tail(`${undefined === input.inputSize ? "" : `"inputSize":${undefined !== input.inputSize ? input.inputSize : undefined},`}${undefined === input.cjProb ? "" : `"cjProb":${undefined !== input.cjProb ? input.cjProb : undefined},`}${undefined === input.cjBright ? "" : `"cjBright":${undefined !== input.cjBright ? input.cjBright : undefined},`}${undefined === input.cjContrast ? "" : `"cjContrast":${undefined !== input.cjContrast ? input.cjContrast : undefined},`}${undefined === input.cjSat ? "" : `"cjSat":${undefined !== input.cjSat ? input.cjSat : undefined},`}${undefined === input.cjHue ? "" : `"cjHue":${undefined !== input.cjHue ? input.cjHue : undefined},`}${undefined === input.minScale ? "" : `"minScale":${undefined !== input.minScale ? input.minScale : undefined},`}${undefined === input.randomGrayScale ? "" : `"randomGrayScale":${undefined !== input.randomGrayScale ? input.randomGrayScale : undefined},`}${undefined === input.gaussianBlur ? "" : `"gaussianBlur":${undefined !== input.gaussianBlur ? input.gaussianBlur : undefined},`}${undefined === input.kernelSize ? "" : `"kernelSize":${undefined !== input.kernelSize ? input.kernelSize : undefined},`}${undefined === input.sigmas ? "" : `"sigmas":${undefined !== input.sigmas ? `[${input.sigmas.map((elem: any) => elem).join(",")}]` : undefined},`}${undefined === input.vfProb ? "" : `"vfProb":${undefined !== input.vfProb ? input.vfProb : undefined},`}${undefined === input.hfProb ? "" : `"hfProb":${undefined !== input.hfProb ? input.hfProb : undefined},`}${undefined === input.rrProb ? "" : `"rrProb":${undefined !== input.rrProb ? input.rrProb : undefined}`}`)}}`;
        const $so14 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so15(elem)).join(",")}]`}}`;
        const $so15 = (input: any): any => `{"input":${$so16(input.input)},"strategy":${$so17(input.strategy)}}`;
        const $so16 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so17 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerWorkerConfigV3RequestBody = DockerWorkerConfigV3CreateRequest;
export const CreateDockerWorkerConfigV3RequestBodySanitizer = DockerWorkerConfigV3CreateRequestFromJSON;
export const CreateDockerWorkerConfigV3RequestBodyValidator = DockerWorkerConfigV3CreateRequestValidator;
export const CreateDockerWorkerConfigV3TypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerWorkerConfigV3RequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerWorkerConfigV3RequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config, true && _exceptionable) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker, true && _exceptionable)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io15(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io6(input.training, true && _exceptionable)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "shutdownWhenJobFinished"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["corruptionThreshold"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io5(input.inputExpiration, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bypassVerify", "enableDatapoolUpdate", "processAll", "inputExpiration"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.minDaysToExpiration && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minDaysToExpiration", "handlingStrategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["taskName"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io8(input.checkpointCallback, true && _exceptionable)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io9(input.loader, true && _exceptionable)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io10(input.model, true && _exceptionable)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io11(input.trainer, true && _exceptionable)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io12(input.criterion, true && _exceptionable)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io13(input.optimizer, true && _exceptionable)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io14(input.collate, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["seed", "checkpointCallback", "loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io8 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.saveLast || "boolean" === typeof input.saveLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["saveLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io9 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io10 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io11 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io12 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["temperature"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io13 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["lr", "weightDecay"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io14 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any, _index2: number) => "number" === typeof elem)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb", "rrDegrees"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io15 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index3: number) => "object" === typeof elem && null !== elem && $io16(elem, true && _exceptionable))) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io16 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io17(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io18(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io17 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index4: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io18 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io19(input.target, true && _exceptionable)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io20(input.targetRange, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target", "numNearestNeighbors", "stoppingConditionMinimumTypicality", "strength", "stoppingConditionMaxSum", "targetRange"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io19 = (input: any, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            });
            const $io20 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.minSum || "number" === typeof input.minSum && 0 <= input.minSum) && (undefined === input.maxSum || "number" === typeof input.maxSum && 0 <= input.maxSum) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minSum", "maxSum"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigV3RequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && $ao7(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                })) && $ao15(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV3Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao4(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao6(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "shutdownWhenJobFinished"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["corruptionThreshold"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (undefined === input.inputExpiration || ("object" === typeof input.inputExpiration && null !== input.inputExpiration || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && $ao5(input.inputExpiration, _path + ".inputExpiration", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bypassVerify", "enableDatapoolUpdate", "processAll", "inputExpiration"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.minDaysToExpiration && (0 <= input.minDaysToExpiration || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number (@minimum 0)",
                    value: input.minDaysToExpiration
                })) || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number",
                    value: input.minDaysToExpiration
                })) && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy || $guard(_exceptionable, {
                    path: _path + ".handlingStrategy",
                    expected: "(\"ABORT\" | \"SKIP\")",
                    value: input.handlingStrategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minDaysToExpiration", "handlingStrategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV3DockerTraining_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["taskName"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && (Math.floor(input.seed) === input.seed || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) && (-2147483648 <= input.seed && input.seed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "(number | undefined)",
                    value: input.seed
                })) && (undefined === input.checkpointCallback || ("object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && $ao8(input.checkpointCallback, _path + ".checkpointCallback", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao9(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && $ao10(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao11(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao12(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao13(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao14(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["seed", "checkpointCallback", "loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.saveLast || "boolean" === typeof input.saveLast || $guard(_exceptionable, {
                    path: _path + ".saveLast",
                    expected: "(boolean | undefined)",
                    value: input.saveLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["saveLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["temperature"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["lr", "weightDecay"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (null === input.rrDegrees || undefined === input.rrDegrees || (Array.isArray(input.rrDegrees) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && input.rrDegrees.every((elem: any, _index2: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".rrDegrees[" + _index2 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb", "rrDegrees"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index3: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index3 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) && $ao16(elem, _path + ".strategies[" + _index3 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index3 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao16 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && $ao17(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                })) && $ao18(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao17 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index4: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index4 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao18 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao19(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && (Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (2 <= input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@minimum 2)",
                    value: input.numNearestNeighbors
                })) || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "(number | undefined)",
                    value: input.numNearestNeighbors
                })) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && (0 < input.stoppingConditionMinimumTypicality || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.stoppingConditionMinimumTypicality
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMinimumTypicality
                })) && (undefined === input.strength || "number" === typeof input.strength && (-1000000000 <= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@minimum -1000000000)",
                    value: input.strength
                })) && (1000000000 >= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@maximum 1000000000)",
                    value: input.strength
                })) || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "(number | undefined)",
                    value: input.strength
                })) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && (0 <= input.stoppingConditionMaxSum || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "number (@minimum 0)",
                    value: input.stoppingConditionMaxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMaxSum
                })) && (undefined === input.targetRange || ("object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && $ao20(input.targetRange, _path + ".targetRange", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target", "numNearestNeighbors", "stoppingConditionMinimumTypicality", "strength", "stoppingConditionMaxSum", "targetRange"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao19 = (input: any, _path: string, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao20 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minSum || "number" === typeof input.minSum && (0 <= input.minSum || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "number (@minimum 0)",
                    value: input.minSum
                })) || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "(number | undefined)",
                    value: input.minSum
                })) && (undefined === input.maxSum || "number" === typeof input.maxSum && (0 <= input.maxSum || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "number (@minimum 0)",
                    value: input.maxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "(number | undefined)",
                    value: input.maxSum
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minSum", "maxSum"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3CreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3CreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerWorkerConfigV3TypiaAssertStringify = (input: CreateDockerWorkerConfigV3RequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerWorkerConfigV3RequestBody => {
        const __is = (input: any): input is CreateDockerWorkerConfigV3RequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io1 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io15(input.selection));
            const $io2 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io6(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished);
            const $io3 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
            const $io4 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io5(input.inputExpiration));
            const $io5 = (input: any): boolean => "number" === typeof input.minDaysToExpiration && !Number.isNaN(input.minDaysToExpiration) && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy);
            const $io6 = (input: any): boolean => undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName);
            const $io7 = (input: any): boolean => (undefined === input.seed || "number" === typeof input.seed && !Number.isNaN(input.seed) && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io8(input.checkpointCallback)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io9(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io10(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io11(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io12(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io13(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io14(input.collate));
            const $io8 = (input: any): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast;
            const $io9 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
            const $io10 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
            const $io11 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
            const $io12 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && 0 < input.temperature;
            const $io13 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
            const $io14 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem))) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem)));
            const $io15 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io16(elem)));
            const $io16 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io17(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io18(input.strategy));
            const $io17 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io18 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io19(input.target)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && !Number.isNaN(input.numNearestNeighbors) && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && !Number.isNaN(input.stoppingConditionMinimumTypicality) && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && !Number.isNaN(input.stoppingConditionMaxSum) && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io20(input.targetRange));
            const $io19 = (input: any): boolean => true;
            const $io20 = (input: any): boolean => (undefined === input.minSum || "number" === typeof input.minSum && !Number.isNaN(input.minSum) && 0 <= input.minSum) && (undefined === input.maxSum || "number" === typeof input.maxSum && !Number.isNaN(input.maxSum) && 0 <= input.maxSum);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigV3RequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && $ao7(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                })) && $ao15(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV3Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao4(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao6(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (undefined === input.inputExpiration || ("object" === typeof input.inputExpiration && null !== input.inputExpiration || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && $ao5(input.inputExpiration, _path + ".inputExpiration", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.minDaysToExpiration && !Number.isNaN(input.minDaysToExpiration) && (0 <= input.minDaysToExpiration || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number (@minimum 0)",
                    value: input.minDaysToExpiration
                })) || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number",
                    value: input.minDaysToExpiration
                })) && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy || $guard(_exceptionable, {
                    path: _path + ".handlingStrategy",
                    expected: "(\"ABORT\" | \"SKIP\")",
                    value: input.handlingStrategy
                }));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV3DockerTraining_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                });
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && !Number.isNaN(input.seed) && (Math.floor(input.seed) === input.seed || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) && (-2147483648 <= input.seed && input.seed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "(number | undefined)",
                    value: input.seed
                })) && (undefined === input.checkpointCallback || ("object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && $ao8(input.checkpointCallback, _path + ".checkpointCallback", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao9(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && $ao10(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao11(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao12(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao13(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao14(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                }));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast || $guard(_exceptionable, {
                    path: _path + ".saveLast",
                    expected: "(boolean | undefined)",
                    value: input.saveLast
                });
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                }));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                }));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                }));
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                });
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                }));
                const $ao14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (null === input.rrDegrees || undefined === input.rrDegrees || (Array.isArray(input.rrDegrees) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && input.rrDegrees.every((elem: any, _index2: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees[" + _index2 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                }));
                const $ao15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index3: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index3 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) && $ao16(elem, _path + ".strategies[" + _index3 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index3 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                }));
                const $ao16 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && $ao17(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                })) && $ao18(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                }));
                const $ao17 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index4: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index4 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao18 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao19(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && !Number.isNaN(input.numNearestNeighbors) && (Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (2 <= input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@minimum 2)",
                    value: input.numNearestNeighbors
                })) || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "(number | undefined)",
                    value: input.numNearestNeighbors
                })) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && !Number.isNaN(input.stoppingConditionMinimumTypicality) && (0 < input.stoppingConditionMinimumTypicality || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.stoppingConditionMinimumTypicality
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMinimumTypicality
                })) && (undefined === input.strength || "number" === typeof input.strength && (-1000000000 <= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@minimum -1000000000)",
                    value: input.strength
                })) && (1000000000 >= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@maximum 1000000000)",
                    value: input.strength
                })) || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "(number | undefined)",
                    value: input.strength
                })) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && !Number.isNaN(input.stoppingConditionMaxSum) && (0 <= input.stoppingConditionMaxSum || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "number (@minimum 0)",
                    value: input.stoppingConditionMaxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMaxSum
                })) && (undefined === input.targetRange || ("object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && $ao20(input.targetRange, _path + ".targetRange", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                }));
                const $ao19 = (input: any, _path: string, _exceptionable: boolean = true): boolean => true;
                const $ao20 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minSum || "number" === typeof input.minSum && !Number.isNaN(input.minSum) && (0 <= input.minSum || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "number (@minimum 0)",
                    value: input.minSum
                })) || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "(number | undefined)",
                    value: input.minSum
                })) && (undefined === input.maxSum || "number" === typeof input.maxSum && !Number.isNaN(input.maxSum) && (0 <= input.maxSum || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "number (@minimum 0)",
                    value: input.maxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "(number | undefined)",
                    value: input.maxSum
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3CreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3CreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerWorkerConfigV3RequestBody): string => {
        const $io1 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io15(input.selection));
        const $io2 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io6(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished);
        const $io3 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
        const $io4 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io5(input.inputExpiration));
        const $io5 = (input: any): boolean => "number" === typeof input.minDaysToExpiration && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy);
        const $io6 = (input: any): boolean => undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName);
        const $io7 = (input: any): boolean => (undefined === input.seed || "number" === typeof input.seed && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io8(input.checkpointCallback)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io9(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io10(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io11(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io12(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io13(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io14(input.collate));
        const $io8 = (input: any): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast;
        const $io9 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
        const $io10 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
        const $io11 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
        const $io12 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature;
        const $io13 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
        const $io14 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any) => "number" === typeof elem));
        const $io15 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io16(elem)));
        const $io16 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io17(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io18(input.strategy));
        const $io17 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io18 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io19(input.target)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io20(input.targetRange));
        const $io19 = (input: any): boolean => true;
        const $io20 = (input: any): boolean => (undefined === input.minSum || "number" === typeof input.minSum && 0 <= input.minSum) && (undefined === input.maxSum || "number" === typeof input.maxSum && 0 <= input.maxSum);
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"config":${$so1(input.config)}}`;
        const $so1 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? $so2(input.docker) : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? $so7(input.lightly) : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so15(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.checkpointRunId ? "" : `"checkpointRunId":${undefined !== input.checkpointRunId ? $string(input.checkpointRunId) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so3(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so4(input.datasource) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.training ? "" : `"training":${undefined !== input.training ? $so6(input.training) : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.numProcesses ? "" : `"numProcesses":${undefined !== input.numProcesses ? input.numProcesses : undefined},`}${undefined === input.numThreads ? "" : `"numThreads":${undefined !== input.numThreads ? input.numThreads : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined},`}${undefined === input.shutdownWhenJobFinished ? "" : `"shutdownWhenJobFinished":${undefined !== input.shutdownWhenJobFinished ? input.shutdownWhenJobFinished : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{${$tail(`${undefined === input.corruptionThreshold ? "" : `"corruptionThreshold":${undefined !== input.corruptionThreshold ? input.corruptionThreshold : undefined}`}`)}}`;
        const $so4 = (input: any): any => `{${$tail(`${undefined === input.bypassVerify ? "" : `"bypassVerify":${undefined !== input.bypassVerify ? input.bypassVerify : undefined},`}${undefined === input.enableDatapoolUpdate ? "" : `"enableDatapoolUpdate":${undefined !== input.enableDatapoolUpdate ? input.enableDatapoolUpdate : undefined},`}${undefined === input.processAll ? "" : `"processAll":${undefined !== input.processAll ? input.processAll : undefined},`}${undefined === input.inputExpiration ? "" : `"inputExpiration":${undefined !== input.inputExpiration ? $so5(input.inputExpiration) : undefined}`}`)}}`;
        const $so5 = (input: any): any => `{"minDaysToExpiration":${input.minDaysToExpiration},"handlingStrategy":${(() => {
            if ("string" === typeof input.handlingStrategy)
                return $string(input.handlingStrategy);
            if ("string" === typeof input.handlingStrategy)
                return "\"" + input.handlingStrategy + "\"";
            $throws({
                expected: "(\"ABORT\" | \"SKIP\")",
                value: input.handlingStrategy
            });
        })()}}`;
        const $so6 = (input: any): any => `{${$tail(`${undefined === input.taskName ? "" : `"taskName":${undefined !== input.taskName ? $string(input.taskName) : undefined}`}`)}}`;
        const $so7 = (input: any): any => `{${$tail(`${undefined === input.seed ? "" : `"seed":${undefined !== input.seed ? input.seed : undefined},`}${undefined === input.checkpointCallback ? "" : `"checkpointCallback":${undefined !== input.checkpointCallback ? $so8(input.checkpointCallback) : undefined},`}${undefined === input.loader ? "" : `"loader":${undefined !== input.loader ? $so9(input.loader) : undefined},`}${undefined === input.model ? "" : `"model":${undefined !== input.model ? $so10(input.model) : undefined},`}${undefined === input.trainer ? "" : `"trainer":${undefined !== input.trainer ? $so11(input.trainer) : undefined},`}${undefined === input.criterion ? "" : `"criterion":${undefined !== input.criterion ? $so12(input.criterion) : undefined},`}${undefined === input.optimizer ? "" : `"optimizer":${undefined !== input.optimizer ? $so13(input.optimizer) : undefined},`}${undefined === input.collate ? "" : `"collate":${undefined !== input.collate ? $so14(input.collate) : undefined}`}`)}}`;
        const $so8 = (input: any): any => `{${$tail(`${undefined === input.saveLast ? "" : `"saveLast":${undefined !== input.saveLast ? input.saveLast : undefined}`}`)}}`;
        const $so9 = (input: any): any => `{${$tail(`${undefined === input.batchSize ? "" : `"batchSize":${undefined !== input.batchSize ? input.batchSize : undefined},`}${undefined === input.shuffle ? "" : `"shuffle":${undefined !== input.shuffle ? input.shuffle : undefined},`}${undefined === input.numWorkers ? "" : `"numWorkers":${undefined !== input.numWorkers ? input.numWorkers : undefined},`}${undefined === input.dropLast ? "" : `"dropLast":${undefined !== input.dropLast ? input.dropLast : undefined}`}`)}}`;
        const $so10 = (input: any): any => `{${$tail(`${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.outDim ? "" : `"outDim":${undefined !== input.outDim ? input.outDim : undefined},`}${undefined === input.numFtrs ? "" : `"numFtrs":${undefined !== input.numFtrs ? input.numFtrs : undefined},`}${undefined === input.width ? "" : `"width":${undefined !== input.width ? input.width : undefined}`}`)}}`;
        const $so11 = (input: any): any => `{${$tail(`${undefined === input.gpus ? "" : `"gpus":${undefined !== input.gpus ? input.gpus : undefined},`}${undefined === input.maxEpochs ? "" : `"maxEpochs":${undefined !== input.maxEpochs ? input.maxEpochs : undefined},`}${undefined === input.precision ? "" : `"precision":${undefined !== input.precision ? input.precision : undefined}`}`)}}`;
        const $so12 = (input: any): any => `{${$tail(`${undefined === input.temperature ? "" : `"temperature":${undefined !== input.temperature ? input.temperature : undefined}`}`)}}`;
        const $so13 = (input: any): any => `{${$tail(`${undefined === input.lr ? "" : `"lr":${undefined !== input.lr ? input.lr : undefined},`}${undefined === input.weightDecay ? "" : `"weightDecay":${undefined !== input.weightDecay ? input.weightDecay : undefined}`}`)}}`;
        const $so14 = (input: any): any => `{${$tail(`${undefined === input.inputSize ? "" : `"inputSize":${undefined !== input.inputSize ? input.inputSize : undefined},`}${undefined === input.cjProb ? "" : `"cjProb":${undefined !== input.cjProb ? input.cjProb : undefined},`}${undefined === input.cjBright ? "" : `"cjBright":${undefined !== input.cjBright ? input.cjBright : undefined},`}${undefined === input.cjContrast ? "" : `"cjContrast":${undefined !== input.cjContrast ? input.cjContrast : undefined},`}${undefined === input.cjSat ? "" : `"cjSat":${undefined !== input.cjSat ? input.cjSat : undefined},`}${undefined === input.cjHue ? "" : `"cjHue":${undefined !== input.cjHue ? input.cjHue : undefined},`}${undefined === input.minScale ? "" : `"minScale":${undefined !== input.minScale ? input.minScale : undefined},`}${undefined === input.randomGrayScale ? "" : `"randomGrayScale":${undefined !== input.randomGrayScale ? input.randomGrayScale : undefined},`}${undefined === input.gaussianBlur ? "" : `"gaussianBlur":${undefined !== input.gaussianBlur ? input.gaussianBlur : undefined},`}${undefined === input.kernelSize ? "" : `"kernelSize":${undefined !== input.kernelSize ? input.kernelSize : undefined},`}${undefined === input.sigmas ? "" : `"sigmas":${undefined !== input.sigmas ? `[${input.sigmas.map((elem: any) => elem).join(",")}]` : undefined},`}${undefined === input.vfProb ? "" : `"vfProb":${undefined !== input.vfProb ? input.vfProb : undefined},`}${undefined === input.hfProb ? "" : `"hfProb":${undefined !== input.hfProb ? input.hfProb : undefined},`}${undefined === input.rrProb ? "" : `"rrProb":${undefined !== input.rrProb ? input.rrProb : undefined},`}${undefined === input.rrDegrees ? "" : `"rrDegrees":${undefined !== input.rrDegrees ? null !== input.rrDegrees ? `[${input.rrDegrees.map((elem: any) => elem).join(",")}]` : "null" : undefined}`}`)}}`;
        const $so15 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so16(elem)).join(",")}]`}}`;
        const $so16 = (input: any): any => `{"input":${$so17(input.input)},"strategy":${$so18(input.strategy)}}`;
        const $so17 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so18 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}${undefined === input.numNearestNeighbors ? "" : `"numNearestNeighbors":${undefined !== input.numNearestNeighbors ? input.numNearestNeighbors : undefined},`}${undefined === input.stoppingConditionMinimumTypicality ? "" : `"stoppingConditionMinimumTypicality":${undefined !== input.stoppingConditionMinimumTypicality ? input.stoppingConditionMinimumTypicality : undefined},`}${undefined === input.strength ? "" : `"strength":${undefined !== input.strength ? input.strength : undefined},`}${undefined === input.stoppingConditionMaxSum ? "" : `"stoppingConditionMaxSum":${undefined !== input.stoppingConditionMaxSum ? input.stoppingConditionMaxSum : undefined},`}${undefined === input.targetRange ? "" : `"targetRange":${undefined !== input.targetRange ? $so20(input.targetRange) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        const $so20 = (input: any): any => `{${$tail(`${undefined === input.minSum ? "" : `"minSum":${undefined !== input.minSum ? input.minSum : undefined},`}${undefined === input.maxSum ? "" : `"maxSum":${undefined !== input.maxSum ? input.maxSum : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type CreateDockerWorkerConfigVXRequestBody = DockerWorkerConfigOmniVXCreateRequest;
export const CreateDockerWorkerConfigVXRequestBodySanitizer = DockerWorkerConfigOmniVXCreateRequestFromJSON;
export const CreateDockerWorkerConfigVXRequestBodyValidator = DockerWorkerConfigOmniVXCreateRequestValidator;
export const CreateDockerWorkerConfigVXTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateDockerWorkerConfigVXRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateDockerWorkerConfigVXRequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "DockerWorkerConfigOmniV2CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io1(input.config, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["version", "config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker, true && _exceptionable)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io14(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io5(input.objectLevel, true && _exceptionable)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io6(input.stoppingCondition, true && _exceptionable)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "method", "normalizeEmbeddings", "outputImageFormat", "objectLevel", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "stoppingCondition", "uploadReport"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["corruptionThreshold"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bypassVerify", "enableDatapoolUpdate", "processAll"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["cropDatasetName", "padding", "taskName"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance) && (undefined === input.nSamples || "number" === typeof input.nSamples) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minDistance", "nSamples"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader, true && _exceptionable)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io9(input.model, true && _exceptionable)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io10(input.trainer, true && _exceptionable)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion, true && _exceptionable)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer, true && _exceptionable)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io13(input.collate, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io8 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io9 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io10 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io11 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["temperature"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io12 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["lr", "weightDecay"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io13 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io14 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index2: number) => "object" === typeof elem && null !== elem && $io15(elem, true && _exceptionable))) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io15 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io16(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io17(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io16 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index3: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io17 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io18 = (input: any, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            });
            const $io19 = (input: any, _exceptionable: boolean = true): boolean => "DockerWorkerConfigOmniV3CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io20(input.config, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["version", "config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io20 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io21(input.docker, true && _exceptionable)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io25(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io30(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io21 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io22(input.datasource, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io24(input.training, true && _exceptionable)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "shutdownWhenJobFinished"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io22 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io23(input.inputExpiration, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bypassVerify", "enableDatapoolUpdate", "processAll", "inputExpiration"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io23 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.minDaysToExpiration && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minDaysToExpiration", "handlingStrategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io24 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["taskName"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io25 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io26(input.checkpointCallback, true && _exceptionable)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader, true && _exceptionable)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io27(input.model, true && _exceptionable)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io28(input.trainer, true && _exceptionable)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion, true && _exceptionable)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer, true && _exceptionable)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io29(input.collate, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["seed", "checkpointCallback", "loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io26 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.saveLast || "boolean" === typeof input.saveLast) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["saveLast"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io27 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io28 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io29 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any, _index4: number) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any, _index5: number) => "number" === typeof elem)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb", "rrDegrees"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io30 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index6: number) => "object" === typeof elem && null !== elem && $io31(elem, true && _exceptionable))) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io31 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io32(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io33(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io32 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index7: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io33 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target, true && _exceptionable)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io34(input.targetRange, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target", "numNearestNeighbors", "stoppingConditionMinimumTypicality", "strength", "stoppingConditionMaxSum", "targetRange"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io34 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.minSum || "number" === typeof input.minSum && 0 <= input.minSum) && (undefined === input.maxSum || "number" === typeof input.maxSum && 0 <= input.maxSum) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minSum", "maxSum"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io35 = (input: any, _exceptionable: boolean = true): boolean => "DockerWorkerConfigOmniV4CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io36(input.config, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["version", "config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io36 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io37(input.docker, true && _exceptionable)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io25(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io39(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io37 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io22(input.datasource, true && _exceptionable)) && (undefined === input.crops || "object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) && $io38(input.crops, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io24(input.training, true && _exceptionable)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && Math.floor(input.cacheSize) === input.cacheSize && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647) && -1 <= input.cacheSize) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "crops", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "useDatapool", "shutdownWhenJobFinished", "cacheSize"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io38 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || Array.isArray(input.enableUploadForTasks) && input.enableUploadForTasks.every((elem: any, _index8: number) => "string" === typeof elem)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["enableUpload", "enableUploadForTasks"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io39 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index9: number) => "object" === typeof elem && null !== elem && $io40(elem, true && _exceptionable))) && (undefined === input.lightlyPathRegex || "string" === typeof input.lightlyPathRegex && 1 <= input.lightlyPathRegex.length) && (undefined === input.autoTasks || "object" === typeof input.autoTasks && null !== input.autoTasks && $io43(input.autoTasks, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies", "lightlyPathRegex", "autoTasks"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io40 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io41(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io42(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io41 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV4EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV4EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV4EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV4EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index10: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io42 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target, true && _exceptionable)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io34(input.targetRange, true && _exceptionable)) && (undefined === input.distribution || "TARGET" === input.distribution || "UNIFORM" === input.distribution || "INPUT" === input.distribution) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target", "numNearestNeighbors", "stoppingConditionMinimumTypicality", "strength", "stoppingConditionMaxSum", "targetRange", "distribution"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io43 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "object" === typeof value && null !== value && $iu0(value, true && _exceptionable);
                return false;
            });
            const $io44 = (input: any, _exceptionable: boolean = true): boolean => "AutoTaskCrop" === input.type && (Array.isArray(input.bboxs) && input.bboxs.every((elem: any, _index11: number) => "object" === typeof elem && null !== elem && $io45(elem, true && _exceptionable))) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name)) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "bboxs", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io45 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value;
                return false;
            });
            const $io46 = (input: any, _exceptionable: boolean = true): boolean => "AutoTaskTiling" === input.type && ("number" === typeof input.numRows && Math.floor(input.numRows) === input.numRows && (-2147483648 <= input.numRows && input.numRows <= 2147483647) && 1 <= input.numRows) && ("number" === typeof input.numCols && Math.floor(input.numCols) === input.numCols && (-2147483648 <= input.numCols && input.numCols <= 2147483647) && 1 <= input.numCols) && (undefined === input.overlap || "number" === typeof input.overlap && 0 <= input.overlap) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name)) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "numRows", "numCols", "overlap", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io47 = (input: any, _exceptionable: boolean = true): boolean => "CROP" === input.type && (Array.isArray(input.bboxs) && input.bboxs.every((elem: any, _index12: number) => "object" === typeof elem && null !== elem && $io45(elem, true && _exceptionable))) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name)) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "bboxs", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io48 = (input: any, _exceptionable: boolean = true): boolean => "TILING" === input.type && ("number" === typeof input.numRows && Math.floor(input.numRows) === input.numRows && (-2147483648 <= input.numRows && input.numRows <= 2147483647) && 1 <= input.numRows) && ("number" === typeof input.numCols && Math.floor(input.numCols) === input.numCols && (-2147483648 <= input.numCols && input.numCols <= 2147483647) && 1 <= input.numCols) && (undefined === input.overlap || "number" === typeof input.overlap && 0 <= input.overlap) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name)) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "numRows", "numCols", "overlap", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io49 = (input: any, _exceptionable: boolean = true): boolean => "V2" === input.version && ("object" === typeof input.config && null !== input.config && $io1(input.config, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["version", "config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io50 = (input: any, _exceptionable: boolean = true): boolean => "V3" === input.version && ("object" === typeof input.config && null !== input.config && $io20(input.config, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["version", "config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io51 = (input: any, _exceptionable: boolean = true): boolean => "V4" === input.version && ("object" === typeof input.config && null !== input.config && $io36(input.config, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["version", "config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $iu0 = (input: any, _exceptionable: boolean = true): any => (() => {
                if ("AutoTaskCrop" === input.type)
                    return $io44(input, true && _exceptionable);
                if ("AutoTaskTiling" === input.type)
                    return $io46(input, true && _exceptionable);
                if ("CROP" === input.type)
                    return $io47(input, true && _exceptionable);
                if ("TILING" === input.type)
                    return $io48(input, true && _exceptionable);
                return false;
            })();
            const $iu1 = (input: any, _exceptionable: boolean = true): any => (() => {
                if ("V4" === input.version)
                    return $io51(input, true && _exceptionable);
                if ("V3" === input.version)
                    return $io50(input, true && _exceptionable);
                if ("V2" === input.version)
                    return $io49(input, true && _exceptionable);
                if ("DockerWorkerConfigOmniV4CreateRequest" === input.version)
                    return $io35(input, true && _exceptionable);
                if ("DockerWorkerConfigOmniV3CreateRequest" === input.version)
                    return $io19(input, true && _exceptionable);
                if ("DockerWorkerConfigOmniV2CreateRequest" === input.version)
                    return $io0(input, true && _exceptionable);
                return false;
            })();
            return "object" === typeof input && null !== input && $iu1(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigVXRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DockerWorkerConfigOmniV2CreateRequest" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"DockerWorkerConfigOmniV2CreateRequest\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["version", "config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && $ao7(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao14(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao4(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.method || "coreset" === input.method || "random" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"coreset\" | \"random\" | undefined)",
                    value: input.method
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.objectLevel || ("object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && $ao5(input.objectLevel, _path + ".objectLevel", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao6(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "method", "normalizeEmbeddings", "outputImageFormat", "objectLevel", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "stoppingCondition", "uploadReport"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["corruptionThreshold"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bypassVerify", "enableDatapoolUpdate", "processAll"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName)",
                    value: input.cropDatasetName
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "(string | undefined)",
                    value: input.cropDatasetName
                })) && (undefined === input.padding || "number" === typeof input.padding || $guard(_exceptionable, {
                    path: _path + ".padding",
                    expected: "(number | undefined)",
                    value: input.padding
                })) && (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["cropDatasetName", "padding", "taskName"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (undefined === input.nSamples || "number" === typeof input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minDistance", "nSamples"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao8(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && $ao9(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao10(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao11(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao12(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao13(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["batchSize", "shuffle", "numWorkers", "dropLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.temperature || "number" === typeof input.temperature && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["temperature"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["lr", "weightDecay"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index2: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao15(elem, _path + ".strategies[" + _index2 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao16(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao17(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao16 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index3: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index3 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao17 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao18 = (input: any, _path: string, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao19 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DockerWorkerConfigOmniV3CreateRequest" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"DockerWorkerConfigOmniV3CreateRequest\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && $ao20(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["version", "config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao20 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && $ao21(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && $ao25(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                })) && $ao30(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao21 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV3Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao22(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao24(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "shutdownWhenJobFinished"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao22 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (undefined === input.inputExpiration || ("object" === typeof input.inputExpiration && null !== input.inputExpiration || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && $ao23(input.inputExpiration, _path + ".inputExpiration", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bypassVerify", "enableDatapoolUpdate", "processAll", "inputExpiration"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao23 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.minDaysToExpiration && (0 <= input.minDaysToExpiration || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number (@minimum 0)",
                    value: input.minDaysToExpiration
                })) || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number",
                    value: input.minDaysToExpiration
                })) && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy || $guard(_exceptionable, {
                    path: _path + ".handlingStrategy",
                    expected: "(\"ABORT\" | \"SKIP\")",
                    value: input.handlingStrategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minDaysToExpiration", "handlingStrategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao24 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV3DockerTraining_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["taskName"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao25 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && (Math.floor(input.seed) === input.seed || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) && (-2147483648 <= input.seed && input.seed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "(number | undefined)",
                    value: input.seed
                })) && (undefined === input.checkpointCallback || ("object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && $ao26(input.checkpointCallback, _path + ".checkpointCallback", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao8(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && $ao27(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao28(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao11(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao12(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao29(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["seed", "checkpointCallback", "loader", "model", "trainer", "criterion", "optimizer", "collate"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao26 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.saveLast || "boolean" === typeof input.saveLast || $guard(_exceptionable, {
                    path: _path + ".saveLast",
                    expected: "(boolean | undefined)",
                    value: input.saveLast
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["saveLast"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao27 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "outDim", "numFtrs", "width"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao28 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao29 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index4: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index4 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (null === input.rrDegrees || undefined === input.rrDegrees || (Array.isArray(input.rrDegrees) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && input.rrDegrees.every((elem: any, _index5: number) => "number" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".rrDegrees[" + _index5 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["inputSize", "cjProb", "cjBright", "cjContrast", "cjSat", "cjHue", "minScale", "randomGrayScale", "gaussianBlur", "kernelSize", "sigmas", "vfProb", "hfProb", "rrProb", "rrDegrees"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao30 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index6: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index6 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) && $ao31(elem, _path + ".strategies[" + _index6 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index6 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao31 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && $ao32(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                })) && $ao33(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao32 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index7: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index7 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao33 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && (Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (2 <= input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@minimum 2)",
                    value: input.numNearestNeighbors
                })) || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "(number | undefined)",
                    value: input.numNearestNeighbors
                })) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && (0 < input.stoppingConditionMinimumTypicality || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.stoppingConditionMinimumTypicality
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMinimumTypicality
                })) && (undefined === input.strength || "number" === typeof input.strength && (-1000000000 <= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@minimum -1000000000)",
                    value: input.strength
                })) && (1000000000 >= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@maximum 1000000000)",
                    value: input.strength
                })) || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "(number | undefined)",
                    value: input.strength
                })) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && (0 <= input.stoppingConditionMaxSum || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "number (@minimum 0)",
                    value: input.stoppingConditionMaxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMaxSum
                })) && (undefined === input.targetRange || ("object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && $ao34(input.targetRange, _path + ".targetRange", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target", "numNearestNeighbors", "stoppingConditionMinimumTypicality", "strength", "stoppingConditionMaxSum", "targetRange"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao34 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minSum || "number" === typeof input.minSum && (0 <= input.minSum || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "number (@minimum 0)",
                    value: input.minSum
                })) || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "(number | undefined)",
                    value: input.minSum
                })) && (undefined === input.maxSum || "number" === typeof input.maxSum && (0 <= input.maxSum || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "number (@minimum 0)",
                    value: input.maxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "(number | undefined)",
                    value: input.maxSum
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minSum", "maxSum"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao35 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DockerWorkerConfigOmniV4CreateRequest" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"DockerWorkerConfigOmniV4CreateRequest\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && $ao36(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["version", "config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao36 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV4Docker | undefined)",
                    value: input.docker
                })) && $ao37(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV4Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && $ao25(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV4 | undefined)",
                    value: input.selection
                })) && $ao39(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV4 | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao37 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV4Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao22(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.crops || ("object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && $ao38(input.crops, _path + ".crops", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao24(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool || $guard(_exceptionable, {
                    path: _path + ".useDatapool",
                    expected: "(boolean | undefined)",
                    value: input.useDatapool
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                })) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && (Math.floor(input.cacheSize) === input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-1 <= input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@minimum -1)",
                    value: input.cacheSize
                })) || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "(number | undefined)",
                    value: input.cacheSize
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "crops", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "useDatapool", "shutdownWhenJobFinished", "cacheSize"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao38 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload || $guard(_exceptionable, {
                    path: _path + ".enableUpload",
                    expected: "(boolean | undefined)",
                    value: input.enableUpload
                })) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || (Array.isArray(input.enableUploadForTasks) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                })) && input.enableUploadForTasks.every((elem: any, _index8: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks[" + _index8 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["enableUpload", "enableUploadForTasks"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao39 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV4Entry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index9: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index9 + "]",
                    expected: "SelectionConfigV4Entry",
                    value: elem
                })) && $ao40(elem, _path + ".strategies[" + _index9 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index9 + "]",
                    expected: "SelectionConfigV4Entry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV4Entry>",
                    value: input.strategies
                })) && (undefined === input.lightlyPathRegex || "string" === typeof input.lightlyPathRegex && (1 <= input.lightlyPathRegex.length || $guard(_exceptionable, {
                    path: _path + ".lightlyPathRegex",
                    expected: "string (@minLength 1)",
                    value: input.lightlyPathRegex
                })) || $guard(_exceptionable, {
                    path: _path + ".lightlyPathRegex",
                    expected: "(string | undefined)",
                    value: input.lightlyPathRegex
                })) && (undefined === input.autoTasks || ("object" === typeof input.autoTasks && null !== input.autoTasks || $guard(_exceptionable, {
                    path: _path + ".autoTasks",
                    expected: "(AutoTasks | undefined)",
                    value: input.autoTasks
                })) && $ao43(input.autoTasks, _path + ".autoTasks", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".autoTasks",
                    expected: "(AutoTasks | undefined)",
                    value: input.autoTasks
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies", "lightlyPathRegex", "autoTasks"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao40 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV4EntryInput",
                    value: input.input
                })) && $ao41(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV4EntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV4EntryStrategy",
                    value: input.strategy
                })) && $ao42(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV4EntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao41 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigV4EntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigV4EntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigV4EntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigV4EntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index10: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index10 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao42 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && (Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (2 <= input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@minimum 2)",
                    value: input.numNearestNeighbors
                })) || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "(number | undefined)",
                    value: input.numNearestNeighbors
                })) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && (0 < input.stoppingConditionMinimumTypicality || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.stoppingConditionMinimumTypicality
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMinimumTypicality
                })) && (undefined === input.strength || "number" === typeof input.strength && (-1000000000 <= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@minimum -1000000000)",
                    value: input.strength
                })) && (1000000000 >= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@maximum 1000000000)",
                    value: input.strength
                })) || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "(number | undefined)",
                    value: input.strength
                })) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && (0 <= input.stoppingConditionMaxSum || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "number (@minimum 0)",
                    value: input.stoppingConditionMaxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMaxSum
                })) && (undefined === input.targetRange || ("object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && $ao34(input.targetRange, _path + ".targetRange", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && (undefined === input.distribution || "TARGET" === input.distribution || "UNIFORM" === input.distribution || "INPUT" === input.distribution || $guard(_exceptionable, {
                    path: _path + ".distribution",
                    expected: "(\"INPUT\" | \"TARGET\" | \"UNIFORM\" | undefined)",
                    value: input.distribution
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target", "numNearestNeighbors", "stoppingConditionMinimumTypicality", "strength", "stoppingConditionMaxSum", "targetRange", "distribution"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao43 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return ("object" === typeof value && null !== value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                            value: value
                        })) && $au0(value, _path + $join(key), true && _exceptionable) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao44 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("AutoTaskCrop" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"AutoTaskCrop\"",
                    value: input.type
                })) && ((Array.isArray(input.bboxs) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && input.bboxs.every((elem: any, _index11: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index11 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) && $ao45(elem, _path + ".bboxs[" + _index11 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index11 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "bboxs", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao45 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao46 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("AutoTaskTiling" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"AutoTaskTiling\"",
                    value: input.type
                })) && ("number" === typeof input.numRows && (Math.floor(input.numRows) === input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (-2147483648 <= input.numRows && input.numRows <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (1 <= input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@minimum 1)",
                    value: input.numRows
                })) || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number",
                    value: input.numRows
                })) && ("number" === typeof input.numCols && (Math.floor(input.numCols) === input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (-2147483648 <= input.numCols && input.numCols <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (1 <= input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@minimum 1)",
                    value: input.numCols
                })) || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number",
                    value: input.numCols
                })) && (undefined === input.overlap || "number" === typeof input.overlap && (0 <= input.overlap || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "number (@minimum 0)",
                    value: input.overlap
                })) || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "(number | undefined)",
                    value: input.overlap
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "numRows", "numCols", "overlap", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao47 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("CROP" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"CROP\"",
                    value: input.type
                })) && ((Array.isArray(input.bboxs) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && input.bboxs.every((elem: any, _index12: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index12 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) && $ao45(elem, _path + ".bboxs[" + _index12 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index12 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "bboxs", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao48 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("TILING" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"TILING\"",
                    value: input.type
                })) && ("number" === typeof input.numRows && (Math.floor(input.numRows) === input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (-2147483648 <= input.numRows && input.numRows <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (1 <= input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@minimum 1)",
                    value: input.numRows
                })) || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number",
                    value: input.numRows
                })) && ("number" === typeof input.numCols && (Math.floor(input.numCols) === input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (-2147483648 <= input.numCols && input.numCols <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (1 <= input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@minimum 1)",
                    value: input.numCols
                })) || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number",
                    value: input.numCols
                })) && (undefined === input.overlap || "number" === typeof input.overlap && (0 <= input.overlap || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "number (@minimum 0)",
                    value: input.overlap
                })) || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "(number | undefined)",
                    value: input.overlap
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "numRows", "numCols", "overlap", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao49 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("V2" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"V2\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["version", "config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao50 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("V3" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"V3\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && $ao20(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["version", "config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao51 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("V4" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"V4\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && $ao36(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["version", "config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $au0 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
                    if ("AutoTaskCrop" === input.type)
                        return $ao44(input, _path, true && _exceptionable);
                    if ("AutoTaskTiling" === input.type)
                        return $ao46(input, _path, true && _exceptionable);
                    if ("CROP" === input.type)
                        return $ao47(input, _path, true && _exceptionable);
                    if ("TILING" === input.type)
                        return $ao48(input, _path, true && _exceptionable);
                    return $guard(_exceptionable, {
                        path: _path,
                        expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                        value: input
                    });
                })();
                const $au1 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
                    if ("V4" === input.version)
                        return $ao51(input, _path, true && _exceptionable);
                    if ("V3" === input.version)
                        return $ao50(input, _path, true && _exceptionable);
                    if ("V2" === input.version)
                        return $ao49(input, _path, true && _exceptionable);
                    if ("DockerWorkerConfigOmniV4CreateRequest" === input.version)
                        return $ao35(input, _path, true && _exceptionable);
                    if ("DockerWorkerConfigOmniV3CreateRequest" === input.version)
                        return $ao19(input, _path, true && _exceptionable);
                    if ("DockerWorkerConfigOmniV2CreateRequest" === input.version)
                        return $ao0(input, _path, true && _exceptionable);
                    return $guard(_exceptionable, {
                        path: _path,
                        expected: "({ version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest)",
                        value: input
                    });
                })();
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "({ version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest)",
                    value: input
                })) && $au1(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "({ version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest)",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateDockerWorkerConfigVXTypiaAssertStringify = (input: CreateDockerWorkerConfigVXRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): CreateDockerWorkerConfigVXRequestBody => {
        const __is = (input: any): input is CreateDockerWorkerConfigVXRequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => "DockerWorkerConfigOmniV2CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io1(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io1 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io14(input.selection));
            const $io2 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io5(input.objectLevel)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io6(input.stoppingCondition)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport);
            const $io3 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
            const $io4 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll);
            const $io5 = (input: any): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding && !Number.isNaN(input.padding)) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName));
            const $io6 = (input: any): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance)) && (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples));
            const $io7 = (input: any): boolean => (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io9(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io10(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io13(input.collate));
            const $io8 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
            const $io9 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
            const $io10 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
            const $io11 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && 0 < input.temperature;
            const $io12 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
            const $io13 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem))) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb);
            const $io14 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io15(elem)));
            const $io15 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io16(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io17(input.strategy));
            const $io16 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io17 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target));
            const $io18 = (input: any): boolean => true;
            const $io19 = (input: any): boolean => "DockerWorkerConfigOmniV3CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io20(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io20 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io21(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io25(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io30(input.selection));
            const $io21 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io22(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io24(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished);
            const $io22 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io23(input.inputExpiration));
            const $io23 = (input: any): boolean => "number" === typeof input.minDaysToExpiration && !Number.isNaN(input.minDaysToExpiration) && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy);
            const $io24 = (input: any): boolean => undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName);
            const $io25 = (input: any): boolean => (undefined === input.seed || "number" === typeof input.seed && !Number.isNaN(input.seed) && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io26(input.checkpointCallback)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io27(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io28(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io29(input.collate));
            const $io26 = (input: any): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast;
            const $io27 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
            const $io28 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
            const $io29 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem))) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any) => "number" === typeof elem && !Number.isNaN(elem)));
            const $io30 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io31(elem)));
            const $io31 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io32(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io33(input.strategy));
            const $io32 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io33 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && !Number.isNaN(input.numNearestNeighbors) && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && !Number.isNaN(input.stoppingConditionMinimumTypicality) && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && !Number.isNaN(input.stoppingConditionMaxSum) && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io34(input.targetRange));
            const $io34 = (input: any): boolean => (undefined === input.minSum || "number" === typeof input.minSum && !Number.isNaN(input.minSum) && 0 <= input.minSum) && (undefined === input.maxSum || "number" === typeof input.maxSum && !Number.isNaN(input.maxSum) && 0 <= input.maxSum);
            const $io35 = (input: any): boolean => "DockerWorkerConfigOmniV4CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io36(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io36 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io37(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io25(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io39(input.selection));
            const $io37 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io22(input.datasource)) && (undefined === input.crops || "object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) && $io38(input.crops)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io24(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && !Number.isNaN(input.cacheSize) && Math.floor(input.cacheSize) === input.cacheSize && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647) && -1 <= input.cacheSize);
            const $io38 = (input: any): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || Array.isArray(input.enableUploadForTasks) && input.enableUploadForTasks.every((elem: any) => "string" === typeof elem));
            const $io39 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io40(elem))) && (undefined === input.lightlyPathRegex || "string" === typeof input.lightlyPathRegex && 1 <= input.lightlyPathRegex.length) && (undefined === input.autoTasks || "object" === typeof input.autoTasks && null !== input.autoTasks && $io43(input.autoTasks));
            const $io40 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io41(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io42(input.strategy));
            const $io41 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV4EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV4EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV4EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV4EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io42 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && !Number.isNaN(input.numNearestNeighbors) && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && !Number.isNaN(input.stoppingConditionMinimumTypicality) && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && !Number.isNaN(input.stoppingConditionMaxSum) && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io34(input.targetRange)) && (undefined === input.distribution || "TARGET" === input.distribution || "UNIFORM" === input.distribution || "INPUT" === input.distribution);
            const $io43 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "object" === typeof value && null !== value && $iu0(value);
                return true;
            });
            const $io44 = (input: any): boolean => "AutoTaskCrop" === input.type && (Array.isArray(input.bboxs) && input.bboxs.every((elem: any) => "object" === typeof elem && null !== elem && $io45(elem))) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
            const $io45 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value && !Number.isNaN(value);
                return true;
            });
            const $io46 = (input: any): boolean => "AutoTaskTiling" === input.type && ("number" === typeof input.numRows && !Number.isNaN(input.numRows) && Math.floor(input.numRows) === input.numRows && (-2147483648 <= input.numRows && input.numRows <= 2147483647) && 1 <= input.numRows) && ("number" === typeof input.numCols && !Number.isNaN(input.numCols) && Math.floor(input.numCols) === input.numCols && (-2147483648 <= input.numCols && input.numCols <= 2147483647) && 1 <= input.numCols) && (undefined === input.overlap || "number" === typeof input.overlap && !Number.isNaN(input.overlap) && 0 <= input.overlap) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
            const $io47 = (input: any): boolean => "CROP" === input.type && (Array.isArray(input.bboxs) && input.bboxs.every((elem: any) => "object" === typeof elem && null !== elem && $io45(elem))) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
            const $io48 = (input: any): boolean => "TILING" === input.type && ("number" === typeof input.numRows && !Number.isNaN(input.numRows) && Math.floor(input.numRows) === input.numRows && (-2147483648 <= input.numRows && input.numRows <= 2147483647) && 1 <= input.numRows) && ("number" === typeof input.numCols && !Number.isNaN(input.numCols) && Math.floor(input.numCols) === input.numCols && (-2147483648 <= input.numCols && input.numCols <= 2147483647) && 1 <= input.numCols) && (undefined === input.overlap || "number" === typeof input.overlap && !Number.isNaN(input.overlap) && 0 <= input.overlap) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
            const $io49 = (input: any): boolean => "V2" === input.version && ("object" === typeof input.config && null !== input.config && $io1(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io50 = (input: any): boolean => "V3" === input.version && ("object" === typeof input.config && null !== input.config && $io20(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io51 = (input: any): boolean => "V4" === input.version && ("object" === typeof input.config && null !== input.config && $io36(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $iu0 = (input: any): any => (() => {
                if ("AutoTaskCrop" === input.type)
                    return $io44(input);
                if ("AutoTaskTiling" === input.type)
                    return $io46(input);
                if ("CROP" === input.type)
                    return $io47(input);
                if ("TILING" === input.type)
                    return $io48(input);
                return false;
            })();
            const $iu1 = (input: any): any => (() => {
                if ("V4" === input.version)
                    return $io51(input);
                if ("V3" === input.version)
                    return $io50(input);
                if ("V2" === input.version)
                    return $io49(input);
                if ("DockerWorkerConfigOmniV4CreateRequest" === input.version)
                    return $io35(input);
                if ("DockerWorkerConfigOmniV3CreateRequest" === input.version)
                    return $io19(input);
                if ("DockerWorkerConfigOmniV2CreateRequest" === input.version)
                    return $io0(input);
                return false;
            })();
            return "object" === typeof input && null !== input && $iu1(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateDockerWorkerConfigVXRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DockerWorkerConfigOmniV2CreateRequest" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"DockerWorkerConfigOmniV2CreateRequest\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV2Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && $ao7(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV2Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao14(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao4(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV2DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.method || "coreset" === input.method || "random" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"coreset\" | \"random\" | undefined)",
                    value: input.method
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.objectLevel || ("object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && $ao5(input.objectLevel, _path + ".objectLevel", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".objectLevel",
                    expected: "(DockerWorkerConfigV2DockerObjectLevel | undefined)",
                    value: input.objectLevel
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao6(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(DockerWorkerConfigV2DockerStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName)",
                    value: input.cropDatasetName
                })) || $guard(_exceptionable, {
                    path: _path + ".cropDatasetName",
                    expected: "(string | undefined)",
                    value: input.cropDatasetName
                })) && (undefined === input.padding || "number" === typeof input.padding && !Number.isNaN(input.padding) || $guard(_exceptionable, {
                    path: _path + ".padding",
                    expected: "(number | undefined)",
                    value: input.padding
                })) && (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV2DockerObjectLevel_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                }));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance) || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                }));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao8(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && $ao9(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV2LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao10(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV2LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao11(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao12(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao13(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV2LightlyCollate | undefined)",
                    value: input.collate
                }));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && !Number.isNaN(input.batchSize) && (Math.floor(input.batchSize) === input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@type int)",
                    value: input.batchSize
                })) && (1 <= input.batchSize || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "number (@minimum 1)",
                    value: input.batchSize
                })) || $guard(_exceptionable, {
                    path: _path + ".batchSize",
                    expected: "(number | undefined)",
                    value: input.batchSize
                })) && (undefined === input.shuffle || "boolean" === typeof input.shuffle || $guard(_exceptionable, {
                    path: _path + ".shuffle",
                    expected: "(boolean | undefined)",
                    value: input.shuffle
                })) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && !Number.isNaN(input.numWorkers) && (Math.floor(input.numWorkers) === input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@type int)",
                    value: input.numWorkers
                })) && (-1 <= input.numWorkers || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "number (@minimum -1)",
                    value: input.numWorkers
                })) || $guard(_exceptionable, {
                    path: _path + ".numWorkers",
                    expected: "(number | undefined)",
                    value: input.numWorkers
                })) && (undefined === input.dropLast || "boolean" === typeof input.dropLast || $guard(_exceptionable, {
                    path: _path + ".dropLast",
                    expected: "(boolean | undefined)",
                    value: input.dropLast
                }));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                }));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                }));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.temperature || "number" === typeof input.temperature && !Number.isNaN(input.temperature) && (0 < input.temperature || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.temperature
                })) || $guard(_exceptionable, {
                    path: _path + ".temperature",
                    expected: "(number | undefined)",
                    value: input.temperature
                });
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.lr || "number" === typeof input.lr && !Number.isNaN(input.lr) && (0 <= input.lr || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "number (@minimum 0)",
                    value: input.lr
                })) || $guard(_exceptionable, {
                    path: _path + ".lr",
                    expected: "(number | undefined)",
                    value: input.lr
                })) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && (0 <= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@minimum 0)",
                    value: input.weightDecay
                })) && (1 >= input.weightDecay || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "number (@maximum 1)",
                    value: input.weightDecay
                })) || $guard(_exceptionable, {
                    path: _path + ".weightDecay",
                    expected: "(number | undefined)",
                    value: input.weightDecay
                }));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index1: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index1 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                }));
                const $ao14 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index2: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao15(elem, _path + ".strategies[" + _index2 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index2 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                }));
                const $ao15 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao16(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao17(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                }));
                const $ao16 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index3: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index3 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao17 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                }));
                const $ao18 = (input: any, _path: string, _exceptionable: boolean = true): boolean => true;
                const $ao19 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DockerWorkerConfigOmniV3CreateRequest" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"DockerWorkerConfigOmniV3CreateRequest\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && $ao20(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao20 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && $ao21(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV3Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && $ao25(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                })) && $ao30(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV3 | undefined)",
                    value: input.selection
                }));
                const $ao21 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV3Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao22(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao24(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                }));
                const $ao22 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (undefined === input.inputExpiration || ("object" === typeof input.inputExpiration && null !== input.inputExpiration || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && $ao23(input.inputExpiration, _path + ".inputExpiration", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                }));
                const $ao23 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.minDaysToExpiration && !Number.isNaN(input.minDaysToExpiration) && (0 <= input.minDaysToExpiration || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number (@minimum 0)",
                    value: input.minDaysToExpiration
                })) || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number",
                    value: input.minDaysToExpiration
                })) && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy || $guard(_exceptionable, {
                    path: _path + ".handlingStrategy",
                    expected: "(\"ABORT\" | \"SKIP\")",
                    value: input.handlingStrategy
                }));
                const $ao24 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV3DockerTraining_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                });
                const $ao25 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.seed || "number" === typeof input.seed && !Number.isNaN(input.seed) && (Math.floor(input.seed) === input.seed || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) && (-2147483648 <= input.seed && input.seed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "number (@type int)",
                    value: input.seed
                })) || $guard(_exceptionable, {
                    path: _path + ".seed",
                    expected: "(number | undefined)",
                    value: input.seed
                })) && (undefined === input.checkpointCallback || ("object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && $ao26(input.checkpointCallback, _path + ".checkpointCallback", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".checkpointCallback",
                    expected: "(DockerWorkerConfigV3LightlyCheckpointCallback | undefined)",
                    value: input.checkpointCallback
                })) && (undefined === input.loader || ("object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && $ao8(input.loader, _path + ".loader", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".loader",
                    expected: "(DockerWorkerConfigV3LightlyLoader | undefined)",
                    value: input.loader
                })) && (undefined === input.model || ("object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && $ao27(input.model, _path + ".model", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".model",
                    expected: "(DockerWorkerConfigV3LightlyModel | undefined)",
                    value: input.model
                })) && (undefined === input.trainer || ("object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && $ao28(input.trainer, _path + ".trainer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".trainer",
                    expected: "(DockerWorkerConfigV3LightlyTrainer | undefined)",
                    value: input.trainer
                })) && (undefined === input.criterion || ("object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && $ao11(input.criterion, _path + ".criterion", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".criterion",
                    expected: "(DockerWorkerConfigV3LightlyCriterion | undefined)",
                    value: input.criterion
                })) && (undefined === input.optimizer || ("object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && $ao12(input.optimizer, _path + ".optimizer", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".optimizer",
                    expected: "(DockerWorkerConfigV3LightlyOptimizer | undefined)",
                    value: input.optimizer
                })) && (undefined === input.collate || ("object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                })) && $ao29(input.collate, _path + ".collate", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".collate",
                    expected: "(DockerWorkerConfigV3LightlyCollate | undefined)",
                    value: input.collate
                }));
                const $ao26 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast || $guard(_exceptionable, {
                    path: _path + ".saveLast",
                    expected: "(boolean | undefined)",
                    value: input.saveLast
                });
                const $ao27 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                    value: input.name
                })) && (undefined === input.outDim || "number" === typeof input.outDim && !Number.isNaN(input.outDim) && (Math.floor(input.outDim) === input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (-2147483648 <= input.outDim && input.outDim <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@type int)",
                    value: input.outDim
                })) && (1 <= input.outDim || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "number (@minimum 1)",
                    value: input.outDim
                })) || $guard(_exceptionable, {
                    path: _path + ".outDim",
                    expected: "(number | undefined)",
                    value: input.outDim
                })) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && !Number.isNaN(input.numFtrs) && (Math.floor(input.numFtrs) === input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@type int)",
                    value: input.numFtrs
                })) && (1 <= input.numFtrs || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "number (@minimum 1)",
                    value: input.numFtrs
                })) || $guard(_exceptionable, {
                    path: _path + ".numFtrs",
                    expected: "(number | undefined)",
                    value: input.numFtrs
                })) && (undefined === input.width || "number" === typeof input.width && !Number.isNaN(input.width) && (Math.floor(input.width) === input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (-2147483648 <= input.width && input.width <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@type int)",
                    value: input.width
                })) && (1 <= input.width || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "number (@minimum 1)",
                    value: input.width
                })) || $guard(_exceptionable, {
                    path: _path + ".width",
                    expected: "(number | undefined)",
                    value: input.width
                }));
                const $ao28 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                }));
                const $ao29 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && !Number.isNaN(input.inputSize) && (Math.floor(input.inputSize) === input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@type int)",
                    value: input.inputSize
                })) && (1 <= input.inputSize || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "number (@minimum 1)",
                    value: input.inputSize
                })) || $guard(_exceptionable, {
                    path: _path + ".inputSize",
                    expected: "(number | undefined)",
                    value: input.inputSize
                })) && (undefined === input.cjProb || "number" === typeof input.cjProb && (0 <= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@minimum 0)",
                    value: input.cjProb
                })) && (1 >= input.cjProb || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "number (@maximum 1)",
                    value: input.cjProb
                })) || $guard(_exceptionable, {
                    path: _path + ".cjProb",
                    expected: "(number | undefined)",
                    value: input.cjProb
                })) && (undefined === input.cjBright || "number" === typeof input.cjBright && (0 <= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@minimum 0)",
                    value: input.cjBright
                })) && (1 >= input.cjBright || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "number (@maximum 1)",
                    value: input.cjBright
                })) || $guard(_exceptionable, {
                    path: _path + ".cjBright",
                    expected: "(number | undefined)",
                    value: input.cjBright
                })) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && (0 <= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@minimum 0)",
                    value: input.cjContrast
                })) && (1 >= input.cjContrast || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "number (@maximum 1)",
                    value: input.cjContrast
                })) || $guard(_exceptionable, {
                    path: _path + ".cjContrast",
                    expected: "(number | undefined)",
                    value: input.cjContrast
                })) && (undefined === input.cjSat || "number" === typeof input.cjSat && (0 <= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@minimum 0)",
                    value: input.cjSat
                })) && (1 >= input.cjSat || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "number (@maximum 1)",
                    value: input.cjSat
                })) || $guard(_exceptionable, {
                    path: _path + ".cjSat",
                    expected: "(number | undefined)",
                    value: input.cjSat
                })) && (undefined === input.cjHue || "number" === typeof input.cjHue && (0 <= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@minimum 0)",
                    value: input.cjHue
                })) && (1 >= input.cjHue || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "number (@maximum 1)",
                    value: input.cjHue
                })) || $guard(_exceptionable, {
                    path: _path + ".cjHue",
                    expected: "(number | undefined)",
                    value: input.cjHue
                })) && (undefined === input.minScale || "number" === typeof input.minScale && (0 <= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@minimum 0)",
                    value: input.minScale
                })) && (1 >= input.minScale || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "number (@maximum 1)",
                    value: input.minScale
                })) || $guard(_exceptionable, {
                    path: _path + ".minScale",
                    expected: "(number | undefined)",
                    value: input.minScale
                })) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && (0 <= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@minimum 0)",
                    value: input.randomGrayScale
                })) && (1 >= input.randomGrayScale || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "number (@maximum 1)",
                    value: input.randomGrayScale
                })) || $guard(_exceptionable, {
                    path: _path + ".randomGrayScale",
                    expected: "(number | undefined)",
                    value: input.randomGrayScale
                })) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && (0 <= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@minimum 0)",
                    value: input.gaussianBlur
                })) && (1 >= input.gaussianBlur || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "number (@maximum 1)",
                    value: input.gaussianBlur
                })) || $guard(_exceptionable, {
                    path: _path + ".gaussianBlur",
                    expected: "(number | undefined)",
                    value: input.gaussianBlur
                })) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && !Number.isNaN(input.kernelSize) && (0 <= input.kernelSize || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "number (@minimum 0)",
                    value: input.kernelSize
                })) || $guard(_exceptionable, {
                    path: _path + ".kernelSize",
                    expected: "(number | undefined)",
                    value: input.kernelSize
                })) && (undefined === input.sigmas || (Array.isArray(input.sigmas) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && input.sigmas.every((elem: any, _index4: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".sigmas[" + _index4 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".sigmas",
                    expected: "(Array<number> | undefined)",
                    value: input.sigmas
                })) && (undefined === input.vfProb || "number" === typeof input.vfProb && (0 <= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@minimum 0)",
                    value: input.vfProb
                })) && (1 >= input.vfProb || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "number (@maximum 1)",
                    value: input.vfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".vfProb",
                    expected: "(number | undefined)",
                    value: input.vfProb
                })) && (undefined === input.hfProb || "number" === typeof input.hfProb && (0 <= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@minimum 0)",
                    value: input.hfProb
                })) && (1 >= input.hfProb || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "number (@maximum 1)",
                    value: input.hfProb
                })) || $guard(_exceptionable, {
                    path: _path + ".hfProb",
                    expected: "(number | undefined)",
                    value: input.hfProb
                })) && (undefined === input.rrProb || "number" === typeof input.rrProb && (0 <= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@minimum 0)",
                    value: input.rrProb
                })) && (1 >= input.rrProb || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "number (@maximum 1)",
                    value: input.rrProb
                })) || $guard(_exceptionable, {
                    path: _path + ".rrProb",
                    expected: "(number | undefined)",
                    value: input.rrProb
                })) && (null === input.rrDegrees || undefined === input.rrDegrees || (Array.isArray(input.rrDegrees) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                })) && input.rrDegrees.every((elem: any, _index5: number) => "number" === typeof elem && !Number.isNaN(elem) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees[" + _index5 + "]",
                    expected: "number",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".rrDegrees",
                    expected: "(Array<number> | null | undefined)",
                    value: input.rrDegrees
                }));
                const $ao30 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index6: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index6 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) && $ao31(elem, _path + ".strategies[" + _index6 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index6 + "]",
                    expected: "SelectionConfigV3Entry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV3Entry>",
                    value: input.strategies
                }));
                const $ao31 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && $ao32(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV3EntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                })) && $ao33(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV3EntryStrategy",
                    value: input.strategy
                }));
                const $ao32 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigV3EntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index7: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index7 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao33 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && !Number.isNaN(input.numNearestNeighbors) && (Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (2 <= input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@minimum 2)",
                    value: input.numNearestNeighbors
                })) || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "(number | undefined)",
                    value: input.numNearestNeighbors
                })) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && !Number.isNaN(input.stoppingConditionMinimumTypicality) && (0 < input.stoppingConditionMinimumTypicality || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.stoppingConditionMinimumTypicality
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMinimumTypicality
                })) && (undefined === input.strength || "number" === typeof input.strength && (-1000000000 <= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@minimum -1000000000)",
                    value: input.strength
                })) && (1000000000 >= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@maximum 1000000000)",
                    value: input.strength
                })) || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "(number | undefined)",
                    value: input.strength
                })) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && !Number.isNaN(input.stoppingConditionMaxSum) && (0 <= input.stoppingConditionMaxSum || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "number (@minimum 0)",
                    value: input.stoppingConditionMaxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMaxSum
                })) && (undefined === input.targetRange || ("object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && $ao34(input.targetRange, _path + ".targetRange", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                }));
                const $ao34 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.minSum || "number" === typeof input.minSum && !Number.isNaN(input.minSum) && (0 <= input.minSum || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "number (@minimum 0)",
                    value: input.minSum
                })) || $guard(_exceptionable, {
                    path: _path + ".minSum",
                    expected: "(number | undefined)",
                    value: input.minSum
                })) && (undefined === input.maxSum || "number" === typeof input.maxSum && !Number.isNaN(input.maxSum) && (0 <= input.maxSum || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "number (@minimum 0)",
                    value: input.maxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".maxSum",
                    expected: "(number | undefined)",
                    value: input.maxSum
                }));
                const $ao35 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DockerWorkerConfigOmniV4CreateRequest" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"DockerWorkerConfigOmniV4CreateRequest\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && $ao36(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao36 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV4Docker | undefined)",
                    value: input.docker
                })) && $ao37(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(DockerWorkerConfigV4Docker | undefined)",
                    value: input.docker
                })) && (undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && $ao25(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(DockerWorkerConfigV3Lightly | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV4 | undefined)",
                    value: input.selection
                })) && $ao39(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfigV4 | undefined)",
                    value: input.selection
                }));
                const $ao37 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV4Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao3(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao22(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.crops || ("object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && $ao38(input.crops, _path + ".crops", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao24(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool || $guard(_exceptionable, {
                    path: _path + ".useDatapool",
                    expected: "(boolean | undefined)",
                    value: input.useDatapool
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                })) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && !Number.isNaN(input.cacheSize) && (Math.floor(input.cacheSize) === input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-1 <= input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@minimum -1)",
                    value: input.cacheSize
                })) || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "(number | undefined)",
                    value: input.cacheSize
                }));
                const $ao38 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload || $guard(_exceptionable, {
                    path: _path + ".enableUpload",
                    expected: "(boolean | undefined)",
                    value: input.enableUpload
                })) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || (Array.isArray(input.enableUploadForTasks) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                })) && input.enableUploadForTasks.every((elem: any, _index8: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks[" + _index8 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                }));
                const $ao39 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV4Entry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index9: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index9 + "]",
                    expected: "SelectionConfigV4Entry",
                    value: elem
                })) && $ao40(elem, _path + ".strategies[" + _index9 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index9 + "]",
                    expected: "SelectionConfigV4Entry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigV4Entry>",
                    value: input.strategies
                })) && (undefined === input.lightlyPathRegex || "string" === typeof input.lightlyPathRegex && (1 <= input.lightlyPathRegex.length || $guard(_exceptionable, {
                    path: _path + ".lightlyPathRegex",
                    expected: "string (@minLength 1)",
                    value: input.lightlyPathRegex
                })) || $guard(_exceptionable, {
                    path: _path + ".lightlyPathRegex",
                    expected: "(string | undefined)",
                    value: input.lightlyPathRegex
                })) && (undefined === input.autoTasks || ("object" === typeof input.autoTasks && null !== input.autoTasks || $guard(_exceptionable, {
                    path: _path + ".autoTasks",
                    expected: "(AutoTasks | undefined)",
                    value: input.autoTasks
                })) && $ao43(input.autoTasks, _path + ".autoTasks", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".autoTasks",
                    expected: "(AutoTasks | undefined)",
                    value: input.autoTasks
                }));
                const $ao40 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV4EntryInput",
                    value: input.input
                })) && $ao41(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigV4EntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV4EntryStrategy",
                    value: input.strategy
                })) && $ao42(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigV4EntryStrategy",
                    value: input.strategy
                }));
                const $ao41 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigV4EntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigV4EntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigV4EntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigV4EntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigV4EntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index10: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index10 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao42 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao18(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && !Number.isNaN(input.numNearestNeighbors) && (Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@type int)",
                    value: input.numNearestNeighbors
                })) && (2 <= input.numNearestNeighbors || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "number (@minimum 2)",
                    value: input.numNearestNeighbors
                })) || $guard(_exceptionable, {
                    path: _path + ".numNearestNeighbors",
                    expected: "(number | undefined)",
                    value: input.numNearestNeighbors
                })) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && !Number.isNaN(input.stoppingConditionMinimumTypicality) && (0 < input.stoppingConditionMinimumTypicality || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "number (@exclusiveMinimum 0)",
                    value: input.stoppingConditionMinimumTypicality
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMinimumTypicality",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMinimumTypicality
                })) && (undefined === input.strength || "number" === typeof input.strength && (-1000000000 <= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@minimum -1000000000)",
                    value: input.strength
                })) && (1000000000 >= input.strength || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "number (@maximum 1000000000)",
                    value: input.strength
                })) || $guard(_exceptionable, {
                    path: _path + ".strength",
                    expected: "(number | undefined)",
                    value: input.strength
                })) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && !Number.isNaN(input.stoppingConditionMaxSum) && (0 <= input.stoppingConditionMaxSum || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "number (@minimum 0)",
                    value: input.stoppingConditionMaxSum
                })) || $guard(_exceptionable, {
                    path: _path + ".stoppingConditionMaxSum",
                    expected: "(number | undefined)",
                    value: input.stoppingConditionMaxSum
                })) && (undefined === input.targetRange || ("object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && $ao34(input.targetRange, _path + ".targetRange", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".targetRange",
                    expected: "(SelectionConfigV3EntryStrategyAllOfTargetRange | undefined)",
                    value: input.targetRange
                })) && (undefined === input.distribution || "TARGET" === input.distribution || "UNIFORM" === input.distribution || "INPUT" === input.distribution || $guard(_exceptionable, {
                    path: _path + ".distribution",
                    expected: "(\"INPUT\" | \"TARGET\" | \"UNIFORM\" | undefined)",
                    value: input.distribution
                }));
                const $ao43 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return ("object" === typeof value && null !== value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                            value: value
                        })) && $au0(value, _path + $join(key), true && _exceptionable) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                            value: value
                        });
                    return true;
                }));
                const $ao44 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("AutoTaskCrop" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"AutoTaskCrop\"",
                    value: input.type
                })) && ((Array.isArray(input.bboxs) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && input.bboxs.every((elem: any, _index11: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index11 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) && $ao45(elem, _path + ".bboxs[" + _index11 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index11 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                const $ao45 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value && !Number.isNaN(value) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return true;
                }));
                const $ao46 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("AutoTaskTiling" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"AutoTaskTiling\"",
                    value: input.type
                })) && ("number" === typeof input.numRows && !Number.isNaN(input.numRows) && (Math.floor(input.numRows) === input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (-2147483648 <= input.numRows && input.numRows <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (1 <= input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@minimum 1)",
                    value: input.numRows
                })) || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number",
                    value: input.numRows
                })) && ("number" === typeof input.numCols && !Number.isNaN(input.numCols) && (Math.floor(input.numCols) === input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (-2147483648 <= input.numCols && input.numCols <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (1 <= input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@minimum 1)",
                    value: input.numCols
                })) || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number",
                    value: input.numCols
                })) && (undefined === input.overlap || "number" === typeof input.overlap && !Number.isNaN(input.overlap) && (0 <= input.overlap || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "number (@minimum 0)",
                    value: input.overlap
                })) || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "(number | undefined)",
                    value: input.overlap
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                const $ao47 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("CROP" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"CROP\"",
                    value: input.type
                })) && ((Array.isArray(input.bboxs) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && input.bboxs.every((elem: any, _index12: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index12 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) && $ao45(elem, _path + ".bboxs[" + _index12 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index12 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                const $ao48 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("TILING" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"TILING\"",
                    value: input.type
                })) && ("number" === typeof input.numRows && !Number.isNaN(input.numRows) && (Math.floor(input.numRows) === input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (-2147483648 <= input.numRows && input.numRows <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@type int)",
                    value: input.numRows
                })) && (1 <= input.numRows || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number (@minimum 1)",
                    value: input.numRows
                })) || $guard(_exceptionable, {
                    path: _path + ".numRows",
                    expected: "number",
                    value: input.numRows
                })) && ("number" === typeof input.numCols && !Number.isNaN(input.numCols) && (Math.floor(input.numCols) === input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (-2147483648 <= input.numCols && input.numCols <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@type int)",
                    value: input.numCols
                })) && (1 <= input.numCols || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number (@minimum 1)",
                    value: input.numCols
                })) || $guard(_exceptionable, {
                    path: _path + ".numCols",
                    expected: "number",
                    value: input.numCols
                })) && (undefined === input.overlap || "number" === typeof input.overlap && !Number.isNaN(input.overlap) && (0 <= input.overlap || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "number (@minimum 0)",
                    value: input.overlap
                })) || $guard(_exceptionable, {
                    path: _path + ".overlap",
                    expected: "(number | undefined)",
                    value: input.overlap
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                const $ao49 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("V2" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"V2\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV2",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao50 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("V3" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"V3\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && $ao20(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV3",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao51 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("V4" === input.version || $guard(_exceptionable, {
                    path: _path + ".version",
                    expected: "\"V4\"",
                    value: input.version
                })) && (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && $ao36(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfigV4",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $au0 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
                    if ("AutoTaskCrop" === input.type)
                        return $ao44(input, _path, true && _exceptionable);
                    if ("AutoTaskTiling" === input.type)
                        return $ao46(input, _path, true && _exceptionable);
                    if ("CROP" === input.type)
                        return $ao47(input, _path, true && _exceptionable);
                    if ("TILING" === input.type)
                        return $ao48(input, _path, true && _exceptionable);
                    return $guard(_exceptionable, {
                        path: _path,
                        expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                        value: input
                    });
                })();
                const $au1 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
                    if ("V4" === input.version)
                        return $ao51(input, _path, true && _exceptionable);
                    if ("V3" === input.version)
                        return $ao50(input, _path, true && _exceptionable);
                    if ("V2" === input.version)
                        return $ao49(input, _path, true && _exceptionable);
                    if ("DockerWorkerConfigOmniV4CreateRequest" === input.version)
                        return $ao35(input, _path, true && _exceptionable);
                    if ("DockerWorkerConfigOmniV3CreateRequest" === input.version)
                        return $ao19(input, _path, true && _exceptionable);
                    if ("DockerWorkerConfigOmniV2CreateRequest" === input.version)
                        return $ao0(input, _path, true && _exceptionable);
                    return $guard(_exceptionable, {
                        path: _path,
                        expected: "({ version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest)",
                        value: input
                    });
                })();
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "({ version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest)",
                    value: input
                })) && $au1(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "({ version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest)",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateDockerWorkerConfigVXRequestBody): string => {
        const $io0 = (input: any): boolean => "DockerWorkerConfigOmniV2CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io1(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
        const $io1 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io7(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io14(input.selection));
        const $io2 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io4(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.method || "coreset" === input.method || "random" === input.method) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.objectLevel || "object" === typeof input.objectLevel && null !== input.objectLevel && false === Array.isArray(input.objectLevel) && $io5(input.objectLevel)) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io6(input.stoppingCondition)) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport);
        const $io3 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
        const $io4 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll);
        const $io5 = (input: any): boolean => (undefined === input.cropDatasetName || "string" === typeof input.cropDatasetName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_cropDatasetName", "string", "", input.cropDatasetName)) && (undefined === input.padding || "number" === typeof input.padding) && (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV2DockerObjectLevel_taskName", "string", "", input.taskName));
        const $io6 = (input: any): boolean => (undefined === input.minDistance || "number" === typeof input.minDistance) && (undefined === input.nSamples || "number" === typeof input.nSamples);
        const $io7 = (input: any): boolean => (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io9(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io10(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io13(input.collate));
        const $io8 = (input: any): boolean => (undefined === input.batchSize || "number" === typeof input.batchSize && Math.floor(input.batchSize) === input.batchSize && (-2147483648 <= input.batchSize && input.batchSize <= 2147483647) && 1 <= input.batchSize) && (undefined === input.shuffle || "boolean" === typeof input.shuffle) && (undefined === input.numWorkers || "number" === typeof input.numWorkers && Math.floor(input.numWorkers) === input.numWorkers && (-2147483648 <= input.numWorkers && input.numWorkers <= 2147483647) && -1 <= input.numWorkers) && (undefined === input.dropLast || "boolean" === typeof input.dropLast);
        const $io9 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
        const $io10 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
        const $io11 = (input: any): boolean => undefined === input.temperature || "number" === typeof input.temperature && 0 < input.temperature;
        const $io12 = (input: any): boolean => (undefined === input.lr || "number" === typeof input.lr && 0 <= input.lr) && (undefined === input.weightDecay || "number" === typeof input.weightDecay && 0 <= input.weightDecay && 1 >= input.weightDecay);
        const $io13 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb);
        const $io14 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io15(elem)));
        const $io15 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io16(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io17(input.strategy));
        const $io16 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io17 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target));
        const $io18 = (input: any): boolean => true;
        const $io19 = (input: any): boolean => "DockerWorkerConfigOmniV3CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io20(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
        const $io20 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io21(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io25(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io30(input.selection));
        const $io21 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV3Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io22(input.datasource)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io24(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished);
        const $io22 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io23(input.inputExpiration));
        const $io23 = (input: any): boolean => "number" === typeof input.minDaysToExpiration && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy);
        const $io24 = (input: any): boolean => undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName);
        const $io25 = (input: any): boolean => (undefined === input.seed || "number" === typeof input.seed && Math.floor(input.seed) === input.seed && (-2147483648 <= input.seed && input.seed <= 2147483647)) && (undefined === input.checkpointCallback || "object" === typeof input.checkpointCallback && null !== input.checkpointCallback && false === Array.isArray(input.checkpointCallback) && $io26(input.checkpointCallback)) && (undefined === input.loader || "object" === typeof input.loader && null !== input.loader && false === Array.isArray(input.loader) && $io8(input.loader)) && (undefined === input.model || "object" === typeof input.model && null !== input.model && false === Array.isArray(input.model) && $io27(input.model)) && (undefined === input.trainer || "object" === typeof input.trainer && null !== input.trainer && false === Array.isArray(input.trainer) && $io28(input.trainer)) && (undefined === input.criterion || "object" === typeof input.criterion && null !== input.criterion && false === Array.isArray(input.criterion) && $io11(input.criterion)) && (undefined === input.optimizer || "object" === typeof input.optimizer && null !== input.optimizer && false === Array.isArray(input.optimizer) && $io12(input.optimizer)) && (undefined === input.collate || "object" === typeof input.collate && null !== input.collate && false === Array.isArray(input.collate) && $io29(input.collate));
        const $io26 = (input: any): boolean => undefined === input.saveLast || "boolean" === typeof input.saveLast;
        const $io27 = (input: any): boolean => (undefined === input.name || "resnet-18" === input.name || "resnet-34" === input.name || "resnet-50" === input.name || "resnet-101" === input.name || "resnet-152" === input.name) && (undefined === input.outDim || "number" === typeof input.outDim && Math.floor(input.outDim) === input.outDim && (-2147483648 <= input.outDim && input.outDim <= 2147483647) && 1 <= input.outDim) && (undefined === input.numFtrs || "number" === typeof input.numFtrs && Math.floor(input.numFtrs) === input.numFtrs && (-2147483648 <= input.numFtrs && input.numFtrs <= 2147483647) && 1 <= input.numFtrs) && (undefined === input.width || "number" === typeof input.width && Math.floor(input.width) === input.width && (-2147483648 <= input.width && input.width <= 2147483647) && 1 <= input.width);
        const $io28 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
        const $io29 = (input: any): boolean => (undefined === input.inputSize || "number" === typeof input.inputSize && Math.floor(input.inputSize) === input.inputSize && (-2147483648 <= input.inputSize && input.inputSize <= 2147483647) && 1 <= input.inputSize) && (undefined === input.cjProb || "number" === typeof input.cjProb && 0 <= input.cjProb && 1 >= input.cjProb) && (undefined === input.cjBright || "number" === typeof input.cjBright && 0 <= input.cjBright && 1 >= input.cjBright) && (undefined === input.cjContrast || "number" === typeof input.cjContrast && 0 <= input.cjContrast && 1 >= input.cjContrast) && (undefined === input.cjSat || "number" === typeof input.cjSat && 0 <= input.cjSat && 1 >= input.cjSat) && (undefined === input.cjHue || "number" === typeof input.cjHue && 0 <= input.cjHue && 1 >= input.cjHue) && (undefined === input.minScale || "number" === typeof input.minScale && 0 <= input.minScale && 1 >= input.minScale) && (undefined === input.randomGrayScale || "number" === typeof input.randomGrayScale && 0 <= input.randomGrayScale && 1 >= input.randomGrayScale) && (undefined === input.gaussianBlur || "number" === typeof input.gaussianBlur && 0 <= input.gaussianBlur && 1 >= input.gaussianBlur) && (undefined === input.kernelSize || "number" === typeof input.kernelSize && 0 <= input.kernelSize) && (undefined === input.sigmas || Array.isArray(input.sigmas) && input.sigmas.every((elem: any) => "number" === typeof elem)) && (undefined === input.vfProb || "number" === typeof input.vfProb && 0 <= input.vfProb && 1 >= input.vfProb) && (undefined === input.hfProb || "number" === typeof input.hfProb && 0 <= input.hfProb && 1 >= input.hfProb) && (undefined === input.rrProb || "number" === typeof input.rrProb && 0 <= input.rrProb && 1 >= input.rrProb) && (null === input.rrDegrees || undefined === input.rrDegrees || Array.isArray(input.rrDegrees) && input.rrDegrees.every((elem: any) => "number" === typeof elem));
        const $io30 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io31(elem)));
        const $io31 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io32(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io33(input.strategy));
        const $io32 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV3EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV3EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV3EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV3EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io33 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io34(input.targetRange));
        const $io34 = (input: any): boolean => (undefined === input.minSum || "number" === typeof input.minSum && 0 <= input.minSum) && (undefined === input.maxSum || "number" === typeof input.maxSum && 0 <= input.maxSum);
        const $io35 = (input: any): boolean => "DockerWorkerConfigOmniV4CreateRequest" === input.version && ("object" === typeof input.config && null !== input.config && $io36(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
        const $io36 = (input: any): boolean => "FULL" === input.workerType && (undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io37(input.docker)) && (undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io25(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io39(input.selection));
        const $io37 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io3(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io22(input.datasource)) && (undefined === input.crops || "object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) && $io38(input.crops)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io24(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && Math.floor(input.cacheSize) === input.cacheSize && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647) && -1 <= input.cacheSize);
        const $io38 = (input: any): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || Array.isArray(input.enableUploadForTasks) && input.enableUploadForTasks.every((elem: any) => "string" === typeof elem));
        const $io39 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io40(elem))) && (undefined === input.lightlyPathRegex || "string" === typeof input.lightlyPathRegex && 1 <= input.lightlyPathRegex.length) && (undefined === input.autoTasks || "object" === typeof input.autoTasks && null !== input.autoTasks && $io43(input.autoTasks));
        const $io40 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io41(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io42(input.strategy));
        const $io41 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigV4EntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigV4EntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigV4EntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigV4EntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io42 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || "TYPICALITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io18(input.target)) && (undefined === input.numNearestNeighbors || "number" === typeof input.numNearestNeighbors && Math.floor(input.numNearestNeighbors) === input.numNearestNeighbors && (-2147483648 <= input.numNearestNeighbors && input.numNearestNeighbors <= 2147483647) && 2 <= input.numNearestNeighbors) && (undefined === input.stoppingConditionMinimumTypicality || "number" === typeof input.stoppingConditionMinimumTypicality && 0 < input.stoppingConditionMinimumTypicality) && (undefined === input.strength || "number" === typeof input.strength && -1000000000 <= input.strength && 1000000000 >= input.strength) && (undefined === input.stoppingConditionMaxSum || "number" === typeof input.stoppingConditionMaxSum && 0 <= input.stoppingConditionMaxSum) && (undefined === input.targetRange || "object" === typeof input.targetRange && null !== input.targetRange && false === Array.isArray(input.targetRange) && $io34(input.targetRange)) && (undefined === input.distribution || "TARGET" === input.distribution || "UNIFORM" === input.distribution || "INPUT" === input.distribution);
        const $io43 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "object" === typeof value && null !== value && $iu0(value);
            return true;
        });
        const $io44 = (input: any): boolean => "AutoTaskCrop" === input.type && (Array.isArray(input.bboxs) && input.bboxs.every((elem: any) => "object" === typeof elem && null !== elem && $io45(elem))) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
        const $io45 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "number" === typeof value;
            return true;
        });
        const $io46 = (input: any): boolean => "AutoTaskTiling" === input.type && ("number" === typeof input.numRows && Math.floor(input.numRows) === input.numRows && (-2147483648 <= input.numRows && input.numRows <= 2147483647) && 1 <= input.numRows) && ("number" === typeof input.numCols && Math.floor(input.numCols) === input.numCols && (-2147483648 <= input.numCols && input.numCols <= 2147483647) && 1 <= input.numCols) && (undefined === input.overlap || "number" === typeof input.overlap && 0 <= input.overlap) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
        const $io47 = (input: any): boolean => "CROP" === input.type && (Array.isArray(input.bboxs) && input.bboxs.every((elem: any) => "object" === typeof elem && null !== elem && $io45(elem))) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
        const $io48 = (input: any): boolean => "TILING" === input.type && ("number" === typeof input.numRows && Math.floor(input.numRows) === input.numRows && (-2147483648 <= input.numRows && input.numRows <= 2147483647) && 1 <= input.numRows) && ("number" === typeof input.numCols && Math.floor(input.numCols) === input.numCols && (-2147483648 <= input.numCols && input.numCols <= 2147483647) && 1 <= input.numCols) && (undefined === input.overlap || "number" === typeof input.overlap && 0 <= input.overlap) && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
        const $io49 = (input: any): boolean => "V2" === input.version && ("object" === typeof input.config && null !== input.config && $io1(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
        const $io50 = (input: any): boolean => "V3" === input.version && ("object" === typeof input.config && null !== input.config && $io20(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
        const $io51 = (input: any): boolean => "V4" === input.version && ("object" === typeof input.config && null !== input.config && $io36(input.config)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
        const $iu0 = (input: any): any => (() => {
            if ("AutoTaskCrop" === input.type)
                return $io44(input);
            if ("AutoTaskTiling" === input.type)
                return $io46(input);
            if ("CROP" === input.type)
                return $io47(input);
            if ("TILING" === input.type)
                return $io48(input);
            return false;
        })();
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $tail = (typia.createAssertStringify as any).tail;
        const $join = (typia.createAssertStringify as any).join;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"version":${(() => {
            if ("string" === typeof input.version)
                return $string(input.version);
            if ("string" === typeof input.version)
                return "\"" + input.version + "\"";
            $throws({
                expected: "\"DockerWorkerConfigOmniV2CreateRequest\"",
                value: input.version
            });
        })()},"config":${$so1(input.config)}}`;
        const $so1 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? $so2(input.docker) : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? $so7(input.lightly) : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so14(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so3(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so4(input.datasource) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.method ? "" : `"method":${undefined !== input.method ? (() => {
            if ("string" === typeof input.method)
                return $string(input.method);
            if ("string" === typeof input.method)
                return "\"" + input.method + "\"";
            $throws({
                expected: "(\"coreset\" | \"random\" | undefined)",
                value: input.method
            });
        })() : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.objectLevel ? "" : `"objectLevel":${undefined !== input.objectLevel ? $so5(input.objectLevel) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.stoppingCondition ? "" : `"stoppingCondition":${undefined !== input.stoppingCondition ? $so6(input.stoppingCondition) : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{${$tail(`${undefined === input.corruptionThreshold ? "" : `"corruptionThreshold":${undefined !== input.corruptionThreshold ? input.corruptionThreshold : undefined}`}`)}}`;
        const $so4 = (input: any): any => `{${$tail(`${undefined === input.bypassVerify ? "" : `"bypassVerify":${undefined !== input.bypassVerify ? input.bypassVerify : undefined},`}${undefined === input.enableDatapoolUpdate ? "" : `"enableDatapoolUpdate":${undefined !== input.enableDatapoolUpdate ? input.enableDatapoolUpdate : undefined},`}${undefined === input.processAll ? "" : `"processAll":${undefined !== input.processAll ? input.processAll : undefined}`}`)}}`;
        const $so5 = (input: any): any => `{${$tail(`${undefined === input.cropDatasetName ? "" : `"cropDatasetName":${undefined !== input.cropDatasetName ? $string(input.cropDatasetName) : undefined},`}${undefined === input.padding ? "" : `"padding":${undefined !== input.padding ? input.padding : undefined},`}${undefined === input.taskName ? "" : `"taskName":${undefined !== input.taskName ? $string(input.taskName) : undefined}`}`)}}`;
        const $so6 = (input: any): any => `{${$tail(`${undefined === input.minDistance ? "" : `"minDistance":${undefined !== input.minDistance ? input.minDistance : undefined},`}${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined}`}`)}}`;
        const $so7 = (input: any): any => `{${$tail(`${undefined === input.loader ? "" : `"loader":${undefined !== input.loader ? $so8(input.loader) : undefined},`}${undefined === input.model ? "" : `"model":${undefined !== input.model ? $so9(input.model) : undefined},`}${undefined === input.trainer ? "" : `"trainer":${undefined !== input.trainer ? $so10(input.trainer) : undefined},`}${undefined === input.criterion ? "" : `"criterion":${undefined !== input.criterion ? $so11(input.criterion) : undefined},`}${undefined === input.optimizer ? "" : `"optimizer":${undefined !== input.optimizer ? $so12(input.optimizer) : undefined},`}${undefined === input.collate ? "" : `"collate":${undefined !== input.collate ? $so13(input.collate) : undefined}`}`)}}`;
        const $so8 = (input: any): any => `{${$tail(`${undefined === input.batchSize ? "" : `"batchSize":${undefined !== input.batchSize ? input.batchSize : undefined},`}${undefined === input.shuffle ? "" : `"shuffle":${undefined !== input.shuffle ? input.shuffle : undefined},`}${undefined === input.numWorkers ? "" : `"numWorkers":${undefined !== input.numWorkers ? input.numWorkers : undefined},`}${undefined === input.dropLast ? "" : `"dropLast":${undefined !== input.dropLast ? input.dropLast : undefined}`}`)}}`;
        const $so9 = (input: any): any => `{${$tail(`${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.outDim ? "" : `"outDim":${undefined !== input.outDim ? input.outDim : undefined},`}${undefined === input.numFtrs ? "" : `"numFtrs":${undefined !== input.numFtrs ? input.numFtrs : undefined},`}${undefined === input.width ? "" : `"width":${undefined !== input.width ? input.width : undefined}`}`)}}`;
        const $so10 = (input: any): any => `{${$tail(`${undefined === input.gpus ? "" : `"gpus":${undefined !== input.gpus ? input.gpus : undefined},`}${undefined === input.maxEpochs ? "" : `"maxEpochs":${undefined !== input.maxEpochs ? input.maxEpochs : undefined},`}${undefined === input.precision ? "" : `"precision":${undefined !== input.precision ? input.precision : undefined}`}`)}}`;
        const $so11 = (input: any): any => `{${$tail(`${undefined === input.temperature ? "" : `"temperature":${undefined !== input.temperature ? input.temperature : undefined}`}`)}}`;
        const $so12 = (input: any): any => `{${$tail(`${undefined === input.lr ? "" : `"lr":${undefined !== input.lr ? input.lr : undefined},`}${undefined === input.weightDecay ? "" : `"weightDecay":${undefined !== input.weightDecay ? input.weightDecay : undefined}`}`)}}`;
        const $so13 = (input: any): any => `{${$tail(`${undefined === input.inputSize ? "" : `"inputSize":${undefined !== input.inputSize ? input.inputSize : undefined},`}${undefined === input.cjProb ? "" : `"cjProb":${undefined !== input.cjProb ? input.cjProb : undefined},`}${undefined === input.cjBright ? "" : `"cjBright":${undefined !== input.cjBright ? input.cjBright : undefined},`}${undefined === input.cjContrast ? "" : `"cjContrast":${undefined !== input.cjContrast ? input.cjContrast : undefined},`}${undefined === input.cjSat ? "" : `"cjSat":${undefined !== input.cjSat ? input.cjSat : undefined},`}${undefined === input.cjHue ? "" : `"cjHue":${undefined !== input.cjHue ? input.cjHue : undefined},`}${undefined === input.minScale ? "" : `"minScale":${undefined !== input.minScale ? input.minScale : undefined},`}${undefined === input.randomGrayScale ? "" : `"randomGrayScale":${undefined !== input.randomGrayScale ? input.randomGrayScale : undefined},`}${undefined === input.gaussianBlur ? "" : `"gaussianBlur":${undefined !== input.gaussianBlur ? input.gaussianBlur : undefined},`}${undefined === input.kernelSize ? "" : `"kernelSize":${undefined !== input.kernelSize ? input.kernelSize : undefined},`}${undefined === input.sigmas ? "" : `"sigmas":${undefined !== input.sigmas ? `[${input.sigmas.map((elem: any) => elem).join(",")}]` : undefined},`}${undefined === input.vfProb ? "" : `"vfProb":${undefined !== input.vfProb ? input.vfProb : undefined},`}${undefined === input.hfProb ? "" : `"hfProb":${undefined !== input.hfProb ? input.hfProb : undefined},`}${undefined === input.rrProb ? "" : `"rrProb":${undefined !== input.rrProb ? input.rrProb : undefined}`}`)}}`;
        const $so14 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so15(elem)).join(",")}]`}}`;
        const $so15 = (input: any): any => `{"input":${$so16(input.input)},"strategy":${$so17(input.strategy)}}`;
        const $so16 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so17 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        const $so19 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"version":${(() => {
            if ("string" === typeof input.version)
                return $string(input.version);
            if ("string" === typeof input.version)
                return "\"" + input.version + "\"";
            $throws({
                expected: "\"DockerWorkerConfigOmniV3CreateRequest\"",
                value: input.version
            });
        })()},"config":${$so20(input.config)}}`;
        const $so20 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? $so21(input.docker) : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? $so25(input.lightly) : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so30(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so21 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.checkpointRunId ? "" : `"checkpointRunId":${undefined !== input.checkpointRunId ? $string(input.checkpointRunId) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so3(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so22(input.datasource) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.training ? "" : `"training":${undefined !== input.training ? $so24(input.training) : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.numProcesses ? "" : `"numProcesses":${undefined !== input.numProcesses ? input.numProcesses : undefined},`}${undefined === input.numThreads ? "" : `"numThreads":${undefined !== input.numThreads ? input.numThreads : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined},`}${undefined === input.shutdownWhenJobFinished ? "" : `"shutdownWhenJobFinished":${undefined !== input.shutdownWhenJobFinished ? input.shutdownWhenJobFinished : undefined}`}`)}}`;
        const $so22 = (input: any): any => `{${$tail(`${undefined === input.bypassVerify ? "" : `"bypassVerify":${undefined !== input.bypassVerify ? input.bypassVerify : undefined},`}${undefined === input.enableDatapoolUpdate ? "" : `"enableDatapoolUpdate":${undefined !== input.enableDatapoolUpdate ? input.enableDatapoolUpdate : undefined},`}${undefined === input.processAll ? "" : `"processAll":${undefined !== input.processAll ? input.processAll : undefined},`}${undefined === input.inputExpiration ? "" : `"inputExpiration":${undefined !== input.inputExpiration ? $so23(input.inputExpiration) : undefined}`}`)}}`;
        const $so23 = (input: any): any => `{"minDaysToExpiration":${input.minDaysToExpiration},"handlingStrategy":${(() => {
            if ("string" === typeof input.handlingStrategy)
                return $string(input.handlingStrategy);
            if ("string" === typeof input.handlingStrategy)
                return "\"" + input.handlingStrategy + "\"";
            $throws({
                expected: "(\"ABORT\" | \"SKIP\")",
                value: input.handlingStrategy
            });
        })()}}`;
        const $so24 = (input: any): any => `{${$tail(`${undefined === input.taskName ? "" : `"taskName":${undefined !== input.taskName ? $string(input.taskName) : undefined}`}`)}}`;
        const $so25 = (input: any): any => `{${$tail(`${undefined === input.seed ? "" : `"seed":${undefined !== input.seed ? input.seed : undefined},`}${undefined === input.checkpointCallback ? "" : `"checkpointCallback":${undefined !== input.checkpointCallback ? $so26(input.checkpointCallback) : undefined},`}${undefined === input.loader ? "" : `"loader":${undefined !== input.loader ? $so8(input.loader) : undefined},`}${undefined === input.model ? "" : `"model":${undefined !== input.model ? $so27(input.model) : undefined},`}${undefined === input.trainer ? "" : `"trainer":${undefined !== input.trainer ? $so28(input.trainer) : undefined},`}${undefined === input.criterion ? "" : `"criterion":${undefined !== input.criterion ? $so11(input.criterion) : undefined},`}${undefined === input.optimizer ? "" : `"optimizer":${undefined !== input.optimizer ? $so12(input.optimizer) : undefined},`}${undefined === input.collate ? "" : `"collate":${undefined !== input.collate ? $so29(input.collate) : undefined}`}`)}}`;
        const $so26 = (input: any): any => `{${$tail(`${undefined === input.saveLast ? "" : `"saveLast":${undefined !== input.saveLast ? input.saveLast : undefined}`}`)}}`;
        const $so27 = (input: any): any => `{${$tail(`${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"resnet-101\" | \"resnet-152\" | \"resnet-18\" | \"resnet-34\" | \"resnet-50\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.outDim ? "" : `"outDim":${undefined !== input.outDim ? input.outDim : undefined},`}${undefined === input.numFtrs ? "" : `"numFtrs":${undefined !== input.numFtrs ? input.numFtrs : undefined},`}${undefined === input.width ? "" : `"width":${undefined !== input.width ? input.width : undefined}`}`)}}`;
        const $so28 = (input: any): any => `{${$tail(`${undefined === input.gpus ? "" : `"gpus":${undefined !== input.gpus ? input.gpus : undefined},`}${undefined === input.maxEpochs ? "" : `"maxEpochs":${undefined !== input.maxEpochs ? input.maxEpochs : undefined},`}${undefined === input.precision ? "" : `"precision":${undefined !== input.precision ? input.precision : undefined}`}`)}}`;
        const $so29 = (input: any): any => `{${$tail(`${undefined === input.inputSize ? "" : `"inputSize":${undefined !== input.inputSize ? input.inputSize : undefined},`}${undefined === input.cjProb ? "" : `"cjProb":${undefined !== input.cjProb ? input.cjProb : undefined},`}${undefined === input.cjBright ? "" : `"cjBright":${undefined !== input.cjBright ? input.cjBright : undefined},`}${undefined === input.cjContrast ? "" : `"cjContrast":${undefined !== input.cjContrast ? input.cjContrast : undefined},`}${undefined === input.cjSat ? "" : `"cjSat":${undefined !== input.cjSat ? input.cjSat : undefined},`}${undefined === input.cjHue ? "" : `"cjHue":${undefined !== input.cjHue ? input.cjHue : undefined},`}${undefined === input.minScale ? "" : `"minScale":${undefined !== input.minScale ? input.minScale : undefined},`}${undefined === input.randomGrayScale ? "" : `"randomGrayScale":${undefined !== input.randomGrayScale ? input.randomGrayScale : undefined},`}${undefined === input.gaussianBlur ? "" : `"gaussianBlur":${undefined !== input.gaussianBlur ? input.gaussianBlur : undefined},`}${undefined === input.kernelSize ? "" : `"kernelSize":${undefined !== input.kernelSize ? input.kernelSize : undefined},`}${undefined === input.sigmas ? "" : `"sigmas":${undefined !== input.sigmas ? `[${input.sigmas.map((elem: any) => elem).join(",")}]` : undefined},`}${undefined === input.vfProb ? "" : `"vfProb":${undefined !== input.vfProb ? input.vfProb : undefined},`}${undefined === input.hfProb ? "" : `"hfProb":${undefined !== input.hfProb ? input.hfProb : undefined},`}${undefined === input.rrProb ? "" : `"rrProb":${undefined !== input.rrProb ? input.rrProb : undefined},`}${undefined === input.rrDegrees ? "" : `"rrDegrees":${undefined !== input.rrDegrees ? null !== input.rrDegrees ? `[${input.rrDegrees.map((elem: any) => elem).join(",")}]` : "null" : undefined}`}`)}}`;
        const $so30 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so31(elem)).join(",")}]`}}`;
        const $so31 = (input: any): any => `{"input":${$so32(input.input)},"strategy":${$so33(input.strategy)}}`;
        const $so32 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so33 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}${undefined === input.numNearestNeighbors ? "" : `"numNearestNeighbors":${undefined !== input.numNearestNeighbors ? input.numNearestNeighbors : undefined},`}${undefined === input.stoppingConditionMinimumTypicality ? "" : `"stoppingConditionMinimumTypicality":${undefined !== input.stoppingConditionMinimumTypicality ? input.stoppingConditionMinimumTypicality : undefined},`}${undefined === input.strength ? "" : `"strength":${undefined !== input.strength ? input.strength : undefined},`}${undefined === input.stoppingConditionMaxSum ? "" : `"stoppingConditionMaxSum":${undefined !== input.stoppingConditionMaxSum ? input.stoppingConditionMaxSum : undefined},`}${undefined === input.targetRange ? "" : `"targetRange":${undefined !== input.targetRange ? $so34(input.targetRange) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        const $so34 = (input: any): any => `{${$tail(`${undefined === input.minSum ? "" : `"minSum":${undefined !== input.minSum ? input.minSum : undefined},`}${undefined === input.maxSum ? "" : `"maxSum":${undefined !== input.maxSum ? input.maxSum : undefined}`}`)}}`;
        const $so35 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"version":${(() => {
            if ("string" === typeof input.version)
                return $string(input.version);
            if ("string" === typeof input.version)
                return "\"" + input.version + "\"";
            $throws({
                expected: "\"DockerWorkerConfigOmniV4CreateRequest\"",
                value: input.version
            });
        })()},"config":${$so36(input.config)}}`;
        const $so36 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? $so37(input.docker) : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? $so25(input.lightly) : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so39(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so37 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.checkpointRunId ? "" : `"checkpointRunId":${undefined !== input.checkpointRunId ? $string(input.checkpointRunId) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so3(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so22(input.datasource) : undefined},`}${undefined === input.crops ? "" : `"crops":${undefined !== input.crops ? $so38(input.crops) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.training ? "" : `"training":${undefined !== input.training ? $so24(input.training) : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.numProcesses ? "" : `"numProcesses":${undefined !== input.numProcesses ? input.numProcesses : undefined},`}${undefined === input.numThreads ? "" : `"numThreads":${undefined !== input.numThreads ? input.numThreads : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined},`}${undefined === input.useDatapool ? "" : `"useDatapool":${undefined !== input.useDatapool ? input.useDatapool : undefined},`}${undefined === input.shutdownWhenJobFinished ? "" : `"shutdownWhenJobFinished":${undefined !== input.shutdownWhenJobFinished ? input.shutdownWhenJobFinished : undefined},`}${undefined === input.cacheSize ? "" : `"cacheSize":${undefined !== input.cacheSize ? input.cacheSize : undefined}`}`)}}`;
        const $so38 = (input: any): any => `{${$tail(`${undefined === input.enableUpload ? "" : `"enableUpload":${undefined !== input.enableUpload ? input.enableUpload : undefined},`}${undefined === input.enableUploadForTasks ? "" : `"enableUploadForTasks":${undefined !== input.enableUploadForTasks ? null !== input.enableUploadForTasks ? `[${input.enableUploadForTasks.map((elem: any) => $string(elem)).join(",")}]` : "null" : undefined}`}`)}}`;
        const $so39 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}${undefined === input.lightlyPathRegex ? "" : `"lightlyPathRegex":${undefined !== input.lightlyPathRegex ? $string(input.lightlyPathRegex) : undefined},`}${undefined === input.autoTasks ? "" : `"autoTasks":${undefined !== input.autoTasks ? $so43(input.autoTasks) : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so40(elem)).join(",")}]`}}`;
        const $so40 = (input: any): any => `{"input":${$so41(input.input)},"strategy":${$so42(input.strategy)}}`;
        const $so41 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so42 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}${undefined === input.numNearestNeighbors ? "" : `"numNearestNeighbors":${undefined !== input.numNearestNeighbors ? input.numNearestNeighbors : undefined},`}${undefined === input.stoppingConditionMinimumTypicality ? "" : `"stoppingConditionMinimumTypicality":${undefined !== input.stoppingConditionMinimumTypicality ? input.stoppingConditionMinimumTypicality : undefined},`}${undefined === input.strength ? "" : `"strength":${undefined !== input.strength ? input.strength : undefined},`}${undefined === input.stoppingConditionMaxSum ? "" : `"stoppingConditionMaxSum":${undefined !== input.stoppingConditionMaxSum ? input.stoppingConditionMaxSum : undefined},`}${undefined === input.targetRange ? "" : `"targetRange":${undefined !== input.targetRange ? $so34(input.targetRange) : undefined},`}${undefined === input.distribution ? "" : `"distribution":${undefined !== input.distribution ? (() => {
            if ("string" === typeof input.distribution)
                return $string(input.distribution);
            if ("string" === typeof input.distribution)
                return "\"" + input.distribution + "\"";
            $throws({
                expected: "(\"INPUT\" | \"TARGET\" | \"UNIFORM\" | undefined)",
                value: input.distribution
            });
        })() : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"TYPICALITY\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        const $so43 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$su0(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        const $so44 = (input: any): any => `{"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"AutoTaskCrop\"",
                value: input.type
            });
        })()},"bboxs":${`[${input.bboxs.map((elem: any) => $so45(elem)).join(",")}]`},"name":${$string(input.name)}}`;
        const $so45 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${value}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        const $so46 = (input: any): any => `{${undefined === input.overlap ? "" : `"overlap":${undefined !== input.overlap ? input.overlap : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"AutoTaskTiling\"",
                value: input.type
            });
        })()},"numRows":${input.numRows},"numCols":${input.numCols},"name":${$string(input.name)}}`;
        const $so47 = (input: any): any => `{"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"CROP\"",
                value: input.type
            });
        })()},"bboxs":${`[${input.bboxs.map((elem: any) => $so45(elem)).join(",")}]`},"name":${$string(input.name)}}`;
        const $so48 = (input: any): any => `{${undefined === input.overlap ? "" : `"overlap":${undefined !== input.overlap ? input.overlap : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"TILING\"",
                value: input.type
            });
        })()},"numRows":${input.numRows},"numCols":${input.numCols},"name":${$string(input.name)}}`;
        const $so49 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"version":${(() => {
            if ("string" === typeof input.version)
                return $string(input.version);
            if ("string" === typeof input.version)
                return "\"" + input.version + "\"";
            $throws({
                expected: "\"V2\"",
                value: input.version
            });
        })()},"config":${$so1(input.config)}}`;
        const $so50 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"version":${(() => {
            if ("string" === typeof input.version)
                return $string(input.version);
            if ("string" === typeof input.version)
                return "\"" + input.version + "\"";
            $throws({
                expected: "\"V3\"",
                value: input.version
            });
        })()},"config":${$so20(input.config)}}`;
        const $so51 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"version":${(() => {
            if ("string" === typeof input.version)
                return $string(input.version);
            if ("string" === typeof input.version)
                return "\"" + input.version + "\"";
            $throws({
                expected: "\"V4\"",
                value: input.version
            });
        })()},"config":${$so36(input.config)}}`;
        const $su0 = (input: any): any => (() => {
            if ("AutoTaskCrop" === input.type)
                return $so44(input);
            if ("AutoTaskTiling" === input.type)
                return $so46(input);
            if ("CROP" === input.type)
                return $so47(input);
            if ("TILING" === input.type)
                return $so48(input);
            $throws({
                expected: "({ type: \"AutoTaskCrop\"; } & AutoTaskCrop | { type: \"AutoTaskTiling\"; } & AutoTaskTiling | { type: \"CROP\"; } & AutoTaskCrop | { type: \"TILING\"; } & AutoTaskTiling)",
                value: input
            });
        })();
        const $su1 = (input: any): any => (() => {
            if ("V4" === input.version)
                return $so51(input);
            if ("V3" === input.version)
                return $so50(input);
            if ("V2" === input.version)
                return $so49(input);
            if ("DockerWorkerConfigOmniV4CreateRequest" === input.version)
                return $so35(input);
            if ("DockerWorkerConfigOmniV3CreateRequest" === input.version)
                return $so19(input);
            if ("DockerWorkerConfigOmniV2CreateRequest" === input.version)
                return $so0(input);
            $throws({
                expected: "({ version: \"V4\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"V3\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"V2\"; } & DockerWorkerConfigOmniV2CreateRequest | { version: \"DockerWorkerConfigOmniV4CreateRequest\"; } & DockerWorkerConfigOmniV4CreateRequest | { version: \"DockerWorkerConfigOmniV3CreateRequest\"; } & DockerWorkerConfigOmniV3CreateRequest | { version: \"DockerWorkerConfigOmniV2CreateRequest\"; } & DockerWorkerConfigOmniV2CreateRequest)",
                value: input
            });
        })();
        return $su1(input);
    }; return stringify(assert(input)); })(input);
};
export type PostDockerAuthorizationRequestRequestBody = DockerAuthorizationRequest;
export const PostDockerAuthorizationRequestRequestBodySanitizer = DockerAuthorizationRequestFromJSON;
export const PostDockerAuthorizationRequestRequestBodyValidator = DockerAuthorizationRequestValidator;
export const PostDockerAuthorizationRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): PostDockerAuthorizationRequestRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is PostDockerAuthorizationRequestRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.timestamp && 0 <= input.timestamp && ("object" === typeof input.taskDescription && null !== input.taskDescription && $io1(input.taskDescription, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["timestamp", "taskDescription"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.embeddingsFilename && "string" === typeof input.embeddingsHash && ("ACTIVE_LEARNING" === input.method || "CORAL" === input.method || "CORESET" === input.method || "RANDOM" === input.method) && "string" === typeof input.existingSelectionColumnName && "string" === typeof input.activeLearningScoresColumnName && "string" === typeof input.maskedOutColumnName && ("object" === typeof input.samplingConfig && null !== input.samplingConfig && false === Array.isArray(input.samplingConfig) && $io2(input.samplingConfig, true && _exceptionable)) && ("number" === typeof input.nData && 0 <= input.nData) && (8 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["embeddingsFilename", "embeddingsHash", "method", "existingSelectionColumnName", "activeLearningScoresColumnName", "maskedOutColumnName", "samplingConfig", "nData"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io3(input.stoppingCondition, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["stoppingCondition"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples) && (undefined === input.minDistance || "number" === typeof input.minDistance) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "minDistance"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PostDockerAuthorizationRequestRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.timestamp && (0 <= input.timestamp || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number (@minimum 0)",
                    value: input.timestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number",
                    value: input.timestamp
                })) && (("object" === typeof input.taskDescription && null !== input.taskDescription || $guard(_exceptionable, {
                    path: _path + ".taskDescription",
                    expected: "DockerTaskDescription",
                    value: input.taskDescription
                })) && $ao1(input.taskDescription, _path + ".taskDescription", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".taskDescription",
                    expected: "DockerTaskDescription",
                    value: input.taskDescription
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["timestamp", "taskDescription"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.embeddingsFilename || $guard(_exceptionable, {
                    path: _path + ".embeddingsFilename",
                    expected: "string",
                    value: input.embeddingsFilename
                })) && ("string" === typeof input.embeddingsHash || $guard(_exceptionable, {
                    path: _path + ".embeddingsHash",
                    expected: "string",
                    value: input.embeddingsHash
                })) && ("ACTIVE_LEARNING" === input.method || "CORAL" === input.method || "CORESET" === input.method || "RANDOM" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"ACTIVE_LEARNING\" | \"CORAL\" | \"CORESET\" | \"RANDOM\")",
                    value: input.method
                })) && ("string" === typeof input.existingSelectionColumnName || $guard(_exceptionable, {
                    path: _path + ".existingSelectionColumnName",
                    expected: "string",
                    value: input.existingSelectionColumnName
                })) && ("string" === typeof input.activeLearningScoresColumnName || $guard(_exceptionable, {
                    path: _path + ".activeLearningScoresColumnName",
                    expected: "string",
                    value: input.activeLearningScoresColumnName
                })) && ("string" === typeof input.maskedOutColumnName || $guard(_exceptionable, {
                    path: _path + ".maskedOutColumnName",
                    expected: "string",
                    value: input.maskedOutColumnName
                })) && (("object" === typeof input.samplingConfig && null !== input.samplingConfig && false === Array.isArray(input.samplingConfig) || $guard(_exceptionable, {
                    path: _path + ".samplingConfig",
                    expected: "SamplingConfig",
                    value: input.samplingConfig
                })) && $ao2(input.samplingConfig, _path + ".samplingConfig", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".samplingConfig",
                    expected: "SamplingConfig",
                    value: input.samplingConfig
                })) && ("number" === typeof input.nData && (0 <= input.nData || $guard(_exceptionable, {
                    path: _path + ".nData",
                    expected: "number (@minimum 0)",
                    value: input.nData
                })) || $guard(_exceptionable, {
                    path: _path + ".nData",
                    expected: "number",
                    value: input.nData
                })) && (8 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["embeddingsFilename", "embeddingsHash", "method", "existingSelectionColumnName", "activeLearningScoresColumnName", "maskedOutColumnName", "samplingConfig", "nData"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(SamplingConfigStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao3(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(SamplingConfigStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["stoppingCondition"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.minDistance || "number" === typeof input.minDistance || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "minDistance"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const PostDockerAuthorizationRequestTypiaAssertStringify = (input: PostDockerAuthorizationRequestRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): PostDockerAuthorizationRequestRequestBody => {
        const __is = (input: any): input is PostDockerAuthorizationRequestRequestBody => {
            const $io0 = (input: any): boolean => "number" === typeof input.timestamp && !Number.isNaN(input.timestamp) && 0 <= input.timestamp && ("object" === typeof input.taskDescription && null !== input.taskDescription && $io1(input.taskDescription));
            const $io1 = (input: any): boolean => "string" === typeof input.embeddingsFilename && "string" === typeof input.embeddingsHash && ("ACTIVE_LEARNING" === input.method || "CORAL" === input.method || "CORESET" === input.method || "RANDOM" === input.method) && "string" === typeof input.existingSelectionColumnName && "string" === typeof input.activeLearningScoresColumnName && "string" === typeof input.maskedOutColumnName && ("object" === typeof input.samplingConfig && null !== input.samplingConfig && false === Array.isArray(input.samplingConfig) && $io2(input.samplingConfig)) && ("number" === typeof input.nData && !Number.isNaN(input.nData) && 0 <= input.nData);
            const $io2 = (input: any): boolean => undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io3(input.stoppingCondition);
            const $io3 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples)) && (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance));
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PostDockerAuthorizationRequestRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.timestamp && !Number.isNaN(input.timestamp) && (0 <= input.timestamp || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number (@minimum 0)",
                    value: input.timestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number",
                    value: input.timestamp
                })) && (("object" === typeof input.taskDescription && null !== input.taskDescription || $guard(_exceptionable, {
                    path: _path + ".taskDescription",
                    expected: "DockerTaskDescription",
                    value: input.taskDescription
                })) && $ao1(input.taskDescription, _path + ".taskDescription", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".taskDescription",
                    expected: "DockerTaskDescription",
                    value: input.taskDescription
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.embeddingsFilename || $guard(_exceptionable, {
                    path: _path + ".embeddingsFilename",
                    expected: "string",
                    value: input.embeddingsFilename
                })) && ("string" === typeof input.embeddingsHash || $guard(_exceptionable, {
                    path: _path + ".embeddingsHash",
                    expected: "string",
                    value: input.embeddingsHash
                })) && ("ACTIVE_LEARNING" === input.method || "CORAL" === input.method || "CORESET" === input.method || "RANDOM" === input.method || $guard(_exceptionable, {
                    path: _path + ".method",
                    expected: "(\"ACTIVE_LEARNING\" | \"CORAL\" | \"CORESET\" | \"RANDOM\")",
                    value: input.method
                })) && ("string" === typeof input.existingSelectionColumnName || $guard(_exceptionable, {
                    path: _path + ".existingSelectionColumnName",
                    expected: "string",
                    value: input.existingSelectionColumnName
                })) && ("string" === typeof input.activeLearningScoresColumnName || $guard(_exceptionable, {
                    path: _path + ".activeLearningScoresColumnName",
                    expected: "string",
                    value: input.activeLearningScoresColumnName
                })) && ("string" === typeof input.maskedOutColumnName || $guard(_exceptionable, {
                    path: _path + ".maskedOutColumnName",
                    expected: "string",
                    value: input.maskedOutColumnName
                })) && (("object" === typeof input.samplingConfig && null !== input.samplingConfig && false === Array.isArray(input.samplingConfig) || $guard(_exceptionable, {
                    path: _path + ".samplingConfig",
                    expected: "SamplingConfig",
                    value: input.samplingConfig
                })) && $ao2(input.samplingConfig, _path + ".samplingConfig", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".samplingConfig",
                    expected: "SamplingConfig",
                    value: input.samplingConfig
                })) && ("number" === typeof input.nData && !Number.isNaN(input.nData) && (0 <= input.nData || $guard(_exceptionable, {
                    path: _path + ".nData",
                    expected: "number (@minimum 0)",
                    value: input.nData
                })) || $guard(_exceptionable, {
                    path: _path + ".nData",
                    expected: "number",
                    value: input.nData
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.stoppingCondition || ("object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(SamplingConfigStoppingCondition | undefined)",
                    value: input.stoppingCondition
                })) && $ao3(input.stoppingCondition, _path + ".stoppingCondition", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".stoppingCondition",
                    expected: "(SamplingConfigStoppingCondition | undefined)",
                    value: input.stoppingCondition
                });
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.minDistance || "number" === typeof input.minDistance && !Number.isNaN(input.minDistance) || $guard(_exceptionable, {
                    path: _path + ".minDistance",
                    expected: "(number | undefined)",
                    value: input.minDistance
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerAuthorizationRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: PostDockerAuthorizationRequestRequestBody): string => {
        const $io1 = (input: any): boolean => "string" === typeof input.embeddingsFilename && "string" === typeof input.embeddingsHash && ("ACTIVE_LEARNING" === input.method || "CORAL" === input.method || "CORESET" === input.method || "RANDOM" === input.method) && "string" === typeof input.existingSelectionColumnName && "string" === typeof input.activeLearningScoresColumnName && "string" === typeof input.maskedOutColumnName && ("object" === typeof input.samplingConfig && null !== input.samplingConfig && false === Array.isArray(input.samplingConfig) && $io2(input.samplingConfig)) && ("number" === typeof input.nData && 0 <= input.nData);
        const $io2 = (input: any): boolean => undefined === input.stoppingCondition || "object" === typeof input.stoppingCondition && null !== input.stoppingCondition && false === Array.isArray(input.stoppingCondition) && $io3(input.stoppingCondition);
        const $io3 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples) && (undefined === input.minDistance || "number" === typeof input.minDistance);
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{"timestamp":${input.timestamp},"taskDescription":${$so1(input.taskDescription)}}`;
        const $so1 = (input: any): any => `{"embeddingsFilename":${$string(input.embeddingsFilename)},"embeddingsHash":${$string(input.embeddingsHash)},"method":${(() => {
            if ("string" === typeof input.method)
                return $string(input.method);
            if ("string" === typeof input.method)
                return "\"" + input.method + "\"";
            $throws({
                expected: "(\"ACTIVE_LEARNING\" | \"CORAL\" | \"CORESET\" | \"RANDOM\")",
                value: input.method
            });
        })()},"existingSelectionColumnName":${$string(input.existingSelectionColumnName)},"activeLearningScoresColumnName":${$string(input.activeLearningScoresColumnName)},"maskedOutColumnName":${$string(input.maskedOutColumnName)},"samplingConfig":${$so2(input.samplingConfig)},"nData":${input.nData}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.stoppingCondition ? "" : `"stoppingCondition":${undefined !== input.stoppingCondition ? $so3(input.stoppingCondition) : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{${$tail(`${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.minDistance ? "" : `"minDistance":${undefined !== input.minDistance ? input.minDistance : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type PostDockerUsageStatsRequestBody = DockerUserStats;
export const PostDockerUsageStatsRequestBodySanitizer = DockerUserStatsFromJSON;
export const PostDockerUsageStatsRequestBodyValidator = DockerUserStatsValidator;
export const PostDockerUsageStatsTypiaAssertEquals = (input: any) => {
    return ((input: any): PostDockerUsageStatsRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is PostDockerUsageStatsRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.runId && "string" === typeof input.action && ("object" === typeof input.data && null !== input.data && false === Array.isArray(input.data) && $io1(input.data, true && _exceptionable)) && ("number" === typeof input.timestamp && 0 <= input.timestamp) && "string" === typeof input.pipVersion && "string" === typeof input.dockerVersion && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["runId", "action", "data", "timestamp", "pipVersion", "dockerVersion"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PostDockerUsageStatsRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.runId || $guard(_exceptionable, {
                    path: _path + ".runId",
                    expected: "string",
                    value: input.runId
                })) && ("string" === typeof input.action || $guard(_exceptionable, {
                    path: _path + ".action",
                    expected: "string",
                    value: input.action
                })) && (("object" === typeof input.data && null !== input.data && false === Array.isArray(input.data) || $guard(_exceptionable, {
                    path: _path + ".data",
                    expected: "object",
                    value: input.data
                })) && $ao1(input.data, _path + ".data", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".data",
                    expected: "object",
                    value: input.data
                })) && ("number" === typeof input.timestamp && (0 <= input.timestamp || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number (@minimum 0)",
                    value: input.timestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number",
                    value: input.timestamp
                })) && ("string" === typeof input.pipVersion || $guard(_exceptionable, {
                    path: _path + ".pipVersion",
                    expected: "string",
                    value: input.pipVersion
                })) && ("string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "string",
                    value: input.dockerVersion
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["runId", "action", "data", "timestamp", "pipVersion", "dockerVersion"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerUserStats",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerUserStats",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const PostDockerUsageStatsTypiaAssertStringify = (input: PostDockerUsageStatsRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): PostDockerUsageStatsRequestBody => {
        const __is = (input: any): input is PostDockerUsageStatsRequestBody => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).runId && "string" === typeof (input as any).action && ("object" === typeof (input as any).data && null !== (input as any).data && true) && ("number" === typeof (input as any).timestamp && !Number.isNaN((input as any).timestamp) && 0 <= (input as any).timestamp) && "string" === typeof (input as any).pipVersion && "string" === typeof (input as any).dockerVersion);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PostDockerUsageStatsRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.runId || $guard(_exceptionable, {
                    path: _path + ".runId",
                    expected: "string",
                    value: input.runId
                })) && ("string" === typeof input.action || $guard(_exceptionable, {
                    path: _path + ".action",
                    expected: "string",
                    value: input.action
                })) && (("object" === typeof input.data && null !== input.data && false === Array.isArray(input.data) || $guard(_exceptionable, {
                    path: _path + ".data",
                    expected: "object",
                    value: input.data
                })) && $ao1(input.data, _path + ".data", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".data",
                    expected: "object",
                    value: input.data
                })) && ("number" === typeof input.timestamp && !Number.isNaN(input.timestamp) && (0 <= input.timestamp || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number (@minimum 0)",
                    value: input.timestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".timestamp",
                    expected: "number",
                    value: input.timestamp
                })) && ("string" === typeof input.pipVersion || $guard(_exceptionable, {
                    path: _path + ".pipVersion",
                    expected: "string",
                    value: input.pipVersion
                })) && ("string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "string",
                    value: input.dockerVersion
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => true;
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerUserStats",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerUserStats",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: PostDockerUsageStatsRequestBody): string => {
        const $io1 = (input: any): boolean => true;
        const $string = (typia.createAssertStringify as any).string;
        return `{"runId":${$string((input as any).runId)},"action":${$string((input as any).action)},"data":{},"timestamp":${(input as any).timestamp},"pipVersion":${$string((input as any).pipVersion)},"dockerVersion":${$string((input as any).dockerVersion)}}`;
    }; return stringify(assert(input)); })(input);
};
export type PostDockerWorkerAuthorizationRequestRequestBody = DockerWorkerAuthorizationRequest;
export const PostDockerWorkerAuthorizationRequestRequestBodySanitizer = DockerWorkerAuthorizationRequestFromJSON;
export const PostDockerWorkerAuthorizationRequestRequestBodyValidator = DockerWorkerAuthorizationRequestValidator;
export const PostDockerWorkerAuthorizationRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): PostDockerWorkerAuthorizationRequestRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is PostDockerWorkerAuthorizationRequestRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.hashedTaskDescription && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["hashedTaskDescription"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PostDockerWorkerAuthorizationRequestRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.hashedTaskDescription || $guard(_exceptionable, {
                    path: _path + ".hashedTaskDescription",
                    expected: "string",
                    value: input.hashedTaskDescription
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["hashedTaskDescription"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerAuthorizationRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerAuthorizationRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const PostDockerWorkerAuthorizationRequestTypiaAssertStringify = (input: PostDockerWorkerAuthorizationRequestRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): PostDockerWorkerAuthorizationRequestRequestBody => {
        const __is = (input: any): input is PostDockerWorkerAuthorizationRequestRequestBody => {
            return "object" === typeof input && null !== input && "string" === typeof (input as any).hashedTaskDescription;
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is PostDockerWorkerAuthorizationRequestRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "string" === typeof input.hashedTaskDescription || $guard(_exceptionable, {
                    path: _path + ".hashedTaskDescription",
                    expected: "string",
                    value: input.hashedTaskDescription
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerAuthorizationRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerAuthorizationRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: PostDockerWorkerAuthorizationRequestRequestBody): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"hashedTaskDescription":${$string((input as any).hashedTaskDescription)}}`;
    }; return stringify(assert(input)); })(input);
};
export type RegisterDockerWorkerRequestBody = CreateDockerWorkerRegistryEntryRequest;
export const RegisterDockerWorkerRequestBodySanitizer = CreateDockerWorkerRegistryEntryRequestFromJSON;
export const RegisterDockerWorkerRequestBodyValidator = CreateDockerWorkerRegistryEntryRequestValidator;
export const RegisterDockerWorkerTypiaAssertEquals = (input: any) => {
    return ((input: any): RegisterDockerWorkerRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is RegisterDockerWorkerRequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.name && 3 <= input.name.length && $is_custom("pattern_CreateDockerWorkerRegistryEntryRequest_name", "string", "", input.name) && "FULL" === input.workerType && (undefined === input.labels || "object" === typeof input.labels && null !== input.labels && $io1(input.labels, true && _exceptionable)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name", "workerType", "labels", "creator", "dockerVersion"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is RegisterDockerWorkerRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.name && (3 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 3)",
                    value: input.name
                })) && ($is_custom("pattern_CreateDockerWorkerRegistryEntryRequest_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_CreateDockerWorkerRegistryEntryRequest_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.labels || ("object" === typeof input.labels && null !== input.labels || $guard(_exceptionable, {
                    path: _path + ".labels",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.labels
                })) && $ao1(input.labels, _path + ".labels", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".labels",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.labels
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "(string | undefined)",
                    value: input.dockerVersion
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name", "workerType", "labels", "creator", "dockerVersion"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "CreateDockerWorkerRegistryEntryRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CreateDockerWorkerRegistryEntryRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const RegisterDockerWorkerTypiaAssertStringify = (input: RegisterDockerWorkerRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): RegisterDockerWorkerRequestBody => {
        const __is = (input: any): input is RegisterDockerWorkerRequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => "string" === typeof input.name && 3 <= input.name.length && $is_custom("pattern_CreateDockerWorkerRegistryEntryRequest_name", "string", "", input.name) && "FULL" === input.workerType && (undefined === input.labels || "object" === typeof input.labels && null !== input.labels && $io1(input.labels)) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion);
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is RegisterDockerWorkerRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.name && (3 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 3)",
                    value: input.name
                })) && ($is_custom("pattern_CreateDockerWorkerRegistryEntryRequest_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_CreateDockerWorkerRegistryEntryRequest_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (undefined === input.labels || ("object" === typeof input.labels && null !== input.labels || $guard(_exceptionable, {
                    path: _path + ".labels",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.labels
                })) && $ao1(input.labels, _path + ".labels", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".labels",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.labels
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "(string | undefined)",
                    value: input.dockerVersion
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "CreateDockerWorkerRegistryEntryRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CreateDockerWorkerRegistryEntryRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: RegisterDockerWorkerRequestBody): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "string" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.labels ? "" : `"labels":${undefined !== input.labels ? $so1(input.labels) : undefined},`}${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}${undefined === input.dockerVersion ? "" : `"dockerVersion":${undefined !== input.dockerVersion ? $string(input.dockerVersion) : undefined},`}"name":${$string(input.name)},"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$string(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type UpdateDockerRunByIdRequestBody = DockerRunUpdateRequest;
export const UpdateDockerRunByIdRequestBodySanitizer = DockerRunUpdateRequestFromJSON;
export const UpdateDockerRunByIdRequestBodyValidator = DockerRunUpdateRequestValidator;
export const UpdateDockerRunByIdTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateDockerRunByIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateDockerRunByIdRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.message || "string" === typeof input.message) && (undefined === input.ts || "number" === typeof input.ts && 0 <= input.ts) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["state", "message", "ts"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDockerRunByIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\")",
                    value: input.state
                })) && (undefined === input.message || "string" === typeof input.message || $guard(_exceptionable, {
                    path: _path + ".message",
                    expected: "(string | undefined)",
                    value: input.message
                })) && (undefined === input.ts || "number" === typeof input.ts && (0 <= input.ts || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "number (@minimum 0)",
                    value: input.ts
                })) || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "(number | undefined)",
                    value: input.ts
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["state", "message", "ts"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateDockerRunByIdTypiaAssertStringify = (input: UpdateDockerRunByIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): UpdateDockerRunByIdRequestBody => {
        const __is = (input: any): input is UpdateDockerRunByIdRequestBody => {
            const $io0 = (input: any): boolean => ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state) && (undefined === input.message || "string" === typeof input.message) && (undefined === input.ts || "number" === typeof input.ts && !Number.isNaN(input.ts) && 0 <= input.ts);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDockerRunByIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("STARTED" === input.state || "INITIALIZING" === input.state || "LOADING_DATASET" === input.state || "LOADING_METADATA" === input.state || "LOADING_PREDICTION" === input.state || "CHECKING_CORRUPTNESS" === input.state || "INITIALIZING_OBJECT_CROPS" === input.state || "COMPUTING_METADATA" === input.state || "TRAINING" === input.state || "EMBEDDING" === input.state || "EMBEDDING_OBJECT_CROPS" === input.state || "PRETAGGING" === input.state || "COMPUTING_ACTIVE_LEARNING_SCORES" === input.state || "SAMPLING" === input.state || "EMBEDDING_FULL_IMAGES" === input.state || "SAVING_RESULTS" === input.state || "UPLOADING_DATASET" === input.state || "GENERATING_REPORT" === input.state || "UPLOADING_REPORT" === input.state || "UPLOADED_REPORT" === input.state || "UPLOADING_ARTIFACTS" === input.state || "UPLOADED_ARTIFACTS" === input.state || "COMPLETED" === input.state || "FAILED" === input.state || "CRASHED" === input.state || "ABORTED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\")",
                    value: input.state
                })) && (undefined === input.message || "string" === typeof input.message || $guard(_exceptionable, {
                    path: _path + ".message",
                    expected: "(string | undefined)",
                    value: input.message
                })) && (undefined === input.ts || "number" === typeof input.ts && !Number.isNaN(input.ts) && (0 <= input.ts || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "number (@minimum 0)",
                    value: input.ts
                })) || $guard(_exceptionable, {
                    path: _path + ".ts",
                    expected: "(number | undefined)",
                    value: input.ts
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateDockerRunByIdRequestBody): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${undefined === input.message ? "" : `"message":${undefined !== input.message ? $string(input.message) : undefined},`}${undefined === input.ts ? "" : `"ts":${undefined !== input.ts ? input.ts : undefined},`}"state":${(() => {
            if ("string" === typeof input.state)
                return $string(input.state);
            if ("string" === typeof input.state)
                return "\"" + input.state + "\"";
            $throws({
                expected: "(\"ABORTED\" | \"CHECKING_CORRUPTNESS\" | \"COMPLETED\" | \"COMPUTING_ACTIVE_LEARNING_SCORES\" | \"COMPUTING_METADATA\" | \"CRASHED\" | \"EMBEDDING\" | \"EMBEDDING_FULL_IMAGES\" | \"EMBEDDING_OBJECT_CROPS\" | \"FAILED\" | \"GENERATING_REPORT\" | \"INITIALIZING\" | \"INITIALIZING_OBJECT_CROPS\" | \"LOADING_DATASET\" | \"LOADING_METADATA\" | \"LOADING_PREDICTION\" | \"PRETAGGING\" | \"SAMPLING\" | \"SAVING_RESULTS\" | \"STARTED\" | \"TRAINING\" | \"UPLOADED_ARTIFACTS\" | \"UPLOADED_REPORT\" | \"UPLOADING_ARTIFACTS\" | \"UPLOADING_DATASET\" | \"UPLOADING_REPORT\")",
                value: input.state
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type UpdateDockerWorkerConfigByIdRequestBody = DockerWorkerConfigCreateRequest;
export const UpdateDockerWorkerConfigByIdRequestBodySanitizer = DockerWorkerConfigCreateRequestFromJSON;
export const UpdateDockerWorkerConfigByIdRequestBodyValidator = DockerWorkerConfigCreateRequestValidator;
export const UpdateDockerWorkerConfigByIdTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateDockerWorkerConfigByIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateDockerWorkerConfigByIdRequestBody => {
            const $join = (typia.createAssertEquals as any).join;
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config, true && _exceptionable) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["config", "creator"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "FULL" === input.workerType && (null === input.docker || undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker, true && _exceptionable)) && (null === input.lightly || undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io3(input.lightly, true && _exceptionable)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io4(input.selection, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return false;
            });
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return false;
            });
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any, _index1: number) => "object" === typeof elem && null !== elem && $io5(elem, true && _exceptionable))) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => "object" === typeof input.input && null !== input.input && $io6(input.input, true && _exceptionable) && ("object" === typeof input.strategy && null !== input.strategy && $io7(input.strategy, true && _exceptionable)) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["input", "strategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any, _index2: number) => "string" === typeof elem))()) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io8(input.target, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io8 = (input: any, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDockerWorkerConfigByIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["config", "creator"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (null === input.docker || undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && (null === input.lightly || undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && $ao3(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao4(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["workerType", "docker", "lightly", "selection"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                });
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao5(elem, _path + ".strategies[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["nSamples", "proportionSamples", "strategies"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao6(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao7(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["input", "strategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index2: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index2 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "task", "score", "key", "name", "datasetId", "tagName", "randomSeed", "categories"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao8(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "stopping_condition_minimum_distance", "threshold", "operation", "target"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => 0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateDockerWorkerConfigByIdTypiaAssertStringify = (input: UpdateDockerWorkerConfigByIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): UpdateDockerWorkerConfigByIdRequestBody => {
        const __is = (input: any): input is UpdateDockerWorkerConfigByIdRequestBody => {
            const $join = (typia.createAssertStringify as any).join;
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "object" === typeof input.config && null !== input.config && $io1(input.config) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator);
            const $io1 = (input: any): boolean => "FULL" === input.workerType && (null === input.docker || undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (null === input.lightly || undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io3(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io4(input.selection));
            const $io2 = (input: any): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return true;
            });
            const $io3 = (input: any): boolean => Object.keys(input).every((key: any) => {
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return true;
            });
            const $io4 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io5(elem)));
            const $io5 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io6(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io7(input.strategy));
            const $io6 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
            const $io7 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance)) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold)) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io8(input.target));
            const $io8 = (input: any): boolean => true;
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDockerWorkerConfigByIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.config && null !== input.config || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && $ao1(input.config, _path + ".config", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".config",
                    expected: "DockerWorkerConfig",
                    value: input.config
                })) && (undefined === input.creator || "UNKNOWN" === input.creator || "USER_WEBAPP" === input.creator || "USER_PIP" === input.creator || "USER_PIP_LIGHTLY_MAGIC" === input.creator || "USER_WORKER" === input.creator || $guard(_exceptionable, {
                    path: _path + ".creator",
                    expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                    value: input.creator
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("FULL" === input.workerType || $guard(_exceptionable, {
                    path: _path + ".workerType",
                    expected: "\"FULL\"",
                    value: input.workerType
                })) && (null === input.docker || undefined === input.docker || ("object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && $ao2(input.docker, _path + ".docker", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".docker",
                    expected: "(__type | null | undefined)",
                    value: input.docker
                })) && (null === input.lightly || undefined === input.lightly || ("object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && $ao3(input.lightly, _path + ".lightly", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".lightly",
                    expected: "(__type.o1 | null | undefined)",
                    value: input.lightly
                })) && (undefined === input.selection || ("object" === typeof input.selection && null !== input.selection || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                })) && $ao4(input.selection, _path + ".selection", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".selection",
                    expected: "(SelectionConfig | undefined)",
                    value: input.selection
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return true;
                });
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => false === _exceptionable || Object.keys(input).every((key: any) => {
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return true;
                });
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && !Number.isNaN(input.nSamples) && (Math.floor(input.nSamples) === input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@type int)",
                    value: input.nSamples
                })) && (-1 <= input.nSamples || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "number (@minimum -1)",
                    value: input.nSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".nSamples",
                    expected: "(number | undefined)",
                    value: input.nSamples
                })) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && (0 <= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@minimum 0)",
                    value: input.proportionSamples
                })) && (1 >= input.proportionSamples || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "number (@maximum 1)",
                    value: input.proportionSamples
                })) || $guard(_exceptionable, {
                    path: _path + ".proportionSamples",
                    expected: "(number | undefined)",
                    value: input.proportionSamples
                })) && ((Array.isArray(input.strategies) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                })) && input.strategies.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) && $ao5(elem, _path + ".strategies[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategies[" + _index1 + "]",
                    expected: "SelectionConfigEntry",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".strategies",
                    expected: "Array<SelectionConfigEntry>",
                    value: input.strategies
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (("object" === typeof input.input && null !== input.input || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && $ao6(input.input, _path + ".input", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".input",
                    expected: "SelectionConfigEntryInput",
                    value: input.input
                })) && (("object" === typeof input.strategy && null !== input.strategy || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                })) && $ao7(input.strategy, _path + ".strategy", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".strategy",
                    expected: "SelectionConfigEntryStrategy",
                    value: input.strategy
                }));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                    value: input.type
                })) && (undefined === input.task || "string" === typeof input.task && ($is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "string (@pattern_SelectionConfigEntryInput_task)",
                    value: input.task
                })) || $guard(_exceptionable, {
                    path: _path + ".task",
                    expected: "(string | undefined)",
                    value: input.task
                })) && (undefined === input.score || "string" === typeof input.score && (1 <= input.score.length || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@minLength 1)",
                    value: input.score
                })) && ($is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "string (@pattern_SelectionConfigEntryInput_score)",
                    value: input.score
                })) || $guard(_exceptionable, {
                    path: _path + ".score",
                    expected: "(string | undefined)",
                    value: input.score
                })) && (undefined === input.key || "string" === typeof input.key && (1 <= input.key.length || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "string (@minLength 1)",
                    value: input.key
                })) || $guard(_exceptionable, {
                    path: _path + ".key",
                    expected: "(string | undefined)",
                    value: input.key
                })) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                    value: input.name
                })) && (undefined === input.datasetId || "string" === typeof input.datasetId && ($is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_SelectionConfigEntryInput_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "(string | undefined)",
                    value: input.datasetId
                })) && (undefined === input.tagName || "string" === typeof input.tagName && (3 <= input.tagName.length || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@minLength 3)",
                    value: input.tagName
                })) && ($is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "string (@pattern_SelectionConfigEntryInput_tagName)",
                    value: input.tagName
                })) || $guard(_exceptionable, {
                    path: _path + ".tagName",
                    expected: "(string | undefined)",
                    value: input.tagName
                })) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && !Number.isNaN(input.randomSeed) && (Math.floor(input.randomSeed) === input.randomSeed || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "number (@type int)",
                    value: input.randomSeed
                })) || $guard(_exceptionable, {
                    path: _path + ".randomSeed",
                    expected: "(number | undefined)",
                    value: input.randomSeed
                })) && (undefined === input.categories || (input.categories instanceof Set || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                })) && (() => [...input.categories].every((elem: any, _index2: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".categories[" + _index2 + "]",
                    expected: "string",
                    value: elem
                })))() || $guard(_exceptionable, {
                    path: _path + ".categories",
                    expected: "(Set<string> | undefined)",
                    value: input.categories
                }));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                    value: input.type
                })) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance && !Number.isNaN(input.stopping_condition_minimum_distance) || $guard(_exceptionable, {
                    path: _path + ".stopping_condition_minimum_distance",
                    expected: "(number | undefined)",
                    value: input.stopping_condition_minimum_distance
                })) && (undefined === input.threshold || "number" === typeof input.threshold && !Number.isNaN(input.threshold) || $guard(_exceptionable, {
                    path: _path + ".threshold",
                    expected: "(number | undefined)",
                    value: input.threshold
                })) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation || $guard(_exceptionable, {
                    path: _path + ".operation",
                    expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                    value: input.operation
                })) && (undefined === input.target || ("object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                })) && $ao8(input.target, _path + ".target", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".target",
                    expected: "(object | undefined)",
                    value: input.target
                }));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => true;
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigCreateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateDockerWorkerConfigByIdRequestBody): string => {
        const $io1 = (input: any): boolean => "FULL" === input.workerType && (null === input.docker || undefined === input.docker || "object" === typeof input.docker && null !== input.docker && false === Array.isArray(input.docker) && $io2(input.docker)) && (null === input.lightly || undefined === input.lightly || "object" === typeof input.lightly && null !== input.lightly && false === Array.isArray(input.lightly) && $io3(input.lightly)) && (undefined === input.selection || "object" === typeof input.selection && null !== input.selection && $io4(input.selection));
        const $io2 = (input: any): boolean => Object.keys(input).every((key: any) => {
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/(.*)/).test(key))
                return true;
            return true;
        });
        const $io3 = (input: any): boolean => Object.keys(input).every((key: any) => {
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/(.*)/).test(key))
                return true;
            return true;
        });
        const $io4 = (input: any): boolean => (undefined === input.nSamples || "number" === typeof input.nSamples && Math.floor(input.nSamples) === input.nSamples && (-2147483648 <= input.nSamples && input.nSamples <= 2147483647) && -1 <= input.nSamples) && (undefined === input.proportionSamples || "number" === typeof input.proportionSamples && 0 <= input.proportionSamples && 1 >= input.proportionSamples) && (Array.isArray(input.strategies) && input.strategies.every((elem: any) => "object" === typeof elem && null !== elem && $io5(elem)));
        const $io5 = (input: any): boolean => "object" === typeof input.input && null !== input.input && $io6(input.input) && ("object" === typeof input.strategy && null !== input.strategy && $io7(input.strategy));
        const $io6 = (input: any): boolean => ("EMBEDDINGS" === input.type || "SCORES" === input.type || "METADATA" === input.type || "PREDICTIONS" === input.type || "RANDOM" === input.type) && (undefined === input.task || "string" === typeof input.task && $is_custom("pattern_SelectionConfigEntryInput_task", "string", "", input.task)) && (undefined === input.score || "string" === typeof input.score && 1 <= input.score.length && $is_custom("pattern_SelectionConfigEntryInput_score", "string", "", input.score)) && (undefined === input.key || "string" === typeof input.key && 1 <= input.key.length) && (undefined === input.name || "CLASS_DISTRIBUTION" === input.name || "CATEGORY_COUNT" === input.name) && (undefined === input.datasetId || "string" === typeof input.datasetId && $is_custom("pattern_SelectionConfigEntryInput_datasetId", "string", "", input.datasetId)) && (undefined === input.tagName || "string" === typeof input.tagName && 3 <= input.tagName.length && $is_custom("pattern_SelectionConfigEntryInput_tagName", "string", "", input.tagName)) && (undefined === input.randomSeed || "number" === typeof input.randomSeed && Math.floor(input.randomSeed) === input.randomSeed && (-2147483648 <= input.randomSeed && input.randomSeed <= 2147483647)) && (undefined === input.categories || input.categories instanceof Set && (() => [...input.categories].every((elem: any) => "string" === typeof elem))());
        const $io7 = (input: any): boolean => ("DIVERSITY" === input.type || "WEIGHTS" === input.type || "THRESHOLD" === input.type || "BALANCE" === input.type || "SIMILARITY" === input.type) && (undefined === input.stopping_condition_minimum_distance || "number" === typeof input.stopping_condition_minimum_distance) && (undefined === input.threshold || "number" === typeof input.threshold) && (undefined === input.operation || "SMALLER" === input.operation || "SMALLER_EQUAL" === input.operation || "BIGGER" === input.operation || "BIGGER_EQUAL" === input.operation) && (undefined === input.target || "object" === typeof input.target && null !== input.target && false === Array.isArray(input.target) && $io8(input.target));
        const $io8 = (input: any): boolean => true;
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.creator ? "" : `"creator":${undefined !== input.creator ? (() => {
            if ("string" === typeof input.creator)
                return $string(input.creator);
            if ("string" === typeof input.creator)
                return "\"" + input.creator + "\"";
            $throws({
                expected: "(\"UNKNOWN\" | \"USER_PIP\" | \"USER_PIP_LIGHTLY_MAGIC\" | \"USER_WEBAPP\" | \"USER_WORKER\" | undefined)",
                value: input.creator
            });
        })() : undefined},`}"config":${$so1(input.config)}}`;
        const $so1 = (input: any): any => `{${undefined === input.docker ? "" : `"docker":${undefined !== input.docker ? null !== input.docker ? $so2(input.docker) : "null" : undefined},`}${undefined === input.lightly ? "" : `"lightly":${undefined !== input.lightly ? null !== input.lightly ? $so3(input.lightly) : "null" : undefined},`}${undefined === input.selection ? "" : `"selection":${undefined !== input.selection ? $so4(input.selection) : undefined},`}"workerType":${(() => {
            if ("string" === typeof input.workerType)
                return $string(input.workerType);
            if ("string" === typeof input.workerType)
                return "\"" + input.workerType + "\"";
            $throws({
                expected: "\"FULL\"",
                value: input.workerType
            });
        })()}}`;
        const $so2 = (input: any): any => `{${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; return `${JSON.stringify(key)}:${undefined !== value ? JSON.stringify(value) : undefined}`; }).filter((str: any) => "" !== str).join(",")}}`;
        const $so3 = (input: any): any => `{${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; return `${JSON.stringify(key)}:${undefined !== value ? JSON.stringify(value) : undefined}`; }).filter((str: any) => "" !== str).join(",")}}`;
        const $so4 = (input: any): any => `{${undefined === input.nSamples ? "" : `"nSamples":${undefined !== input.nSamples ? input.nSamples : undefined},`}${undefined === input.proportionSamples ? "" : `"proportionSamples":${undefined !== input.proportionSamples ? input.proportionSamples : undefined},`}"strategies":${`[${input.strategies.map((elem: any) => $so5(elem)).join(",")}]`}}`;
        const $so5 = (input: any): any => `{"input":${$so6(input.input)},"strategy":${$so7(input.strategy)}}`;
        const $so6 = (input: any): any => `{${undefined === input.task ? "" : `"task":${undefined !== input.task ? $string(input.task) : undefined},`}${undefined === input.score ? "" : `"score":${undefined !== input.score ? $string(input.score) : undefined},`}${undefined === input.key ? "" : `"key":${undefined !== input.key ? $string(input.key) : undefined},`}${undefined === input.name ? "" : `"name":${undefined !== input.name ? (() => {
            if ("string" === typeof input.name)
                return $string(input.name);
            if ("string" === typeof input.name)
                return "\"" + input.name + "\"";
            $throws({
                expected: "(\"CATEGORY_COUNT\" | \"CLASS_DISTRIBUTION\" | undefined)",
                value: input.name
            });
        })() : undefined},`}${undefined === input.datasetId ? "" : `"datasetId":${undefined !== input.datasetId ? $string(input.datasetId) : undefined},`}${undefined === input.tagName ? "" : `"tagName":${undefined !== input.tagName ? $string(input.tagName) : undefined},`}${undefined === input.randomSeed ? "" : `"randomSeed":${undefined !== input.randomSeed ? input.randomSeed : undefined},`}${undefined === input.categories ? "" : `"categories":${undefined !== input.categories ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"EMBEDDINGS\" | \"METADATA\" | \"PREDICTIONS\" | \"RANDOM\" | \"SCORES\")",
                value: input.type
            });
        })()}}`;
        const $so7 = (input: any): any => `{${undefined === input.stopping_condition_minimum_distance ? "" : `"stopping_condition_minimum_distance":${undefined !== input.stopping_condition_minimum_distance ? input.stopping_condition_minimum_distance : undefined},`}${undefined === input.threshold ? "" : `"threshold":${undefined !== input.threshold ? input.threshold : undefined},`}${undefined === input.operation ? "" : `"operation":${undefined !== input.operation ? (() => {
            if ("string" === typeof input.operation)
                return $string(input.operation);
            if ("string" === typeof input.operation)
                return "\"" + input.operation + "\"";
            $throws({
                expected: "(\"BIGGER\" | \"BIGGER_EQUAL\" | \"SMALLER\" | \"SMALLER_EQUAL\" | undefined)",
                value: input.operation
            });
        })() : undefined},`}${undefined === input.target ? "" : `"target":${undefined !== input.target ? "{}" : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "(\"BALANCE\" | \"DIVERSITY\" | \"SIMILARITY\" | \"THRESHOLD\" | \"WEIGHTS\")",
                value: input.type
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type UpdateDockerWorkerRegistryEntryByIdRequestBody = UpdateDockerWorkerRegistryEntryRequest;
export const UpdateDockerWorkerRegistryEntryByIdRequestBodySanitizer = UpdateDockerWorkerRegistryEntryRequestFromJSON;
export const UpdateDockerWorkerRegistryEntryByIdRequestBodyValidator = UpdateDockerWorkerRegistryEntryRequestValidator;
export const UpdateDockerWorkerRegistryEntryByIdTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateDockerWorkerRegistryEntryByIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateDockerWorkerRegistryEntryByIdRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => ("OFFLINE" === input.state || "CRASHED" === input.state || "IDLE" === input.state || "BUSY" === input.state) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["state", "dockerVersion"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDockerWorkerRegistryEntryByIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OFFLINE" === input.state || "CRASHED" === input.state || "IDLE" === input.state || "BUSY" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"BUSY\" | \"CRASHED\" | \"IDLE\" | \"OFFLINE\")",
                    value: input.state
                })) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "(string | undefined)",
                    value: input.dockerVersion
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["state", "dockerVersion"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "UpdateDockerWorkerRegistryEntryRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "UpdateDockerWorkerRegistryEntryRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateDockerWorkerRegistryEntryByIdTypiaAssertStringify = (input: UpdateDockerWorkerRegistryEntryByIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): UpdateDockerWorkerRegistryEntryByIdRequestBody => {
        const __is = (input: any): input is UpdateDockerWorkerRegistryEntryByIdRequestBody => {
            const $io0 = (input: any): boolean => ("OFFLINE" === input.state || "CRASHED" === input.state || "IDLE" === input.state || "BUSY" === input.state) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDockerWorkerRegistryEntryByIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OFFLINE" === input.state || "CRASHED" === input.state || "IDLE" === input.state || "BUSY" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"BUSY\" | \"CRASHED\" | \"IDLE\" | \"OFFLINE\")",
                    value: input.state
                })) && (undefined === input.dockerVersion || "string" === typeof input.dockerVersion || $guard(_exceptionable, {
                    path: _path + ".dockerVersion",
                    expected: "(string | undefined)",
                    value: input.dockerVersion
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "UpdateDockerWorkerRegistryEntryRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "UpdateDockerWorkerRegistryEntryRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateDockerWorkerRegistryEntryByIdRequestBody): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $so0 = (input: any): any => `{${undefined === input.dockerVersion ? "" : `"dockerVersion":${undefined !== input.dockerVersion ? $string(input.dockerVersion) : undefined},`}"state":${(() => {
            if ("string" === typeof input.state)
                return $string(input.state);
            if ("string" === typeof input.state)
                return "\"" + input.state + "\"";
            $throws({
                expected: "(\"BUSY\" | \"CRASHED\" | \"IDLE\" | \"OFFLINE\")",
                value: input.state
            });
        })()}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export type UpdateScheduledDockerRunStateByIdRequestBody = DockerRunScheduledUpdateRequest;
export const UpdateScheduledDockerRunStateByIdRequestBodySanitizer = DockerRunScheduledUpdateRequestFromJSON;
export const UpdateScheduledDockerRunStateByIdRequestBodyValidator = DockerRunScheduledUpdateRequestValidator;
export const UpdateScheduledDockerRunStateByIdTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateScheduledDockerRunStateByIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateScheduledDockerRunStateByIdRequestBody => {
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority) && (undefined === input.runsOn || "object" === typeof input.runsOn && null !== input.runsOn && $io1(input.runsOn, true && _exceptionable)) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["state", "priority", "runsOn"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateScheduledDockerRunStateByIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                    value: input.state
                })) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority || $guard(_exceptionable, {
                    path: _path + ".priority",
                    expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\" | undefined)",
                    value: input.priority
                })) && (undefined === input.runsOn || ("object" === typeof input.runsOn && null !== input.runsOn || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && $ao1(input.runsOn, _path + ".runsOn", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["state", "priority", "runsOn"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateScheduledDockerRunStateByIdTypiaAssertStringify = (input: UpdateScheduledDockerRunStateByIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): UpdateScheduledDockerRunStateByIdRequestBody => {
        const __is = (input: any): input is UpdateScheduledDockerRunStateByIdRequestBody => {
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority) && (undefined === input.runsOn || "object" === typeof input.runsOn && null !== input.runsOn && $io1(input.runsOn));
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "string" === typeof value;
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateScheduledDockerRunStateByIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OPEN" === input.state || "LOCKED" === input.state || "DONE" === input.state || "CANCELED" === input.state || $guard(_exceptionable, {
                    path: _path + ".state",
                    expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                    value: input.state
                })) && (undefined === input.priority || "LOW" === input.priority || "MID" === input.priority || "HIGH" === input.priority || "CRITICAL" === input.priority || $guard(_exceptionable, {
                    path: _path + ".priority",
                    expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\" | undefined)",
                    value: input.priority
                })) && (undefined === input.runsOn || ("object" === typeof input.runsOn && null !== input.runsOn || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                })) && $ao1(input.runsOn, _path + ".runsOn", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".runsOn",
                    expected: "(DockerWorkerLabels | undefined)",
                    value: input.runsOn
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "string" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "string",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerRunScheduledUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateScheduledDockerRunStateByIdRequestBody): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "string" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${undefined === input.priority ? "" : `"priority":${undefined !== input.priority ? (() => {
            if ("string" === typeof input.priority)
                return $string(input.priority);
            if ("string" === typeof input.priority)
                return "\"" + input.priority + "\"";
            $throws({
                expected: "(\"CRITICAL\" | \"HIGH\" | \"LOW\" | \"MID\" | undefined)",
                value: input.priority
            });
        })() : undefined},`}${undefined === input.runsOn ? "" : `"runsOn":${undefined !== input.runsOn ? $so1(input.runsOn) : undefined},`}"state":${(() => {
            if ("string" === typeof input.state)
                return $string(input.state);
            if ("string" === typeof input.state)
                return "\"" + input.state + "\"";
            $throws({
                expected: "(\"CANCELED\" | \"DONE\" | \"LOCKED\" | \"OPEN\")",
                value: input.state
            });
        })()}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$string(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
/*
HANDLERS:



/v1/datasets/{datasetId}/docker/worker/schedule/{scheduledId}

export const cancelScheduledDockerRunStateByIdFN: RequestHandler<
    CancelScheduledDockerRunStateByIdRequestParams,
     | ApiErrorResponse,
    CancelScheduledDockerRunStateByIdRequestBody,
    CancelScheduledDockerRunStateByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CancelScheduledDockerRunStateByIdRequestBodySanitizer, CancelScheduledDockerRunStateByIdRequestBodyValidator);
    const {
        datasetId,
        scheduledId,
    } =  await validateAndSanitize(req.params, CancelScheduledDockerRunStateByIdRequestParamsSanitizer, CancelScheduledDockerRunStateByIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, CancelScheduledDockerRunStateByIdRequestQuerySanitizer, CancelScheduledDockerRunStateByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/docker/runs/{runId}/artifacts/{artifactId}/confirmUpload

export const confirmDockerRunArtifactCreationFN: RequestHandler<
    ConfirmDockerRunArtifactCreationRequestParams,
     | ApiErrorResponse,
    ConfirmDockerRunArtifactCreationRequestBody,
    ConfirmDockerRunArtifactCreationRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, ConfirmDockerRunArtifactCreationRequestBodySanitizer, ConfirmDockerRunArtifactCreationRequestBodyValidator);
    const {
        runId,
        artifactId,
    } =  await validateAndSanitize(req.params, ConfirmDockerRunArtifactCreationRequestParamsSanitizer, ConfirmDockerRunArtifactCreationRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, ConfirmDockerRunArtifactCreationRequestQuerySanitizer, ConfirmDockerRunArtifactCreationRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/docker/runs

export const createDockerRunFN: RequestHandler<
    CreateDockerRunRequestParams,
    CreateEntityResponse | ApiErrorResponse,
    CreateDockerRunRequestBody,
    CreateDockerRunRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerRunRequestBodySanitizer, CreateDockerRunRequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, CreateDockerRunRequestParamsSanitizer, CreateDockerRunRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, CreateDockerRunRequestQuerySanitizer, CreateDockerRunRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/runs/{runId}/artifacts

export const createDockerRunArtifactFN: RequestHandler<
    CreateDockerRunArtifactRequestParams,
    DockerRunArtifactCreatedData | ApiErrorResponse,
    CreateDockerRunArtifactRequestBody,
    CreateDockerRunArtifactRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerRunArtifactRequestBodySanitizer, CreateDockerRunArtifactRequestBodyValidator);
    const {
        
        runId,
    } =  await validateAndSanitize(req.params, CreateDockerRunArtifactRequestParamsSanitizer, CreateDockerRunArtifactRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, CreateDockerRunArtifactRequestQuerySanitizer, CreateDockerRunArtifactRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerRunArtifactCreatedDataStringify,
        validateAndRespond({ id, ...rest }, DockerRunArtifactCreatedDataFromJSON, DockerRunArtifactCreatedDataValidator),
    );
}



/v1/docker/runs/{runId}/logs

export const createDockerRunLogByIdFN: RequestHandler<
    CreateDockerRunLogByIdRequestParams,
     | ApiErrorResponse,
    CreateDockerRunLogByIdRequestBody,
    CreateDockerRunLogByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerRunLogByIdRequestBodySanitizer, CreateDockerRunLogByIdRequestBodyValidator);
    const {
        
        runId,
    } =  await validateAndSanitize(req.params, CreateDockerRunLogByIdRequestParamsSanitizer, CreateDockerRunLogByIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, CreateDockerRunLogByIdRequestQuerySanitizer, CreateDockerRunLogByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/datasets/{datasetId}/docker/worker/schedule

export const createDockerRunScheduledByDatasetIdFN: RequestHandler<
    CreateDockerRunScheduledByDatasetIdRequestParams,
    CreateEntityResponse | ApiErrorResponse,
    CreateDockerRunScheduledByDatasetIdRequestBody,
    CreateDockerRunScheduledByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerRunScheduledByDatasetIdRequestBodySanitizer, CreateDockerRunScheduledByDatasetIdRequestBodyValidator);
    const {
        
        datasetId,
        
    } =  await validateAndSanitize(req.params, CreateDockerRunScheduledByDatasetIdRequestParamsSanitizer, CreateDockerRunScheduledByDatasetIdRequestParamsValidator);
    const {
        
        
        disableConfigValidation,
    } = await validateAndSanitize(req.query, CreateDockerRunScheduledByDatasetIdRequestQuerySanitizer, CreateDockerRunScheduledByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/worker/config

export const createDockerWorkerConfigFN: RequestHandler<
    CreateDockerWorkerConfigRequestParams,
    CreateEntityResponse | ApiErrorResponse,
    CreateDockerWorkerConfigRequestBody,
    CreateDockerWorkerConfigRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerWorkerConfigRequestBodySanitizer, CreateDockerWorkerConfigRequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, CreateDockerWorkerConfigRequestParamsSanitizer, CreateDockerWorkerConfigRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, CreateDockerWorkerConfigRequestQuerySanitizer, CreateDockerWorkerConfigRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/worker/config/v2

export const createDockerWorkerConfigV2FN: RequestHandler<
    CreateDockerWorkerConfigV2RequestParams,
    CreateEntityResponse | ApiErrorResponse,
    CreateDockerWorkerConfigV2RequestBody,
    CreateDockerWorkerConfigV2RequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerWorkerConfigV2RequestBodySanitizer, CreateDockerWorkerConfigV2RequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, CreateDockerWorkerConfigV2RequestParamsSanitizer, CreateDockerWorkerConfigV2RequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, CreateDockerWorkerConfigV2RequestQuerySanitizer, CreateDockerWorkerConfigV2RequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/worker/config/v3

export const createDockerWorkerConfigV3FN: RequestHandler<
    CreateDockerWorkerConfigV3RequestParams,
    CreateEntityResponse | ApiErrorResponse,
    CreateDockerWorkerConfigV3RequestBody,
    CreateDockerWorkerConfigV3RequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerWorkerConfigV3RequestBodySanitizer, CreateDockerWorkerConfigV3RequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, CreateDockerWorkerConfigV3RequestParamsSanitizer, CreateDockerWorkerConfigV3RequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, CreateDockerWorkerConfigV3RequestQuerySanitizer, CreateDockerWorkerConfigV3RequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/worker/config/vX

export const createDockerWorkerConfigVXFN: RequestHandler<
    CreateDockerWorkerConfigVXRequestParams,
    CreateEntityResponse | ApiErrorResponse,
    CreateDockerWorkerConfigVXRequestBody,
    CreateDockerWorkerConfigVXRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, CreateDockerWorkerConfigVXRequestBodySanitizer, CreateDockerWorkerConfigVXRequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, CreateDockerWorkerConfigVXRequestParamsSanitizer, CreateDockerWorkerConfigVXRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, CreateDockerWorkerConfigVXRequestQuerySanitizer, CreateDockerWorkerConfigVXRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/worker/{workerId}

export const deleteDockerWorkerRegistryEntryByIdFN: RequestHandler<
    DeleteDockerWorkerRegistryEntryByIdRequestParams,
     | ApiErrorResponse,
    DeleteDockerWorkerRegistryEntryByIdRequestBody,
    DeleteDockerWorkerRegistryEntryByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, DeleteDockerWorkerRegistryEntryByIdRequestBodySanitizer, DeleteDockerWorkerRegistryEntryByIdRequestBodyValidator);
    const {
        workerId,
    } =  await validateAndSanitize(req.params, DeleteDockerWorkerRegistryEntryByIdRequestParamsSanitizer, DeleteDockerWorkerRegistryEntryByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, DeleteDockerWorkerRegistryEntryByIdRequestQuerySanitizer, DeleteDockerWorkerRegistryEntryByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/docker/worker/default

export const getDefaultOrRegisterWorkerFN: RequestHandler<
    GetDefaultOrRegisterWorkerRequestParams,
    DockerWorkerRegistryEntryData | ApiErrorResponse,
    GetDefaultOrRegisterWorkerRequestBody,
    GetDefaultOrRegisterWorkerRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDefaultOrRegisterWorkerRequestBodySanitizer, GetDefaultOrRegisterWorkerRequestBodyValidator);
    const {
    } =  await validateAndSanitize(req.params, GetDefaultOrRegisterWorkerRequestParamsSanitizer, GetDefaultOrRegisterWorkerRequestParamsValidator);
    const {
    } = await validateAndSanitize(req.query, GetDefaultOrRegisterWorkerRequestQuerySanitizer, GetDefaultOrRegisterWorkerRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerWorkerRegistryEntryDataStringify,
        validateAndRespond({ id, ...rest }, DockerWorkerRegistryEntryDataFromJSON, DockerWorkerRegistryEntryDataValidator),
    );
}



/v1/docker/licenseInformation

export const getDockerLicenseInformationFN: RequestHandler<
    GetDockerLicenseInformationRequestParams,
    DockerLicenseInformation | ApiErrorResponse,
    GetDockerLicenseInformationRequestBody,
    GetDockerLicenseInformationRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerLicenseInformationRequestBodySanitizer, GetDockerLicenseInformationRequestBodyValidator);
    const {
    } =  await validateAndSanitize(req.params, GetDockerLicenseInformationRequestParamsSanitizer, GetDockerLicenseInformationRequestParamsValidator);
    const {
    } = await validateAndSanitize(req.query, GetDockerLicenseInformationRequestQuerySanitizer, GetDockerLicenseInformationRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerLicenseInformationStringify,
        validateAndRespond({ id, ...rest }, DockerLicenseInformationFromJSON, DockerLicenseInformationValidator),
    );
}



/v1/docker/runs/{runId}/artifacts/{artifactId}/readurl

export const getDockerRunArtifactReadUrlByIdFN: RequestHandler<
    GetDockerRunArtifactReadUrlByIdRequestParams,
    string | ApiErrorResponse,
    GetDockerRunArtifactReadUrlByIdRequestBody,
    GetDockerRunArtifactReadUrlByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunArtifactReadUrlByIdRequestBodySanitizer, GetDockerRunArtifactReadUrlByIdRequestBodyValidator);
    const {
        runId,
        artifactId,
    } =  await validateAndSanitize(req.params, GetDockerRunArtifactReadUrlByIdRequestParamsSanitizer, GetDockerRunArtifactReadUrlByIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, GetDockerRunArtifactReadUrlByIdRequestQuerySanitizer, GetDockerRunArtifactReadUrlByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/docker/runs/{runId}

export const getDockerRunByIdFN: RequestHandler<
    GetDockerRunByIdRequestParams,
    DockerRunData | ApiErrorResponse,
    GetDockerRunByIdRequestBody,
    GetDockerRunByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunByIdRequestBodySanitizer, GetDockerRunByIdRequestBodyValidator);
    const {
        runId,
    } =  await validateAndSanitize(req.params, GetDockerRunByIdRequestParamsSanitizer, GetDockerRunByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerRunByIdRequestQuerySanitizer, GetDockerRunByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerRunDataStringify,
        validateAndRespond({ id, ...rest }, DockerRunDataFromJSON, DockerRunDataValidator),
    );
}



/v1/docker/runs/schedule/{scheduledId}

export const getDockerRunByScheduledIdFN: RequestHandler<
    GetDockerRunByScheduledIdRequestParams,
    DockerRunData | ApiErrorResponse,
    GetDockerRunByScheduledIdRequestBody,
    GetDockerRunByScheduledIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunByScheduledIdRequestBodySanitizer, GetDockerRunByScheduledIdRequestBodyValidator);
    const {
        scheduledId,
    } =  await validateAndSanitize(req.params, GetDockerRunByScheduledIdRequestParamsSanitizer, GetDockerRunByScheduledIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerRunByScheduledIdRequestQuerySanitizer, GetDockerRunByScheduledIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerRunDataStringify,
        validateAndRespond({ id, ...rest }, DockerRunDataFromJSON, DockerRunDataValidator),
    );
}



/v1/docker/runs/{runId}/logs

export const getDockerRunLogsByIdFN: RequestHandler<
    GetDockerRunLogsByIdRequestParams,
    DockerRunLogData | ApiErrorResponse,
    GetDockerRunLogsByIdRequestBody,
    GetDockerRunLogsByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunLogsByIdRequestBodySanitizer, GetDockerRunLogsByIdRequestBodyValidator);
    const {
        runId,
        
    } =  await validateAndSanitize(req.params, GetDockerRunLogsByIdRequestParamsSanitizer, GetDockerRunLogsByIdRequestParamsValidator);
    const {
        
        cursor,
    } = await validateAndSanitize(req.query, GetDockerRunLogsByIdRequestQuerySanitizer, GetDockerRunLogsByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerRunLogDataStringify,
        validateAndRespond({ id, ...rest }, DockerRunLogDataFromJSON, DockerRunLogDataValidator),
    );
}



/v1/docker/runs/{runId}/readReportUrl

export const getDockerRunReportReadUrlByIdFN: RequestHandler<
    GetDockerRunReportReadUrlByIdRequestParams,
    string | ApiErrorResponse,
    GetDockerRunReportReadUrlByIdRequestBody,
    GetDockerRunReportReadUrlByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunReportReadUrlByIdRequestBodySanitizer, GetDockerRunReportReadUrlByIdRequestBodyValidator);
    const {
        runId,
    } =  await validateAndSanitize(req.params, GetDockerRunReportReadUrlByIdRequestParamsSanitizer, GetDockerRunReportReadUrlByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerRunReportReadUrlByIdRequestQuerySanitizer, GetDockerRunReportReadUrlByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/docker/runs/{runId}/writeReportUrl

export const getDockerRunReportWriteUrlByIdFN: RequestHandler<
    GetDockerRunReportWriteUrlByIdRequestParams,
    string | ApiErrorResponse,
    GetDockerRunReportWriteUrlByIdRequestBody,
    GetDockerRunReportWriteUrlByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunReportWriteUrlByIdRequestBodySanitizer, GetDockerRunReportWriteUrlByIdRequestBodyValidator);
    const {
        runId,
    } =  await validateAndSanitize(req.params, GetDockerRunReportWriteUrlByIdRequestParamsSanitizer, GetDockerRunReportWriteUrlByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerRunReportWriteUrlByIdRequestQuerySanitizer, GetDockerRunReportWriteUrlByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/docker/runs/{runId}/tags
const TagDataArrayStringify = fastJSONArrayify(TagDataStringifyShape);
export const getDockerRunTagsFN: RequestHandler<
    GetDockerRunTagsRequestParams,
    TagData[] | ApiErrorResponse,
    GetDockerRunTagsRequestBody,
    GetDockerRunTagsRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunTagsRequestBodySanitizer, GetDockerRunTagsRequestBodyValidator);
    const {
        runId,
    } =  await validateAndSanitize(req.params, GetDockerRunTagsRequestParamsSanitizer, GetDockerRunTagsRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerRunTagsRequestQuerySanitizer, GetDockerRunTagsRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        TagDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, TagDataFromJSON, TagDataValidator);
        }),
    );
}



/v1/docker/runs
const DockerRunDataArrayStringify = fastJSONArrayify(DockerRunDataStringifyShape);
export const getDockerRunsFN: RequestHandler<
    GetDockerRunsRequestParams,
    DockerRunData[] | ApiErrorResponse,
    GetDockerRunsRequestBody,
    GetDockerRunsRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunsRequestBodySanitizer, GetDockerRunsRequestBodyValidator);
    const {
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetDockerRunsRequestParamsSanitizer, GetDockerRunsRequestParamsValidator);
    const {
        pageSize,
        pageOffset,
        getAssetsOfTeam,
        getAssetsOfTeamInclusiveSelf,
        showArchived,
    } = await validateAndSanitize(req.query, GetDockerRunsRequestQuerySanitizer, GetDockerRunsRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerRunDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerRunDataFromJSON, DockerRunDataValidator);
        }),
    );
}



/v1/docker/runs/count

export const getDockerRunsCountFN: RequestHandler<
    GetDockerRunsCountRequestParams,
    string | ApiErrorResponse,
    GetDockerRunsCountRequestBody,
    GetDockerRunsCountRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunsCountRequestBodySanitizer, GetDockerRunsCountRequestBodyValidator);
    const {
        
        
        
    } =  await validateAndSanitize(req.params, GetDockerRunsCountRequestParamsSanitizer, GetDockerRunsCountRequestParamsValidator);
    const {
        getAssetsOfTeam,
        getAssetsOfTeamInclusiveSelf,
        showArchived,
    } = await validateAndSanitize(req.query, GetDockerRunsCountRequestQuerySanitizer, GetDockerRunsCountRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/docker/runs/query/datasetId/{datasetId}
const DockerRunDataArrayStringify = fastJSONArrayify(DockerRunDataStringifyShape);
export const getDockerRunsQueryByDatasetIdFN: RequestHandler<
    GetDockerRunsQueryByDatasetIdRequestParams,
    DockerRunData[] | ApiErrorResponse,
    GetDockerRunsQueryByDatasetIdRequestBody,
    GetDockerRunsQueryByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunsQueryByDatasetIdRequestBodySanitizer, GetDockerRunsQueryByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
    } =  await validateAndSanitize(req.params, GetDockerRunsQueryByDatasetIdRequestParamsSanitizer, GetDockerRunsQueryByDatasetIdRequestParamsValidator);
    const {
        
        pageSize,
        pageOffset,
        getAssetsOfTeam,
        getAssetsOfTeamInclusiveSelf,
    } = await validateAndSanitize(req.query, GetDockerRunsQueryByDatasetIdRequestQuerySanitizer, GetDockerRunsQueryByDatasetIdRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerRunDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerRunDataFromJSON, DockerRunDataValidator);
        }),
    );
}



/v1/datasets/{datasetId}/docker/worker/schedule
const DockerRunScheduledDataArrayStringify = fastJSONArrayify(DockerRunScheduledDataStringifyShape);
export const getDockerRunsScheduledByDatasetIdFN: RequestHandler<
    GetDockerRunsScheduledByDatasetIdRequestParams,
    DockerRunScheduledData[] | ApiErrorResponse,
    GetDockerRunsScheduledByDatasetIdRequestBody,
    GetDockerRunsScheduledByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunsScheduledByDatasetIdRequestBodySanitizer, GetDockerRunsScheduledByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
    } =  await validateAndSanitize(req.params, GetDockerRunsScheduledByDatasetIdRequestParamsSanitizer, GetDockerRunsScheduledByDatasetIdRequestParamsValidator);
    const {
        
        state,
        states,
    } = await validateAndSanitize(req.query, GetDockerRunsScheduledByDatasetIdRequestQuerySanitizer, GetDockerRunsScheduledByDatasetIdRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerRunScheduledDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerRunScheduledDataFromJSON, DockerRunScheduledDataValidator);
        }),
    );
}



/v1/docker/worker/schedule
const DockerRunScheduledDataArrayStringify = fastJSONArrayify(DockerRunScheduledDataStringifyShape);
export const getDockerRunsScheduledByStateAndLabelsFN: RequestHandler<
    GetDockerRunsScheduledByStateAndLabelsRequestParams,
    DockerRunScheduledData[] | ApiErrorResponse,
    GetDockerRunsScheduledByStateAndLabelsRequestBody,
    GetDockerRunsScheduledByStateAndLabelsRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunsScheduledByStateAndLabelsRequestBodySanitizer, GetDockerRunsScheduledByStateAndLabelsRequestBodyValidator);
    const {
        
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetDockerRunsScheduledByStateAndLabelsRequestParamsSanitizer, GetDockerRunsScheduledByStateAndLabelsRequestParamsValidator);
    const {
        state,
        labels,
        version,
        includeUnlockableRuns,
        getAssetsOfTeam,
        getAssetsOfTeamInclusiveSelf,
    } = await validateAndSanitize(req.query, GetDockerRunsScheduledByStateAndLabelsRequestQuerySanitizer, GetDockerRunsScheduledByStateAndLabelsRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerRunScheduledDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerRunScheduledDataFromJSON, DockerRunScheduledDataValidator);
        }),
    );
}



/v1/docker/worker/{workerId}/schedule
const DockerRunScheduledDataArrayStringify = fastJSONArrayify(DockerRunScheduledDataStringifyShape);
export const getDockerRunsScheduledByWorkerIdFN: RequestHandler<
    GetDockerRunsScheduledByWorkerIdRequestParams,
    DockerRunScheduledData[] | ApiErrorResponse,
    GetDockerRunsScheduledByWorkerIdRequestBody,
    GetDockerRunsScheduledByWorkerIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerRunsScheduledByWorkerIdRequestBodySanitizer, GetDockerRunsScheduledByWorkerIdRequestBodyValidator);
    const {
        workerId,
        
        
        
    } =  await validateAndSanitize(req.params, GetDockerRunsScheduledByWorkerIdRequestParamsSanitizer, GetDockerRunsScheduledByWorkerIdRequestParamsValidator);
    const {
        
        state,
        getAssetsOfTeam,
        getAssetsOfTeamInclusiveSelf,
    } = await validateAndSanitize(req.query, GetDockerRunsScheduledByWorkerIdRequestQuerySanitizer, GetDockerRunsScheduledByWorkerIdRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerRunScheduledDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerRunScheduledDataFromJSON, DockerRunScheduledDataValidator);
        }),
    );
}



/v1/docker/worker/config/{configId}

export const getDockerWorkerConfigByIdFN: RequestHandler<
    GetDockerWorkerConfigByIdRequestParams,
    DockerWorkerConfigV0Data | ApiErrorResponse,
    GetDockerWorkerConfigByIdRequestBody,
    GetDockerWorkerConfigByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerConfigByIdRequestBodySanitizer, GetDockerWorkerConfigByIdRequestBodyValidator);
    const {
        configId,
    } =  await validateAndSanitize(req.params, GetDockerWorkerConfigByIdRequestParamsSanitizer, GetDockerWorkerConfigByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerWorkerConfigByIdRequestQuerySanitizer, GetDockerWorkerConfigByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerWorkerConfigV0DataStringify,
        validateAndRespond({ id, ...rest }, DockerWorkerConfigV0DataFromJSON, DockerWorkerConfigV0DataValidator),
    );
}



/v1/docker/worker/config/v2/{configId}

export const getDockerWorkerConfigV2ByIdFN: RequestHandler<
    GetDockerWorkerConfigV2ByIdRequestParams,
    DockerWorkerConfigV2Data | ApiErrorResponse,
    GetDockerWorkerConfigV2ByIdRequestBody,
    GetDockerWorkerConfigV2ByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerConfigV2ByIdRequestBodySanitizer, GetDockerWorkerConfigV2ByIdRequestBodyValidator);
    const {
        configId,
    } =  await validateAndSanitize(req.params, GetDockerWorkerConfigV2ByIdRequestParamsSanitizer, GetDockerWorkerConfigV2ByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerWorkerConfigV2ByIdRequestQuerySanitizer, GetDockerWorkerConfigV2ByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerWorkerConfigV2DataStringify,
        validateAndRespond({ id, ...rest }, DockerWorkerConfigV2DataFromJSON, DockerWorkerConfigV2DataValidator),
    );
}



/v1/docker/worker/config/v3/{configId}

export const getDockerWorkerConfigV3ByIdFN: RequestHandler<
    GetDockerWorkerConfigV3ByIdRequestParams,
    DockerWorkerConfigV3Data | ApiErrorResponse,
    GetDockerWorkerConfigV3ByIdRequestBody,
    GetDockerWorkerConfigV3ByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerConfigV3ByIdRequestBodySanitizer, GetDockerWorkerConfigV3ByIdRequestBodyValidator);
    const {
        configId,
    } =  await validateAndSanitize(req.params, GetDockerWorkerConfigV3ByIdRequestParamsSanitizer, GetDockerWorkerConfigV3ByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerWorkerConfigV3ByIdRequestQuerySanitizer, GetDockerWorkerConfigV3ByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerWorkerConfigV3DataStringify,
        validateAndRespond({ id, ...rest }, DockerWorkerConfigV3DataFromJSON, DockerWorkerConfigV3DataValidator),
    );
}



/v1/docker/worker/config/vX/{configId}

export const getDockerWorkerConfigVXByIdFN: RequestHandler<
    GetDockerWorkerConfigVXByIdRequestParams,
    DockerWorkerConfigVXData | ApiErrorResponse,
    GetDockerWorkerConfigVXByIdRequestBody,
    GetDockerWorkerConfigVXByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerConfigVXByIdRequestBodySanitizer, GetDockerWorkerConfigVXByIdRequestBodyValidator);
    const {
        configId,
    } =  await validateAndSanitize(req.params, GetDockerWorkerConfigVXByIdRequestParamsSanitizer, GetDockerWorkerConfigVXByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerWorkerConfigVXByIdRequestQuerySanitizer, GetDockerWorkerConfigVXByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerWorkerConfigVXDataStringify,
        validateAndRespond({ id, ...rest }, DockerWorkerConfigVXDataFromJSON, DockerWorkerConfigVXDataValidator),
    );
}



/v1/docker/worker/config
const DockerWorkerConfigV0DataArrayStringify = fastJSONArrayify(DockerWorkerConfigV0DataStringifyShape);
export const getDockerWorkerConfigsFN: RequestHandler<
    GetDockerWorkerConfigsRequestParams,
    DockerWorkerConfigV0Data[] | ApiErrorResponse,
    GetDockerWorkerConfigsRequestBody,
    GetDockerWorkerConfigsRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerConfigsRequestBodySanitizer, GetDockerWorkerConfigsRequestBodyValidator);
    const {
    } =  await validateAndSanitize(req.params, GetDockerWorkerConfigsRequestParamsSanitizer, GetDockerWorkerConfigsRequestParamsValidator);
    const {
    } = await validateAndSanitize(req.query, GetDockerWorkerConfigsRequestQuerySanitizer, GetDockerWorkerConfigsRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerWorkerConfigV0DataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerWorkerConfigV0DataFromJSON, DockerWorkerConfigV0DataValidator);
        }),
    );
}



/v1/docker/worker
const DockerWorkerRegistryEntryDataArrayStringify = fastJSONArrayify(DockerWorkerRegistryEntryDataStringifyShape);
export const getDockerWorkerRegistryEntriesFN: RequestHandler<
    GetDockerWorkerRegistryEntriesRequestParams,
    DockerWorkerRegistryEntryData[] | ApiErrorResponse,
    GetDockerWorkerRegistryEntriesRequestBody,
    GetDockerWorkerRegistryEntriesRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerRegistryEntriesRequestBodySanitizer, GetDockerWorkerRegistryEntriesRequestBodyValidator);
    const {
        
        
    } =  await validateAndSanitize(req.params, GetDockerWorkerRegistryEntriesRequestParamsSanitizer, GetDockerWorkerRegistryEntriesRequestParamsValidator);
    const {
        getAssetsOfTeam,
        getAssetsOfTeamInclusiveSelf,
    } = await validateAndSanitize(req.query, GetDockerWorkerRegistryEntriesRequestQuerySanitizer, GetDockerWorkerRegistryEntriesRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DockerWorkerRegistryEntryDataArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DockerWorkerRegistryEntryDataFromJSON, DockerWorkerRegistryEntryDataValidator);
        }),
    );
}



/v1/docker/worker/{workerId}

export const getDockerWorkerRegistryEntryByIdFN: RequestHandler<
    GetDockerWorkerRegistryEntryByIdRequestParams,
    DockerWorkerRegistryEntryData | ApiErrorResponse,
    GetDockerWorkerRegistryEntryByIdRequestBody,
    GetDockerWorkerRegistryEntryByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDockerWorkerRegistryEntryByIdRequestBodySanitizer, GetDockerWorkerRegistryEntryByIdRequestBodyValidator);
    const {
        workerId,
    } =  await validateAndSanitize(req.params, GetDockerWorkerRegistryEntryByIdRequestParamsSanitizer, GetDockerWorkerRegistryEntryByIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDockerWorkerRegistryEntryByIdRequestQuerySanitizer, GetDockerWorkerRegistryEntryByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerWorkerRegistryEntryDataStringify,
        validateAndRespond({ id, ...rest }, DockerWorkerRegistryEntryDataFromJSON, DockerWorkerRegistryEntryDataValidator),
    );
}



/v1/docker/authorization

export const postDockerAuthorizationRequestFN: RequestHandler<
    PostDockerAuthorizationRequestRequestParams,
    DockerAuthorizationResponse | ApiErrorResponse,
    PostDockerAuthorizationRequestRequestBody,
    PostDockerAuthorizationRequestRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, PostDockerAuthorizationRequestRequestBodySanitizer, PostDockerAuthorizationRequestRequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, PostDockerAuthorizationRequestRequestParamsSanitizer, PostDockerAuthorizationRequestRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, PostDockerAuthorizationRequestRequestQuerySanitizer, PostDockerAuthorizationRequestRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DockerAuthorizationResponseStringify,
        validateAndRespond({ id, ...rest }, DockerAuthorizationResponseFromJSON, DockerAuthorizationResponseValidator),
    );
}



/v1/docker

export const postDockerUsageStatsFN: RequestHandler<
    PostDockerUsageStatsRequestParams,
     | ApiErrorResponse,
    PostDockerUsageStatsRequestBody,
    PostDockerUsageStatsRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, PostDockerUsageStatsRequestBodySanitizer, PostDockerUsageStatsRequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, PostDockerUsageStatsRequestParamsSanitizer, PostDockerUsageStatsRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, PostDockerUsageStatsRequestQuerySanitizer, PostDockerUsageStatsRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/docker/workerAuthorization

export const postDockerWorkerAuthorizationRequestFN: RequestHandler<
    PostDockerWorkerAuthorizationRequestRequestParams,
    string | ApiErrorResponse,
    PostDockerWorkerAuthorizationRequestRequestBody,
    PostDockerWorkerAuthorizationRequestRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, PostDockerWorkerAuthorizationRequestRequestBodySanitizer, PostDockerWorkerAuthorizationRequestRequestBodyValidator);
    const {
        
    } =  await validateAndSanitize(req.params, PostDockerWorkerAuthorizationRequestRequestParamsSanitizer, PostDockerWorkerAuthorizationRequestRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, PostDockerWorkerAuthorizationRequestRequestQuerySanitizer, PostDockerWorkerAuthorizationRequestRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/docker/worker

export const registerDockerWorkerFN: RequestHandler<
    RegisterDockerWorkerRequestParams,
    CreateEntityResponse | ApiErrorResponse,
    RegisterDockerWorkerRequestBody,
    RegisterDockerWorkerRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, RegisterDockerWorkerRequestBodySanitizer, RegisterDockerWorkerRequestBodyValidator);
    const {
        
        
    } =  await validateAndSanitize(req.params, RegisterDockerWorkerRequestParamsSanitizer, RegisterDockerWorkerRequestParamsValidator);
    const {
        
        forUserId,
    } = await validateAndSanitize(req.query, RegisterDockerWorkerRequestQuerySanitizer, RegisterDockerWorkerRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        CreateEntityResponseStringify,
        validateAndRespond({ id, ...rest }, CreateEntityResponseFromJSON, CreateEntityResponseValidator),
    );
}



/v1/docker/runs/{runId}

export const updateDockerRunByIdFN: RequestHandler<
    UpdateDockerRunByIdRequestParams,
     | ApiErrorResponse,
    UpdateDockerRunByIdRequestBody,
    UpdateDockerRunByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, UpdateDockerRunByIdRequestBodySanitizer, UpdateDockerRunByIdRequestBodyValidator);
    const {
        
        runId,
    } =  await validateAndSanitize(req.params, UpdateDockerRunByIdRequestParamsSanitizer, UpdateDockerRunByIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, UpdateDockerRunByIdRequestQuerySanitizer, UpdateDockerRunByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/docker/worker/config/{configId}

export const updateDockerWorkerConfigByIdFN: RequestHandler<
    UpdateDockerWorkerConfigByIdRequestParams,
     | ApiErrorResponse,
    UpdateDockerWorkerConfigByIdRequestBody,
    UpdateDockerWorkerConfigByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, UpdateDockerWorkerConfigByIdRequestBodySanitizer, UpdateDockerWorkerConfigByIdRequestBodyValidator);
    const {
        
        configId,
    } =  await validateAndSanitize(req.params, UpdateDockerWorkerConfigByIdRequestParamsSanitizer, UpdateDockerWorkerConfigByIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, UpdateDockerWorkerConfigByIdRequestQuerySanitizer, UpdateDockerWorkerConfigByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/docker/worker/{workerId}

export const updateDockerWorkerRegistryEntryByIdFN: RequestHandler<
    UpdateDockerWorkerRegistryEntryByIdRequestParams,
     | ApiErrorResponse,
    UpdateDockerWorkerRegistryEntryByIdRequestBody,
    UpdateDockerWorkerRegistryEntryByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, UpdateDockerWorkerRegistryEntryByIdRequestBodySanitizer, UpdateDockerWorkerRegistryEntryByIdRequestBodyValidator);
    const {
        
        workerId,
    } =  await validateAndSanitize(req.params, UpdateDockerWorkerRegistryEntryByIdRequestParamsSanitizer, UpdateDockerWorkerRegistryEntryByIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, UpdateDockerWorkerRegistryEntryByIdRequestQuerySanitizer, UpdateDockerWorkerRegistryEntryByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/datasets/{datasetId}/docker/worker/{workerId}/schedule/{scheduledId}

export const updateScheduledDockerRunStateByIdFN: RequestHandler<
    UpdateScheduledDockerRunStateByIdRequestParams,
     | ApiErrorResponse,
    UpdateScheduledDockerRunStateByIdRequestBody,
    UpdateScheduledDockerRunStateByIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, UpdateScheduledDockerRunStateByIdRequestBodySanitizer, UpdateScheduledDockerRunStateByIdRequestBodyValidator);
    const {
        
        datasetId,
        workerId,
        scheduledId,
    } =  await validateAndSanitize(req.params, UpdateScheduledDockerRunStateByIdRequestParamsSanitizer, UpdateScheduledDockerRunStateByIdRequestParamsValidator);
    const {
        
        
        
        
    } = await validateAndSanitize(req.query, UpdateScheduledDockerRunStateByIdRequestQuerySanitizer, UpdateScheduledDockerRunStateByIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}


*/
/* LIGHTLY CUSTOM END -> api */
/**
 * DockerApi - interface
 *
 * @export
 * @interface DockerApiInterface
 */
export interface DockerApiInterface {
    /**
     * Cancel a scheduled run. This will fail if the state of the scheduled run is no longer OPEN (e.g when it is LOCKED)
     * @summary Cancel scheduled run
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} scheduledId ObjectId of the docker worker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    cancelScheduledDockerRunStateByIdRaw(requestParameters: CancelScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Cancel a scheduled run. This will fail if the state of the scheduled run is no longer OPEN (e.g when it is LOCKED)
     * Cancel scheduled run
     */
    cancelScheduledDockerRunStateById(requestParameters: CancelScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * confirm that the docker run artifact has been uploaded and is available
     * @summary Confirm run artifact upload
     * @param {string} runId ObjectId of the docker run
     * @param {string} artifactId ObjectId of the artifact of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    confirmDockerRunArtifactCreationRaw(requestParameters: ConfirmDockerRunArtifactCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * confirm that the docker run artifact has been uploaded and is available
     * Confirm run artifact upload
     */
    confirmDockerRunArtifactCreation(requestParameters: ConfirmDockerRunArtifactCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Creates a new docker run database entry.
     * @summary Create docker run
     * @param {DockerRunCreateRequest} dockerRunCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerRunRaw(requestParameters: CreateDockerRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Creates a new docker run database entry.
     * Create docker run
     */
    createDockerRun(requestParameters: CreateDockerRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * creates a docker run artifact and returns the writeUrl and artifactId to upload and confirm
     * @summary Create run artifact
     * @param {DockerRunArtifactCreateRequest} dockerRunArtifactCreateRequest
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerRunArtifactRaw(requestParameters: CreateDockerRunArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunArtifactCreatedData>>;
    /**
     * creates a docker run artifact and returns the writeUrl and artifactId to upload and confirm
     * Create run artifact
     */
    createDockerRunArtifact(requestParameters: CreateDockerRunArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunArtifactCreatedData>;
    /**
     * Creates a new log msg for a docker run database entry.
     * @summary Create run log
     * @param {DockerRunLogCreateEntriesRequest} dockerRunLogCreateEntriesRequest
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerRunLogByIdRaw(requestParameters: CreateDockerRunLogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Creates a new log msg for a docker run database entry.
     * Create run log
     */
    createDockerRunLogById(requestParameters: CreateDockerRunLogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Schedule a docker run by dataset id. With docker runs it\'s possible to process unlabeled images from a datasource and use active learning to select the most relevant samples for further processing and visualization in the web app
     * @summary Schedule run by dataset id
     * @param {DockerRunScheduledCreateRequest} dockerRunScheduledCreateRequest
     * @param {string} datasetId ObjectId of the dataset
     * @param {boolean} [disableConfigValidation] if set, disables the sanity check and validation where we check if the provided configuration can run on your datasource e.g     if predictions are used, we check that the bucket structure + tasks.json, schema.json are correct     if metadata is used, we check that the bucket structure + schema.json are correct     if relevantFilenamesFile is set, we check that the file exists
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerRunScheduledByDatasetIdRaw(requestParameters: CreateDockerRunScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Schedule a docker run by dataset id. With docker runs it\'s possible to process unlabeled images from a datasource and use active learning to select the most relevant samples for further processing and visualization in the web app
     * Schedule run by dataset id
     */
    createDockerRunScheduledByDatasetId(requestParameters: CreateDockerRunScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * Creates a docker worker configuration.
     * @summary Create worker configuration
     * @param {DockerWorkerConfigCreateRequest} dockerWorkerConfigCreateRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerWorkerConfigRaw(requestParameters: CreateDockerWorkerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Creates a docker worker configuration.
     * Create worker configuration
     */
    createDockerWorkerConfig(requestParameters: CreateDockerWorkerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * Creates a docker worker v2 configuration.
     * @summary Create worker v2 configuration
     * @param {DockerWorkerConfigV2CreateRequest} dockerWorkerConfigV2CreateRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerWorkerConfigV2Raw(requestParameters: CreateDockerWorkerConfigV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Creates a docker worker v2 configuration.
     * Create worker v2 configuration
     */
    createDockerWorkerConfigV2(requestParameters: CreateDockerWorkerConfigV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * Creates a docker worker v3 configuration.
     * @summary Create worker v3 configuration
     * @param {DockerWorkerConfigV3CreateRequest} dockerWorkerConfigV3CreateRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerWorkerConfigV3Raw(requestParameters: CreateDockerWorkerConfigV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Creates a docker worker v3 configuration.
     * Create worker v3 configuration
     */
    createDockerWorkerConfigV3(requestParameters: CreateDockerWorkerConfigV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * Creates a docker worker configuration for any version. Can either be V2, V3, V4, V5 etc.
     * @summary Create worker configuration
     * @param {DockerWorkerConfigOmniVXCreateRequest} dockerWorkerConfigOmniVXCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    createDockerWorkerConfigVXRaw(requestParameters: CreateDockerWorkerConfigVXRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Creates a docker worker configuration for any version. Can either be V2, V3, V4, V5 etc.
     * Create worker configuration
     */
    createDockerWorkerConfigVX(requestParameters: CreateDockerWorkerConfigVXRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * Deletes a worker registry entry by id.
     * @summary Delete registered worker
     * @param {string} workerId ObjectId of the docker worker
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    deleteDockerWorkerRegistryEntryByIdRaw(requestParameters: DeleteDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Deletes a worker registry entry by id.
     * Delete registered worker
     */
    deleteDockerWorkerRegistryEntryById(requestParameters: DeleteDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Return a free default worker or register a new worker if no default worker exists.
     * @summary Get or register default worker
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDefaultOrRegisterWorkerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerRegistryEntryData>>;
    /**
     * Return a free default worker or register a new worker if no default worker exists.
     * Get or register default worker
     */
    getDefaultOrRegisterWorker(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerRegistryEntryData>;
    /**
     * Requests license information to run the container.
     * @summary Get license information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerLicenseInformationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerLicenseInformation>>;
    /**
     * Requests license information to run the container.
     * Get license information
     */
    getDockerLicenseInformation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerLicenseInformation>;
    /**
     * Get the url of a specific docker runs artifact
     * @summary Get run artifact read URL
     * @param {string} runId ObjectId of the docker run
     * @param {string} artifactId ObjectId of the artifact of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunArtifactReadUrlByIdRaw(requestParameters: GetDockerRunArtifactReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Get the url of a specific docker runs artifact
     * Get run artifact read URL
     */
    getDockerRunArtifactReadUrlById(requestParameters: GetDockerRunArtifactReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Gets a docker run by docker run id.
     * @summary Get run by id
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunByIdRaw(requestParameters: GetDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunData>>;
    /**
     * Gets a docker run by docker run id.
     * Get run by id
     */
    getDockerRunById(requestParameters: GetDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunData>;
    /**
     * Retrieves the associated docker run of a scheduled run; returns the docker run by the id of the scheduled run which caused this docker run. If a scheduled docker run has not yet started being processed by a worker, a 404 will be returned.
     * @summary Get run by scheduled id
     * @param {string} scheduledId ObjectId of the docker worker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunByScheduledIdRaw(requestParameters: GetDockerRunByScheduledIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunData>>;
    /**
     * Retrieves the associated docker run of a scheduled run; returns the docker run by the id of the scheduled run which caused this docker run. If a scheduled docker run has not yet started being processed by a worker, a 404 will be returned.
     * Get run by scheduled id
     */
    getDockerRunByScheduledId(requestParameters: GetDockerRunByScheduledIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunData>;
    /**
     * Gets the logs of a docker run by docker run id.
     * @summary Get run logs
     * @param {string} runId ObjectId of the docker run
     * @param {number} [cursor] the cursor of where the logs last were
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunLogsByIdRaw(requestParameters: GetDockerRunLogsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunLogData>>;
    /**
     * Gets the logs of a docker run by docker run id.
     * Get run logs
     */
    getDockerRunLogsById(requestParameters: GetDockerRunLogsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunLogData>;
    /**
     * DEPRECATED, use getDockerRunArtifactReadUrlById - Get the url of a specific docker runs report
     * @summary Get run report read URL
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunReportReadUrlByIdRaw(requestParameters: GetDockerRunReportReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * DEPRECATED, use getDockerRunArtifactReadUrlById - Get the url of a specific docker runs report
     * Get run report read URL
     */
    getDockerRunReportReadUrlById(requestParameters: GetDockerRunReportReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * DEPRECATED, use createDockerRunArtifact - Get the signed url to upload a report of a docker run
     * @summary Get run report write URL
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunReportWriteUrlByIdRaw(requestParameters: GetDockerRunReportWriteUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * DEPRECATED, use createDockerRunArtifact - Get the signed url to upload a report of a docker run
     * Get run report write URL
     */
    getDockerRunReportWriteUrlById(requestParameters: GetDockerRunReportWriteUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Gets all tags which were created from a docker run by docker run id.
     * @summary Get run tags
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunTagsRaw(requestParameters: GetDockerRunTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TagData>>>;
    /**
     * Gets all tags which were created from a docker run by docker run id.
     * Get run tags
     */
    getDockerRunTags(requestParameters: GetDockerRunTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TagData>>;
    /**
     * Gets all docker runs for a user.
     * @summary Get Docker runs
     * @param {number} [pageSize] pagination size/limit of the number of samples to return
     * @param {number} [pageOffset] pagination offset
     * @param {boolean} [getAssetsOfTeam] if this flag is true, we get the relevant asset of the team of the user rather than the assets of the user
     * @param {boolean} [getAssetsOfTeamInclusiveSelf] if this flag is true, we get the relevant asset of the team of the user including the assets of the user
     * @param {boolean} [showArchived] if this flag is true, we also get the archived assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunsRaw(requestParameters: GetDockerRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunData>>>;
    /**
     * Gets all docker runs for a user.
     * Get Docker runs
     */
    getDockerRuns(requestParameters: GetDockerRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunData>>;
    /**
     * Gets the total count of the amount of runs existing for a user
     * @summary Get runs count
     * @param {boolean} [getAssetsOfTeam] if this flag is true, we get the relevant asset of the team of the user rather than the assets of the user
     * @param {boolean} [getAssetsOfTeamInclusiveSelf] if this flag is true, we get the relevant asset of the team of the user including the assets of the user
     * @param {boolean} [showArchived] if this flag is true, we also get the archived assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunsCountRaw(requestParameters: GetDockerRunsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Gets the total count of the amount of runs existing for a user
     * Get runs count
     */
    getDockerRunsCount(requestParameters: GetDockerRunsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Get all docker runs of a user by dataset id
     * @summary Get runs by dataset id
     * @param {string} datasetId ObjectId of the dataset
     * @param {number} [pageSize] pagination size/limit of the number of samples to return
     * @param {number} [pageOffset] pagination offset
     * @param {boolean} [getAssetsOfTeam] if this flag is true, we get the relevant asset of the team of the user rather than the assets of the user
     * @param {boolean} [getAssetsOfTeamInclusiveSelf] if this flag is true, we get the relevant asset of the team of the user including the assets of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunsQueryByDatasetIdRaw(requestParameters: GetDockerRunsQueryByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunData>>>;
    /**
     * Get all docker runs of a user by dataset id
     * Get runs by dataset id
     */
    getDockerRunsQueryByDatasetId(requestParameters: GetDockerRunsQueryByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunData>>;
    /**
     * Get all scheduled docker runs by dataset id. If no state(s) is specified, returns runs which have not yet finished (neither DONE or CANCELED).
     * @summary Get scheduled runs by dataset id
     * @param {string} datasetId ObjectId of the dataset
     * @param {DockerRunScheduledState} [state]
     * @param {DockerRunScheduledStateArray} [states]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunsScheduledByDatasetIdRaw(requestParameters: GetDockerRunsScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunScheduledData>>>;
    /**
     * Get all scheduled docker runs by dataset id. If no state(s) is specified, returns runs which have not yet finished (neither DONE or CANCELED).
     * Get scheduled runs by dataset id
     */
    getDockerRunsScheduledByDatasetId(requestParameters: GetDockerRunsScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunScheduledData>>;
    /**
     * Get all scheduled docker runs of the user. Additionally, you can filter by state.  Furthermore, you can filter by only providing labels and only return scheduled runs whose runsOn labels are included in the provided labels. Runs are filtered by the provided version parameter. Version parameter set to * returns all configs
     * @summary Get scheduled runs
     * @param {DockerRunScheduledState} [state]
     * @param {DockerWorkerLabels} [labels]
     * @param {string} [version]
     * @param {boolean} [includeUnlockableRuns] Unlockable runs are runs which can\&#39;t be locked due to e.g another run with the same datasetId being locked/processed. This safeguards two workers processing the same dataset. Only has an effect if querying for runs with state&#x3D;OPEN
     * @param {boolean} [getAssetsOfTeam] if this flag is true, we get the relevant asset of the team of the user rather than the assets of the user
     * @param {boolean} [getAssetsOfTeamInclusiveSelf] if this flag is true, we get the relevant asset of the team of the user including the assets of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunsScheduledByStateAndLabelsRaw(requestParameters: GetDockerRunsScheduledByStateAndLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunScheduledData>>>;
    /**
     * Get all scheduled docker runs of the user. Additionally, you can filter by state.  Furthermore, you can filter by only providing labels and only return scheduled runs whose runsOn labels are included in the provided labels. Runs are filtered by the provided version parameter. Version parameter set to * returns all configs
     * Get scheduled runs
     */
    getDockerRunsScheduledByStateAndLabels(requestParameters: GetDockerRunsScheduledByStateAndLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunScheduledData>>;
    /**
     * Get all scheduled runs that might be picked up by the worker with that workerId.
     * @summary Get a workers scheduled runs
     * @param {string} workerId ObjectId of the docker worker
     * @param {DockerRunScheduledState} [state]
     * @param {boolean} [getAssetsOfTeam] if this flag is true, we get the relevant asset of the team of the user rather than the assets of the user
     * @param {boolean} [getAssetsOfTeamInclusiveSelf] if this flag is true, we get the relevant asset of the team of the user including the assets of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerRunsScheduledByWorkerIdRaw(requestParameters: GetDockerRunsScheduledByWorkerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunScheduledData>>>;
    /**
     * Get all scheduled runs that might be picked up by the worker with that workerId.
     * Get a workers scheduled runs
     */
    getDockerRunsScheduledByWorkerId(requestParameters: GetDockerRunsScheduledByWorkerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunScheduledData>>;
    /**
     * Gets a docker worker configuration by id. It will try to return the config version but expects (and will fail if not) the config to be of v0
     * @summary Get worker configuration
     * @param {string} configId ObjectId of the docker worker config
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerConfigByIdRaw(requestParameters: GetDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigV0Data>>;
    /**
     * Gets a docker worker configuration by id. It will try to return the config version but expects (and will fail if not) the config to be of v0
     * Get worker configuration
     */
    getDockerWorkerConfigById(requestParameters: GetDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigV0Data>;
    /**
     * Gets a docker worker configuration by id which needs to be v2
     * @summary Get worker v2 configuration
     * @param {string} configId ObjectId of the docker worker config
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerConfigV2ByIdRaw(requestParameters: GetDockerWorkerConfigV2ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigV2Data>>;
    /**
     * Gets a docker worker configuration by id which needs to be v2
     * Get worker v2 configuration
     */
    getDockerWorkerConfigV2ById(requestParameters: GetDockerWorkerConfigV2ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigV2Data>;
    /**
     * Gets a docker worker configuration by id which needs to be v3
     * @summary Get worker v3 configuration
     * @param {string} configId ObjectId of the docker worker config
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerConfigV3ByIdRaw(requestParameters: GetDockerWorkerConfigV3ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigV3Data>>;
    /**
     * Gets a docker worker configuration by id which needs to be v3
     * Get worker v3 configuration
     */
    getDockerWorkerConfigV3ById(requestParameters: GetDockerWorkerConfigV3ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigV3Data>;
    /**
     * Gets a docker worker configuration by id. It will return whichever config version the configId corresponds to.
     * @summary Get worker configuration
     * @param {string} configId ObjectId of the docker worker config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerConfigVXByIdRaw(requestParameters: GetDockerWorkerConfigVXByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigVXData>>;
    /**
     * Gets a docker worker configuration by id. It will return whichever config version the configId corresponds to.
     * Get worker configuration
     */
    getDockerWorkerConfigVXById(requestParameters: GetDockerWorkerConfigVXByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigVXData>;
    /**
     * Get docker worker configurations.
     * @summary Get worker configurations
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerConfigsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerWorkerConfigV0Data>>>;
    /**
     * Get docker worker configurations.
     * Get worker configurations
     */
    getDockerWorkerConfigs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerWorkerConfigV0Data>>;
    /**
     * Returns all worker registry entries for a given user.
     * @summary Get registered workers
     * @param {boolean} [getAssetsOfTeam] if this flag is true, we get the relevant asset of the team of the user rather than the assets of the user
     * @param {boolean} [getAssetsOfTeamInclusiveSelf] if this flag is true, we get the relevant asset of the team of the user including the assets of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerRegistryEntriesRaw(requestParameters: GetDockerWorkerRegistryEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerWorkerRegistryEntryData>>>;
    /**
     * Returns all worker registry entries for a given user.
     * Get registered workers
     */
    getDockerWorkerRegistryEntries(requestParameters: GetDockerWorkerRegistryEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerWorkerRegistryEntryData>>;
    /**
     * Returns worker registry entry by id.
     * @summary Get registered worker
     * @param {string} workerId ObjectId of the docker worker
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    getDockerWorkerRegistryEntryByIdRaw(requestParameters: GetDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerRegistryEntryData>>;
    /**
     * Returns worker registry entry by id.
     * Get registered worker
     */
    getDockerWorkerRegistryEntryById(requestParameters: GetDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerRegistryEntryData>;
    /**
     * Deprecated, use postDockerWorkerAuthorizationRequest. Performs an authorization to run the container.
     * @summary Authorize Docker container
     * @param {DockerAuthorizationRequest} dockerAuthorizationRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    postDockerAuthorizationRequestRaw(requestParameters: PostDockerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerAuthorizationResponse>>;
    /**
     * Deprecated, use postDockerWorkerAuthorizationRequest. Performs an authorization to run the container.
     * Authorize Docker container
     */
    postDockerAuthorizationRequest(requestParameters: PostDockerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerAuthorizationResponse>;
    /**
     * Adds a diagnostic entry of user stats.
     * @summary Create docker usage stats
     * @param {DockerUserStats} dockerUserStats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    postDockerUsageStatsRaw(requestParameters: PostDockerUsageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Adds a diagnostic entry of user stats.
     * Create docker usage stats
     */
    postDockerUsageStats(requestParameters: PostDockerUsageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Performs an authorization to run the Lightly Worker.
     * @summary Authorize Lightly Worker
     * @param {DockerWorkerAuthorizationRequest} dockerWorkerAuthorizationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    postDockerWorkerAuthorizationRequestRaw(requestParameters: PostDockerWorkerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Performs an authorization to run the Lightly Worker.
     * Authorize Lightly Worker
     */
    postDockerWorkerAuthorizationRequest(requestParameters: PostDockerWorkerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Registers a worker for a user. If a worker with the same name is passed that already exists, the same workerId will be returned
     * @summary Register worker
     * @param {CreateDockerWorkerRegistryEntryRequest} createDockerWorkerRegistryEntryRequest
     * @param {string} [forUserId] The userId for which we want to create the worker for. This is only allowed for users within the same team.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    registerDockerWorkerRaw(requestParameters: RegisterDockerWorkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>>;
    /**
     * Registers a worker for a user. If a worker with the same name is passed that already exists, the same workerId will be returned
     * Register worker
     */
    registerDockerWorker(requestParameters: RegisterDockerWorkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse>;
    /**
     * Updates a docker run database entry.
     * @summary Update run by id
     * @param {DockerRunUpdateRequest} dockerRunUpdateRequest
     * @param {string} runId ObjectId of the docker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    updateDockerRunByIdRaw(requestParameters: UpdateDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Updates a docker run database entry.
     * Update run by id
     */
    updateDockerRunById(requestParameters: UpdateDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * DEPRECATED, DONT USE. Updates a docker worker configuration by id.
     * @summary Update worker configuration
     * @param {DockerWorkerConfigCreateRequest} dockerWorkerConfigCreateRequest
     * @param {string} configId ObjectId of the docker worker config
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    updateDockerWorkerConfigByIdRaw(requestParameters: UpdateDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * DEPRECATED, DONT USE. Updates a docker worker configuration by id.
     * Update worker configuration
     */
    updateDockerWorkerConfigById(requestParameters: UpdateDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Updates the worker status by id.
     * @summary Update worker status
     * @param {UpdateDockerWorkerRegistryEntryRequest} updateDockerWorkerRegistryEntryRequest
     * @param {string} workerId ObjectId of the docker worker
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    updateDockerWorkerRegistryEntryByIdRaw(requestParameters: UpdateDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Updates the worker status by id.
     * Update worker status
     */
    updateDockerWorkerRegistryEntryById(requestParameters: UpdateDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Update the state of a scheduled run. This will fail if the state of the scheduled run is LOCKED.
     * @summary Update scheduled run state
     * @param {DockerRunScheduledUpdateRequest} dockerRunScheduledUpdateRequest
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} workerId ObjectId of the docker worker
     * @param {string} scheduledId ObjectId of the docker worker run
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockerApiInterface
     */
    updateScheduledDockerRunStateByIdRaw(requestParameters: UpdateScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Update the state of a scheduled run. This will fail if the state of the scheduled run is LOCKED.
     * Update scheduled run state
     */
    updateScheduledDockerRunStateById(requestParameters: UpdateScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
}
/**
 *
 */
export class DockerApi extends runtime.BaseAPI implements DockerApiInterface {
    /**
     * Cancel a scheduled run. This will fail if the state of the scheduled run is no longer OPEN (e.g when it is LOCKED)
     * Cancel scheduled run
     */
    async cancelScheduledDockerRunStateByIdRaw(requestParameters: CancelScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling cancelScheduledDockerRunStateById.');
        }
        if (requestParameters.scheduledId === null || requestParameters.scheduledId === undefined) {
            throw new runtime.RequiredError('scheduledId', 'Required parameter requestParameters.scheduledId was null or undefined when calling cancelScheduledDockerRunStateById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/docker/worker/schedule/{scheduledId}`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))).replace(`{${"scheduledId"}}`, encodeURIComponent(String(requestParameters.scheduledId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancel a scheduled run. This will fail if the state of the scheduled run is no longer OPEN (e.g when it is LOCKED)
     * Cancel scheduled run
     */
    async cancelScheduledDockerRunStateById(requestParameters: CancelScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelScheduledDockerRunStateByIdRaw(requestParameters, initOverrides);
    }
    /**
     * confirm that the docker run artifact has been uploaded and is available
     * Confirm run artifact upload
     */
    async confirmDockerRunArtifactCreationRaw(requestParameters: ConfirmDockerRunArtifactCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling confirmDockerRunArtifactCreation.');
        }
        if (requestParameters.artifactId === null || requestParameters.artifactId === undefined) {
            throw new runtime.RequiredError('artifactId', 'Required parameter requestParameters.artifactId was null or undefined when calling confirmDockerRunArtifactCreation.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/artifacts/{artifactId}/confirmUpload`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"artifactId"}}`, encodeURIComponent(String(requestParameters.artifactId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * confirm that the docker run artifact has been uploaded and is available
     * Confirm run artifact upload
     */
    async confirmDockerRunArtifactCreation(requestParameters: ConfirmDockerRunArtifactCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmDockerRunArtifactCreationRaw(requestParameters, initOverrides);
    }
    /**
     * Creates a new docker run database entry.
     * Create docker run
     */
    async createDockerRunRaw(requestParameters: CreateDockerRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.dockerRunCreateRequest === null || requestParameters.dockerRunCreateRequest === undefined) {
            throw new runtime.RequiredError('dockerRunCreateRequest', 'Required parameter requestParameters.dockerRunCreateRequest was null or undefined when calling createDockerRun.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerRunCreateRequestToJSON(requestParameters.dockerRunCreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Creates a new docker run database entry.
     * Create docker run
     */
    async createDockerRun(requestParameters: CreateDockerRunRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.createDockerRunRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * creates a docker run artifact and returns the writeUrl and artifactId to upload and confirm
     * Create run artifact
     */
    async createDockerRunArtifactRaw(requestParameters: CreateDockerRunArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunArtifactCreatedData>> {
        if (requestParameters.dockerRunArtifactCreateRequest === null || requestParameters.dockerRunArtifactCreateRequest === undefined) {
            throw new runtime.RequiredError('dockerRunArtifactCreateRequest', 'Required parameter requestParameters.dockerRunArtifactCreateRequest was null or undefined when calling createDockerRunArtifact.');
        }
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling createDockerRunArtifact.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/artifacts`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerRunArtifactCreateRequestToJSON(requestParameters.dockerRunArtifactCreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerRunArtifactCreatedDataFromJSON(jsonValue));
    }
    /**
     * creates a docker run artifact and returns the writeUrl and artifactId to upload and confirm
     * Create run artifact
     */
    async createDockerRunArtifact(requestParameters: CreateDockerRunArtifactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunArtifactCreatedData> {
        const response = await this.createDockerRunArtifactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates a new log msg for a docker run database entry.
     * Create run log
     */
    async createDockerRunLogByIdRaw(requestParameters: CreateDockerRunLogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dockerRunLogCreateEntriesRequest === null || requestParameters.dockerRunLogCreateEntriesRequest === undefined) {
            throw new runtime.RequiredError('dockerRunLogCreateEntriesRequest', 'Required parameter requestParameters.dockerRunLogCreateEntriesRequest was null or undefined when calling createDockerRunLogById.');
        }
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling createDockerRunLogById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/logs`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DockerRunLogCreateEntriesRequestToJSON(requestParameters.dockerRunLogCreateEntriesRequest),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Creates a new log msg for a docker run database entry.
     * Create run log
     */
    async createDockerRunLogById(requestParameters: CreateDockerRunLogByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createDockerRunLogByIdRaw(requestParameters, initOverrides);
    }
    /**
     * Schedule a docker run by dataset id. With docker runs it\'s possible to process unlabeled images from a datasource and use active learning to select the most relevant samples for further processing and visualization in the web app
     * Schedule run by dataset id
     */
    async createDockerRunScheduledByDatasetIdRaw(requestParameters: CreateDockerRunScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.dockerRunScheduledCreateRequest === null || requestParameters.dockerRunScheduledCreateRequest === undefined) {
            throw new runtime.RequiredError('dockerRunScheduledCreateRequest', 'Required parameter requestParameters.dockerRunScheduledCreateRequest was null or undefined when calling createDockerRunScheduledByDatasetId.');
        }
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling createDockerRunScheduledByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.disableConfigValidation !== undefined) {
            queryParameters['disableConfigValidation'] = requestParameters.disableConfigValidation;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/docker/worker/schedule`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerRunScheduledCreateRequestToJSON(requestParameters.dockerRunScheduledCreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Schedule a docker run by dataset id. With docker runs it\'s possible to process unlabeled images from a datasource and use active learning to select the most relevant samples for further processing and visualization in the web app
     * Schedule run by dataset id
     */
    async createDockerRunScheduledByDatasetId(requestParameters: CreateDockerRunScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.createDockerRunScheduledByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates a docker worker configuration.
     * Create worker configuration
     */
    async createDockerWorkerConfigRaw(requestParameters: CreateDockerWorkerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.dockerWorkerConfigCreateRequest === null || requestParameters.dockerWorkerConfigCreateRequest === undefined) {
            throw new runtime.RequiredError('dockerWorkerConfigCreateRequest', 'Required parameter requestParameters.dockerWorkerConfigCreateRequest was null or undefined when calling createDockerWorkerConfig.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerWorkerConfigCreateRequestToJSON(requestParameters.dockerWorkerConfigCreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Creates a docker worker configuration.
     * Create worker configuration
     */
    async createDockerWorkerConfig(requestParameters: CreateDockerWorkerConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.createDockerWorkerConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates a docker worker v2 configuration.
     * Create worker v2 configuration
     */
    async createDockerWorkerConfigV2Raw(requestParameters: CreateDockerWorkerConfigV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.dockerWorkerConfigV2CreateRequest === null || requestParameters.dockerWorkerConfigV2CreateRequest === undefined) {
            throw new runtime.RequiredError('dockerWorkerConfigV2CreateRequest', 'Required parameter requestParameters.dockerWorkerConfigV2CreateRequest was null or undefined when calling createDockerWorkerConfigV2.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerWorkerConfigV2CreateRequestToJSON(requestParameters.dockerWorkerConfigV2CreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Creates a docker worker v2 configuration.
     * Create worker v2 configuration
     */
    async createDockerWorkerConfigV2(requestParameters: CreateDockerWorkerConfigV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.createDockerWorkerConfigV2Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates a docker worker v3 configuration.
     * Create worker v3 configuration
     */
    async createDockerWorkerConfigV3Raw(requestParameters: CreateDockerWorkerConfigV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.dockerWorkerConfigV3CreateRequest === null || requestParameters.dockerWorkerConfigV3CreateRequest === undefined) {
            throw new runtime.RequiredError('dockerWorkerConfigV3CreateRequest', 'Required parameter requestParameters.dockerWorkerConfigV3CreateRequest was null or undefined when calling createDockerWorkerConfigV3.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/v3`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerWorkerConfigV3CreateRequestToJSON(requestParameters.dockerWorkerConfigV3CreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Creates a docker worker v3 configuration.
     * Create worker v3 configuration
     */
    async createDockerWorkerConfigV3(requestParameters: CreateDockerWorkerConfigV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.createDockerWorkerConfigV3Raw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Creates a docker worker configuration for any version. Can either be V2, V3, V4, V5 etc.
     * Create worker configuration
     */
    async createDockerWorkerConfigVXRaw(requestParameters: CreateDockerWorkerConfigVXRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.dockerWorkerConfigOmniVXCreateRequest === null || requestParameters.dockerWorkerConfigOmniVXCreateRequest === undefined) {
            throw new runtime.RequiredError('dockerWorkerConfigOmniVXCreateRequest', 'Required parameter requestParameters.dockerWorkerConfigOmniVXCreateRequest was null or undefined when calling createDockerWorkerConfigVX.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/vX`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerWorkerConfigOmniVXCreateRequestToJSON(requestParameters.dockerWorkerConfigOmniVXCreateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Creates a docker worker configuration for any version. Can either be V2, V3, V4, V5 etc.
     * Create worker configuration
     */
    async createDockerWorkerConfigVX(requestParameters: CreateDockerWorkerConfigVXRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.createDockerWorkerConfigVXRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Deletes a worker registry entry by id.
     * Delete registered worker
     */
    async deleteDockerWorkerRegistryEntryByIdRaw(requestParameters: DeleteDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId', 'Required parameter requestParameters.workerId was null or undefined when calling deleteDockerWorkerRegistryEntryById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/{workerId}`.replace(`{${"workerId"}}`, encodeURIComponent(String(requestParameters.workerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Deletes a worker registry entry by id.
     * Delete registered worker
     */
    async deleteDockerWorkerRegistryEntryById(requestParameters: DeleteDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDockerWorkerRegistryEntryByIdRaw(requestParameters, initOverrides);
    }
    /**
     * Return a free default worker or register a new worker if no default worker exists.
     * Get or register default worker
     */
    async getDefaultOrRegisterWorkerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerRegistryEntryData>> {
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/default`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerWorkerRegistryEntryDataFromJSON(jsonValue));
    }
    /**
     * Return a free default worker or register a new worker if no default worker exists.
     * Get or register default worker
     */
    async getDefaultOrRegisterWorker(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerRegistryEntryData> {
        const response = await this.getDefaultOrRegisterWorkerRaw(initOverrides);
        return await response.value();
    }
    /**
     * Requests license information to run the container.
     * Get license information
     */
    async getDockerLicenseInformationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerLicenseInformation>> {
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/licenseInformation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerLicenseInformationFromJSON(jsonValue));
    }
    /**
     * Requests license information to run the container.
     * Get license information
     */
    async getDockerLicenseInformation(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerLicenseInformation> {
        const response = await this.getDockerLicenseInformationRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get the url of a specific docker runs artifact
     * Get run artifact read URL
     */
    async getDockerRunArtifactReadUrlByIdRaw(requestParameters: GetDockerRunArtifactReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getDockerRunArtifactReadUrlById.');
        }
        if (requestParameters.artifactId === null || requestParameters.artifactId === undefined) {
            throw new runtime.RequiredError('artifactId', 'Required parameter requestParameters.artifactId was null or undefined when calling getDockerRunArtifactReadUrlById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/artifacts/{artifactId}/readurl`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))).replace(`{${"artifactId"}}`, encodeURIComponent(String(requestParameters.artifactId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Get the url of a specific docker runs artifact
     * Get run artifact read URL
     */
    async getDockerRunArtifactReadUrlById(requestParameters: GetDockerRunArtifactReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDockerRunArtifactReadUrlByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets a docker run by docker run id.
     * Get run by id
     */
    async getDockerRunByIdRaw(requestParameters: GetDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunData>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getDockerRunById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerRunDataFromJSON(jsonValue));
    }
    /**
     * Gets a docker run by docker run id.
     * Get run by id
     */
    async getDockerRunById(requestParameters: GetDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunData> {
        const response = await this.getDockerRunByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieves the associated docker run of a scheduled run; returns the docker run by the id of the scheduled run which caused this docker run. If a scheduled docker run has not yet started being processed by a worker, a 404 will be returned.
     * Get run by scheduled id
     */
    async getDockerRunByScheduledIdRaw(requestParameters: GetDockerRunByScheduledIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunData>> {
        if (requestParameters.scheduledId === null || requestParameters.scheduledId === undefined) {
            throw new runtime.RequiredError('scheduledId', 'Required parameter requestParameters.scheduledId was null or undefined when calling getDockerRunByScheduledId.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/schedule/{scheduledId}`.replace(`{${"scheduledId"}}`, encodeURIComponent(String(requestParameters.scheduledId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerRunDataFromJSON(jsonValue));
    }
    /**
     * Retrieves the associated docker run of a scheduled run; returns the docker run by the id of the scheduled run which caused this docker run. If a scheduled docker run has not yet started being processed by a worker, a 404 will be returned.
     * Get run by scheduled id
     */
    async getDockerRunByScheduledId(requestParameters: GetDockerRunByScheduledIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunData> {
        const response = await this.getDockerRunByScheduledIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets the logs of a docker run by docker run id.
     * Get run logs
     */
    async getDockerRunLogsByIdRaw(requestParameters: GetDockerRunLogsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerRunLogData>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getDockerRunLogsById.');
        }
        const queryParameters: any = {};
        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/logs`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerRunLogDataFromJSON(jsonValue));
    }
    /**
     * Gets the logs of a docker run by docker run id.
     * Get run logs
     */
    async getDockerRunLogsById(requestParameters: GetDockerRunLogsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerRunLogData> {
        const response = await this.getDockerRunLogsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * DEPRECATED, use getDockerRunArtifactReadUrlById - Get the url of a specific docker runs report
     * Get run report read URL
     */
    async getDockerRunReportReadUrlByIdRaw(requestParameters: GetDockerRunReportReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getDockerRunReportReadUrlById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/readReportUrl`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * DEPRECATED, use getDockerRunArtifactReadUrlById - Get the url of a specific docker runs report
     * Get run report read URL
     */
    async getDockerRunReportReadUrlById(requestParameters: GetDockerRunReportReadUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDockerRunReportReadUrlByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * DEPRECATED, use createDockerRunArtifact - Get the signed url to upload a report of a docker run
     * Get run report write URL
     */
    async getDockerRunReportWriteUrlByIdRaw(requestParameters: GetDockerRunReportWriteUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getDockerRunReportWriteUrlById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/writeReportUrl`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * DEPRECATED, use createDockerRunArtifact - Get the signed url to upload a report of a docker run
     * Get run report write URL
     */
    async getDockerRunReportWriteUrlById(requestParameters: GetDockerRunReportWriteUrlByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDockerRunReportWriteUrlByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets all tags which were created from a docker run by docker run id.
     * Get run tags
     */
    async getDockerRunTagsRaw(requestParameters: GetDockerRunTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TagData>>> {
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling getDockerRunTags.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}/tags`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TagDataFromJSON));
    }
    /**
     * Gets all tags which were created from a docker run by docker run id.
     * Get run tags
     */
    async getDockerRunTags(requestParameters: GetDockerRunTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TagData>> {
        const response = await this.getDockerRunTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets all docker runs for a user.
     * Get Docker runs
     */
    async getDockerRunsRaw(requestParameters: GetDockerRunsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunData>>> {
        const queryParameters: any = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }
        if (requestParameters.pageOffset !== undefined) {
            queryParameters['pageOffset'] = requestParameters.pageOffset;
        }
        if (requestParameters.getAssetsOfTeam !== undefined) {
            queryParameters['getAssetsOfTeam'] = requestParameters.getAssetsOfTeam;
        }
        if (requestParameters.getAssetsOfTeamInclusiveSelf !== undefined) {
            queryParameters['getAssetsOfTeamInclusiveSelf'] = requestParameters.getAssetsOfTeamInclusiveSelf;
        }
        if (requestParameters.showArchived !== undefined) {
            queryParameters['showArchived'] = requestParameters.showArchived;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerRunDataFromJSON));
    }
    /**
     * Gets all docker runs for a user.
     * Get Docker runs
     */
    async getDockerRuns(requestParameters: GetDockerRunsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunData>> {
        const response = await this.getDockerRunsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets the total count of the amount of runs existing for a user
     * Get runs count
     */
    async getDockerRunsCountRaw(requestParameters: GetDockerRunsCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};
        if (requestParameters.getAssetsOfTeam !== undefined) {
            queryParameters['getAssetsOfTeam'] = requestParameters.getAssetsOfTeam;
        }
        if (requestParameters.getAssetsOfTeamInclusiveSelf !== undefined) {
            queryParameters['getAssetsOfTeamInclusiveSelf'] = requestParameters.getAssetsOfTeamInclusiveSelf;
        }
        if (requestParameters.showArchived !== undefined) {
            queryParameters['showArchived'] = requestParameters.showArchived;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Gets the total count of the amount of runs existing for a user
     * Get runs count
     */
    async getDockerRunsCount(requestParameters: GetDockerRunsCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDockerRunsCountRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all docker runs of a user by dataset id
     * Get runs by dataset id
     */
    async getDockerRunsQueryByDatasetIdRaw(requestParameters: GetDockerRunsQueryByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunData>>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDockerRunsQueryByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }
        if (requestParameters.pageOffset !== undefined) {
            queryParameters['pageOffset'] = requestParameters.pageOffset;
        }
        if (requestParameters.getAssetsOfTeam !== undefined) {
            queryParameters['getAssetsOfTeam'] = requestParameters.getAssetsOfTeam;
        }
        if (requestParameters.getAssetsOfTeamInclusiveSelf !== undefined) {
            queryParameters['getAssetsOfTeamInclusiveSelf'] = requestParameters.getAssetsOfTeamInclusiveSelf;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/query/datasetId/{datasetId}`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerRunDataFromJSON));
    }
    /**
     * Get all docker runs of a user by dataset id
     * Get runs by dataset id
     */
    async getDockerRunsQueryByDatasetId(requestParameters: GetDockerRunsQueryByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunData>> {
        const response = await this.getDockerRunsQueryByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all scheduled docker runs by dataset id. If no state(s) is specified, returns runs which have not yet finished (neither DONE or CANCELED).
     * Get scheduled runs by dataset id
     */
    async getDockerRunsScheduledByDatasetIdRaw(requestParameters: GetDockerRunsScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunScheduledData>>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDockerRunsScheduledByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }
        if (requestParameters.states) {
            queryParameters['states'] = requestParameters.states;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/docker/worker/schedule`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerRunScheduledDataFromJSON));
    }
    /**
     * Get all scheduled docker runs by dataset id. If no state(s) is specified, returns runs which have not yet finished (neither DONE or CANCELED).
     * Get scheduled runs by dataset id
     */
    async getDockerRunsScheduledByDatasetId(requestParameters: GetDockerRunsScheduledByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunScheduledData>> {
        const response = await this.getDockerRunsScheduledByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all scheduled docker runs of the user. Additionally, you can filter by state.  Furthermore, you can filter by only providing labels and only return scheduled runs whose runsOn labels are included in the provided labels. Runs are filtered by the provided version parameter. Version parameter set to * returns all configs
     * Get scheduled runs
     */
    async getDockerRunsScheduledByStateAndLabelsRaw(requestParameters: GetDockerRunsScheduledByStateAndLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunScheduledData>>> {
        const queryParameters: any = {};
        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }
        if (requestParameters.labels) {
            queryParameters['labels'] = requestParameters.labels;
        }
        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }
        if (requestParameters.includeUnlockableRuns !== undefined) {
            queryParameters['includeUnlockableRuns'] = requestParameters.includeUnlockableRuns;
        }
        if (requestParameters.getAssetsOfTeam !== undefined) {
            queryParameters['getAssetsOfTeam'] = requestParameters.getAssetsOfTeam;
        }
        if (requestParameters.getAssetsOfTeamInclusiveSelf !== undefined) {
            queryParameters['getAssetsOfTeamInclusiveSelf'] = requestParameters.getAssetsOfTeamInclusiveSelf;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/schedule`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerRunScheduledDataFromJSON));
    }
    /**
     * Get all scheduled docker runs of the user. Additionally, you can filter by state.  Furthermore, you can filter by only providing labels and only return scheduled runs whose runsOn labels are included in the provided labels. Runs are filtered by the provided version parameter. Version parameter set to * returns all configs
     * Get scheduled runs
     */
    async getDockerRunsScheduledByStateAndLabels(requestParameters: GetDockerRunsScheduledByStateAndLabelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunScheduledData>> {
        const response = await this.getDockerRunsScheduledByStateAndLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all scheduled runs that might be picked up by the worker with that workerId.
     * Get a workers scheduled runs
     */
    async getDockerRunsScheduledByWorkerIdRaw(requestParameters: GetDockerRunsScheduledByWorkerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerRunScheduledData>>> {
        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId', 'Required parameter requestParameters.workerId was null or undefined when calling getDockerRunsScheduledByWorkerId.');
        }
        const queryParameters: any = {};
        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }
        if (requestParameters.getAssetsOfTeam !== undefined) {
            queryParameters['getAssetsOfTeam'] = requestParameters.getAssetsOfTeam;
        }
        if (requestParameters.getAssetsOfTeamInclusiveSelf !== undefined) {
            queryParameters['getAssetsOfTeamInclusiveSelf'] = requestParameters.getAssetsOfTeamInclusiveSelf;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/{workerId}/schedule`.replace(`{${"workerId"}}`, encodeURIComponent(String(requestParameters.workerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerRunScheduledDataFromJSON));
    }
    /**
     * Get all scheduled runs that might be picked up by the worker with that workerId.
     * Get a workers scheduled runs
     */
    async getDockerRunsScheduledByWorkerId(requestParameters: GetDockerRunsScheduledByWorkerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerRunScheduledData>> {
        const response = await this.getDockerRunsScheduledByWorkerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets a docker worker configuration by id. It will try to return the config version but expects (and will fail if not) the config to be of v0
     * Get worker configuration
     */
    async getDockerWorkerConfigByIdRaw(requestParameters: GetDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigV0Data>> {
        if (requestParameters.configId === null || requestParameters.configId === undefined) {
            throw new runtime.RequiredError('configId', 'Required parameter requestParameters.configId was null or undefined when calling getDockerWorkerConfigById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/{configId}`.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerWorkerConfigV0DataFromJSON(jsonValue));
    }
    /**
     * Gets a docker worker configuration by id. It will try to return the config version but expects (and will fail if not) the config to be of v0
     * Get worker configuration
     */
    async getDockerWorkerConfigById(requestParameters: GetDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigV0Data> {
        const response = await this.getDockerWorkerConfigByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets a docker worker configuration by id which needs to be v2
     * Get worker v2 configuration
     */
    async getDockerWorkerConfigV2ByIdRaw(requestParameters: GetDockerWorkerConfigV2ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigV2Data>> {
        if (requestParameters.configId === null || requestParameters.configId === undefined) {
            throw new runtime.RequiredError('configId', 'Required parameter requestParameters.configId was null or undefined when calling getDockerWorkerConfigV2ById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/v2/{configId}`.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerWorkerConfigV2DataFromJSON(jsonValue));
    }
    /**
     * Gets a docker worker configuration by id which needs to be v2
     * Get worker v2 configuration
     */
    async getDockerWorkerConfigV2ById(requestParameters: GetDockerWorkerConfigV2ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigV2Data> {
        const response = await this.getDockerWorkerConfigV2ByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets a docker worker configuration by id which needs to be v3
     * Get worker v3 configuration
     */
    async getDockerWorkerConfigV3ByIdRaw(requestParameters: GetDockerWorkerConfigV3ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigV3Data>> {
        if (requestParameters.configId === null || requestParameters.configId === undefined) {
            throw new runtime.RequiredError('configId', 'Required parameter requestParameters.configId was null or undefined when calling getDockerWorkerConfigV3ById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/v3/{configId}`.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerWorkerConfigV3DataFromJSON(jsonValue));
    }
    /**
     * Gets a docker worker configuration by id which needs to be v3
     * Get worker v3 configuration
     */
    async getDockerWorkerConfigV3ById(requestParameters: GetDockerWorkerConfigV3ByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigV3Data> {
        const response = await this.getDockerWorkerConfigV3ByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Gets a docker worker configuration by id. It will return whichever config version the configId corresponds to.
     * Get worker configuration
     */
    async getDockerWorkerConfigVXByIdRaw(requestParameters: GetDockerWorkerConfigVXByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerConfigVXData>> {
        if (requestParameters.configId === null || requestParameters.configId === undefined) {
            throw new runtime.RequiredError('configId', 'Required parameter requestParameters.configId was null or undefined when calling getDockerWorkerConfigVXById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/vX/{configId}`.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerWorkerConfigVXDataFromJSON(jsonValue));
    }
    /**
     * Gets a docker worker configuration by id. It will return whichever config version the configId corresponds to.
     * Get worker configuration
     */
    async getDockerWorkerConfigVXById(requestParameters: GetDockerWorkerConfigVXByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerConfigVXData> {
        const response = await this.getDockerWorkerConfigVXByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get docker worker configurations.
     * Get worker configurations
     */
    async getDockerWorkerConfigsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerWorkerConfigV0Data>>> {
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerWorkerConfigV0DataFromJSON));
    }
    /**
     * Get docker worker configurations.
     * Get worker configurations
     */
    async getDockerWorkerConfigs(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerWorkerConfigV0Data>> {
        const response = await this.getDockerWorkerConfigsRaw(initOverrides);
        return await response.value();
    }
    /**
     * Returns all worker registry entries for a given user.
     * Get registered workers
     */
    async getDockerWorkerRegistryEntriesRaw(requestParameters: GetDockerWorkerRegistryEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DockerWorkerRegistryEntryData>>> {
        const queryParameters: any = {};
        if (requestParameters.getAssetsOfTeam !== undefined) {
            queryParameters['getAssetsOfTeam'] = requestParameters.getAssetsOfTeam;
        }
        if (requestParameters.getAssetsOfTeamInclusiveSelf !== undefined) {
            queryParameters['getAssetsOfTeamInclusiveSelf'] = requestParameters.getAssetsOfTeamInclusiveSelf;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DockerWorkerRegistryEntryDataFromJSON));
    }
    /**
     * Returns all worker registry entries for a given user.
     * Get registered workers
     */
    async getDockerWorkerRegistryEntries(requestParameters: GetDockerWorkerRegistryEntriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DockerWorkerRegistryEntryData>> {
        const response = await this.getDockerWorkerRegistryEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Returns worker registry entry by id.
     * Get registered worker
     */
    async getDockerWorkerRegistryEntryByIdRaw(requestParameters: GetDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerWorkerRegistryEntryData>> {
        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId', 'Required parameter requestParameters.workerId was null or undefined when calling getDockerWorkerRegistryEntryById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/{workerId}`.replace(`{${"workerId"}}`, encodeURIComponent(String(requestParameters.workerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerWorkerRegistryEntryDataFromJSON(jsonValue));
    }
    /**
     * Returns worker registry entry by id.
     * Get registered worker
     */
    async getDockerWorkerRegistryEntryById(requestParameters: GetDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerWorkerRegistryEntryData> {
        const response = await this.getDockerWorkerRegistryEntryByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Deprecated, use postDockerWorkerAuthorizationRequest. Performs an authorization to run the container.
     * Authorize Docker container
     */
    async postDockerAuthorizationRequestRaw(requestParameters: PostDockerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DockerAuthorizationResponse>> {
        if (requestParameters.dockerAuthorizationRequest === null || requestParameters.dockerAuthorizationRequest === undefined) {
            throw new runtime.RequiredError('dockerAuthorizationRequest', 'Required parameter requestParameters.dockerAuthorizationRequest was null or undefined when calling postDockerAuthorizationRequest.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/authorization`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerAuthorizationRequestToJSON(requestParameters.dockerAuthorizationRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DockerAuthorizationResponseFromJSON(jsonValue));
    }
    /**
     * Deprecated, use postDockerWorkerAuthorizationRequest. Performs an authorization to run the container.
     * Authorize Docker container
     */
    async postDockerAuthorizationRequest(requestParameters: PostDockerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DockerAuthorizationResponse> {
        const response = await this.postDockerAuthorizationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Adds a diagnostic entry of user stats.
     * Create docker usage stats
     */
    async postDockerUsageStatsRaw(requestParameters: PostDockerUsageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dockerUserStats === null || requestParameters.dockerUserStats === undefined) {
            throw new runtime.RequiredError('dockerUserStats', 'Required parameter requestParameters.dockerUserStats was null or undefined when calling postDockerUsageStats.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerUserStatsToJSON(requestParameters.dockerUserStats),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Adds a diagnostic entry of user stats.
     * Create docker usage stats
     */
    async postDockerUsageStats(requestParameters: PostDockerUsageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postDockerUsageStatsRaw(requestParameters, initOverrides);
    }
    /**
     * Performs an authorization to run the Lightly Worker.
     * Authorize Lightly Worker
     */
    async postDockerWorkerAuthorizationRequestRaw(requestParameters: PostDockerWorkerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.dockerWorkerAuthorizationRequest === null || requestParameters.dockerWorkerAuthorizationRequest === undefined) {
            throw new runtime.RequiredError('dockerWorkerAuthorizationRequest', 'Required parameter requestParameters.dockerWorkerAuthorizationRequest was null or undefined when calling postDockerWorkerAuthorizationRequest.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/workerAuthorization`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DockerWorkerAuthorizationRequestToJSON(requestParameters.dockerWorkerAuthorizationRequest),
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Performs an authorization to run the Lightly Worker.
     * Authorize Lightly Worker
     */
    async postDockerWorkerAuthorizationRequest(requestParameters: PostDockerWorkerAuthorizationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.postDockerWorkerAuthorizationRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Registers a worker for a user. If a worker with the same name is passed that already exists, the same workerId will be returned
     * Register worker
     */
    async registerDockerWorkerRaw(requestParameters: RegisterDockerWorkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEntityResponse>> {
        if (requestParameters.createDockerWorkerRegistryEntryRequest === null || requestParameters.createDockerWorkerRegistryEntryRequest === undefined) {
            throw new runtime.RequiredError('createDockerWorkerRegistryEntryRequest', 'Required parameter requestParameters.createDockerWorkerRegistryEntryRequest was null or undefined when calling registerDockerWorker.');
        }
        const queryParameters: any = {};
        if (requestParameters.forUserId !== undefined) {
            queryParameters['forUserId'] = requestParameters.forUserId;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDockerWorkerRegistryEntryRequestToJSON(requestParameters.createDockerWorkerRegistryEntryRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEntityResponseFromJSON(jsonValue));
    }
    /**
     * Registers a worker for a user. If a worker with the same name is passed that already exists, the same workerId will be returned
     * Register worker
     */
    async registerDockerWorker(requestParameters: RegisterDockerWorkerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEntityResponse> {
        const response = await this.registerDockerWorkerRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Updates a docker run database entry.
     * Update run by id
     */
    async updateDockerRunByIdRaw(requestParameters: UpdateDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dockerRunUpdateRequest === null || requestParameters.dockerRunUpdateRequest === undefined) {
            throw new runtime.RequiredError('dockerRunUpdateRequest', 'Required parameter requestParameters.dockerRunUpdateRequest was null or undefined when calling updateDockerRunById.');
        }
        if (requestParameters.runId === null || requestParameters.runId === undefined) {
            throw new runtime.RequiredError('runId', 'Required parameter requestParameters.runId was null or undefined when calling updateDockerRunById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/runs/{runId}`.replace(`{${"runId"}}`, encodeURIComponent(String(requestParameters.runId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DockerRunUpdateRequestToJSON(requestParameters.dockerRunUpdateRequest),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Updates a docker run database entry.
     * Update run by id
     */
    async updateDockerRunById(requestParameters: UpdateDockerRunByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDockerRunByIdRaw(requestParameters, initOverrides);
    }
    /**
     * DEPRECATED, DONT USE. Updates a docker worker configuration by id.
     * Update worker configuration
     */
    async updateDockerWorkerConfigByIdRaw(requestParameters: UpdateDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dockerWorkerConfigCreateRequest === null || requestParameters.dockerWorkerConfigCreateRequest === undefined) {
            throw new runtime.RequiredError('dockerWorkerConfigCreateRequest', 'Required parameter requestParameters.dockerWorkerConfigCreateRequest was null or undefined when calling updateDockerWorkerConfigById.');
        }
        if (requestParameters.configId === null || requestParameters.configId === undefined) {
            throw new runtime.RequiredError('configId', 'Required parameter requestParameters.configId was null or undefined when calling updateDockerWorkerConfigById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/config/{configId}`.replace(`{${"configId"}}`, encodeURIComponent(String(requestParameters.configId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DockerWorkerConfigCreateRequestToJSON(requestParameters.dockerWorkerConfigCreateRequest),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * DEPRECATED, DONT USE. Updates a docker worker configuration by id.
     * Update worker configuration
     */
    async updateDockerWorkerConfigById(requestParameters: UpdateDockerWorkerConfigByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDockerWorkerConfigByIdRaw(requestParameters, initOverrides);
    }
    /**
     * Updates the worker status by id.
     * Update worker status
     */
    async updateDockerWorkerRegistryEntryByIdRaw(requestParameters: UpdateDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateDockerWorkerRegistryEntryRequest === null || requestParameters.updateDockerWorkerRegistryEntryRequest === undefined) {
            throw new runtime.RequiredError('updateDockerWorkerRegistryEntryRequest', 'Required parameter requestParameters.updateDockerWorkerRegistryEntryRequest was null or undefined when calling updateDockerWorkerRegistryEntryById.');
        }
        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId', 'Required parameter requestParameters.workerId was null or undefined when calling updateDockerWorkerRegistryEntryById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/docker/worker/{workerId}`.replace(`{${"workerId"}}`, encodeURIComponent(String(requestParameters.workerId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDockerWorkerRegistryEntryRequestToJSON(requestParameters.updateDockerWorkerRegistryEntryRequest),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Updates the worker status by id.
     * Update worker status
     */
    async updateDockerWorkerRegistryEntryById(requestParameters: UpdateDockerWorkerRegistryEntryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDockerWorkerRegistryEntryByIdRaw(requestParameters, initOverrides);
    }
    /**
     * Update the state of a scheduled run. This will fail if the state of the scheduled run is LOCKED.
     * Update scheduled run state
     */
    async updateScheduledDockerRunStateByIdRaw(requestParameters: UpdateScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dockerRunScheduledUpdateRequest === null || requestParameters.dockerRunScheduledUpdateRequest === undefined) {
            throw new runtime.RequiredError('dockerRunScheduledUpdateRequest', 'Required parameter requestParameters.dockerRunScheduledUpdateRequest was null or undefined when calling updateScheduledDockerRunStateById.');
        }
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling updateScheduledDockerRunStateById.');
        }
        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId', 'Required parameter requestParameters.workerId was null or undefined when calling updateScheduledDockerRunStateById.');
        }
        if (requestParameters.scheduledId === null || requestParameters.scheduledId === undefined) {
            throw new runtime.RequiredError('scheduledId', 'Required parameter requestParameters.scheduledId was null or undefined when calling updateScheduledDockerRunStateById.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/docker/worker/{workerId}/schedule/{scheduledId}`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))).replace(`{${"workerId"}}`, encodeURIComponent(String(requestParameters.workerId))).replace(`{${"scheduledId"}}`, encodeURIComponent(String(requestParameters.scheduledId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DockerRunScheduledUpdateRequestToJSON(requestParameters.dockerRunScheduledUpdateRequest),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update the state of a scheduled run. This will fail if the state of the scheduled run is LOCKED.
     * Update scheduled run state
     */
    async updateScheduledDockerRunStateById(requestParameters: UpdateScheduledDockerRunStateByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateScheduledDockerRunStateByIdRaw(requestParameters, initOverrides);
    }
}
